import React, { useState, useEffect, useRef, useContext, useCallback, useMemo } from 'react'
import { useNavigate, Link, useParams, useSearchParams } from 'react-router-dom'
import { ChevronDown, ChevronUp, Check, X } from 'lucide-react'
import Colors from '../../Collections/RegisterCollection/collapse/Colors'
import Measures, { MeasuresHandle } from '../../Collections/RegisterCollection/collapse/Measures'
import BaseMaterials from '../../Collections/RegisterCollection/collapse/BaseMaterials'
import Beneficiamento, {
  BeneficiamentoNota,
  Sector as BeneficiamentoSector,
  newBeneficiamentoNota,
} from '../../Collections/RegisterCollection/collapse/Beneficiamento'
import PreCost from '../../Collections/RegisterCollection/collapse/PreCost'
import Aprovations from '../../Collections/RegisterCollection/collapse/Aprovations'
import axios from '../../../../config/axios'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import InfiniteSelect from '../../../../components/InfiniteSelect'
import { NcmCatalogoOption, ncmCatalogoEndpoint, ncmDaOpcao, ncmSelecionado } from '../../../../utils/ncmCatalogo'
import { PantoneSwatch } from '../../../../components/InfiniteSelect/style'
import PantoneSelect, { PantoneValue } from '../../../../components/PantoneSelect'
import ModalTest from '../../../../components/BaseModal'
import {
  ContainerOfModal,
  Header as ModalHeader,
  HeaderTitle as ModalHeaderTitle,
  CloseDiv as ModalCloseDiv,
  InputDiv as ModalInputDiv,
  Label as ModalLabel,
  Input as ModalInput,
  ButtonContainer as ModalButtonContainer,
  Button as ModalButton,
} from '../../../../components/styles/modal-style'
import { ExistingAttachment } from '../../../../components/AttachmentManager'
import GeneratePDFModal from '../../../../components/Modals/FashionProduct/GeneratePDFModal'
import ApiService from '../../../../services/ApiService'
import AttachmentApiService from '../../../../services/AttachmentApiService'
import openSignedAttachment from '../../../../utils/openSignedAttachment'
import ConfirmationModal from '../../../../components/ModalConfirmation'
import { getTagTextColor } from '../../../../utils/colorContrast'
import OrdenoLoading from '../../../../components/OrdenoLoading'
import ProductAttachmentsAside, {
  isAllowedDocumentUpload,
  isProductImageFile,
} from './AttachmentsAside'
import {
  SubHeaderContainer,
  SectionName,
  LeftSide,
} from '../../../../components/styles/subheader-style'
import {
  MainContainer,
  StyledCard,
  FormGrid,
  StyledFormGroup,
  LeftColumnGroup,
  ObservationsFormGroup,
  TagSelectContainer,
  TagChipsContainer,
  TagChip,
  TagPlaceholder,
  TagDropdownMenu,
  TagSearchInput,
  TagOptionsList,
  TagOptionItem,
  TagEmptyState,
  ActionButtons,
  CancelButton,
  SaveButton,
  BreadcrumbsContainer,
  CardTitle,
  GraduationGrid,
  GraduationButton,
  CompositionTableWrapper,
  CompositionTable,
  CompositionTableHeader,
  CompositionTableHeaderCell,
  CompositionTableRow,
  TableCell,
  TableSelect,
  TableInput,
  DeleteButton,
  AddItemButton,
  ImportButton,
  TagsContainer,
  Tag,
  RemoveTagButton,
  SelectContainer,
  PageGrid,
  FormColumn,
  AsideColumn,
  MaterialCellContainer,
  ItemTypeBadge,
} from './style'
import { CollapsePanelHeader } from '../../Collections/RegisterCollection/style'
import ResizableCompositionHeaderCell from './ResizableCompositionHeaderCell'
import {
  colorColumnKey,
  getColumnCssVar,
  useCompositionColumnResize,
} from './useCompositionColumnResize'
import CurrencyInput from '../../../../components/CurrencyInput'
import { downloadRemoteFile } from '../../../../utils/downloadRemoteFile'
import trash from '../../../../assets/equipment/Tables/trash.svg'
import * as CollectionStyles from '../../Collections/RegisterCollection/style'
import plus from '../../../../assets/certificates/AddParameter/blue-plus.svg'
import save from '../../../../assets/certificates/AddParameter/save.svg'
import cross from '../../../../assets/addStockModal/cross.svg'

const GATEWAY_URL = process.env.REACT_APP_GATEWAY_BASE_URL
const FASHION_API_URL = `${GATEWAY_URL}/backend-fashion-orders/fashion-product`

interface Collection {
  id: number
  name: string
}

interface CollectionEpisodeOption {
  id: number
  name: string
}

interface Family {
  id: number
  name: string
  collectionId: number
}

interface Group {
  id: number
  name: string
}



interface GradeType {
  id: number
  name: string
}

interface Grade {
  id: number
  name: string
  typeId: number
  type: GradeType
  GraduationType?: GradeType
}

interface Stock {
  id: number
  description: string
  costPerKg?: number
  costPerMm?: number
}

interface ResourceCategory {
  id: number
  name: string
}

interface Resource {
  id: number
  name: string
  description: string
  categoryId: number
  materialId?: number | null
  prices?: ResourcePrice[]
}

interface ResourcePrice {
  id: number
  price: number
  unitOfMeasurement?: {
    id: number
    name: string
    abbreviation: string
  }
}

interface StageService {
  id: number
  name: string
  category?: { id: number; name: string } | null
  type?: { id: number; name: string } | null
  code?: string
  deadlineInDays?: number
}

interface MaterialVariation {
  id: number
  colorId: number | null
  stockId: number | null
  resourceId: number | null
  color: { id: number; name: string } | null
  stock: Stock | null
  resource: Resource | null
}

interface ColorVariationMapping {
  mainVariationId: number
  mainColorName: string
  itemVariationId: number | null
}

function scriptCostPerUnitToInput(value: unknown): string {
  if (value === undefined || value === null) return ''
  const s = String(value).trim()
  if (!s || s === 'null' || s === 'undefined') return ''
  return s
}

/** Apenas dígitos e no máximo um separador decimal (`,` ou `.`). */
function sanitizeCompositionDecimalInput(raw: string): string {
  if (!raw) return ''
  const normalized = raw.replace(/,/g, '.')
  let result = ''
  let hasDot = false
  for (const ch of normalized) {
    if (ch >= '0' && ch <= '9') {
      result += ch
    } else if (ch === '.' && !hasDot) {
      hasDot = true
      result += '.'
    }
  }
  return result
}

const getStockFinishing = (stock: any): string =>
  String(stock?.Finishing?.type ?? stock?.finishing ?? '').trim()

interface CompositionItem {
  id: number
  tipo: 'materia-prima' | 'insumo' | 'servico' | ''
  materialId?: number | null
  stockId: number | null
  resourceId: number | null
  stageId?: number | null
  categoryId: number | null
  descricao: string
  unidadeMedida: string
  unitOfMeasurementId?: number | null
  localEstoque: string
  skinSize?: string | number | null
  consumo: string
  costPerUnit?: string
  finishing?: string | null
  availableVariations: MaterialVariation[]
  autoCreated?: boolean
  sizeRange?: number[]
  productItemColors?: Array<{
    id?: number
    collectionColorId: number
    itemColorId?: number | null
    itemColorName?: string | null
    materialId?: number | null
    resourceId?: number | null
    stockId?: number | null
  }>
  resourceItemColorId?: number | null
  resourceItemColorName?: string | null
  attachments?: string[]
  serviceFiles?: File[]
}

/** Igual ao `value` do `<TableSelect>` de insumo — usado para evitar ocupar todas as variantes do mesmo material. */
function insumoOptionValueFromItem(ci: CompositionItem): string | null {
  if (ci.tipo !== 'insumo') return null
  if (ci.resourceId) return `r:${ci.resourceId}`
  if (ci.materialId != null) return `${ci.materialId}:${ci.categoryId ?? ''}`
  return null
}

function insumoOptionValueFromGroup(g: {
  resourceId?: number | null
  materialId?: number | null
  categoryId?: number | null
}): string | null {
  if (g.resourceId != null) return `r:${g.resourceId}`
  if (g.materialId != null) return `${g.materialId}:${g.categoryId ?? ''}`
  return null
}

function sanitizeCode(rawCode: any): string {
  if (rawCode == null) return ''
  const str = String(rawCode).trim()
  if (!str) return ''
  return str.replace(/\s*-\s*/g, '-')
}

function materiaPrimaFamilyMaterialIdFromItem(
  ci: CompositionItem,
  conjuntos: Array<{ familyMaterialId: number; stockId: number | null; materialId: number; materialName?: string; stockLabel?: string | null }>,
): number | null {
  if (ci.tipo !== 'materia-prima') return null
  const match = conjuntos.find(
    (c) =>
      (ci.stockId && c.stockId === ci.stockId) ||
      (!ci.stockId && ci.materialId != null && c.materialId === ci.materialId) ||
      (ci.materialId != null && c.materialId === ci.materialId) ||
      (ci.descricao && (c.materialName === ci.descricao || c.stockLabel?.includes(ci.descricao))),
  )
  return match?.familyMaterialId ?? null
}

function servicoStageIdFromItem(ci: CompositionItem): number | null {
  if (ci.tipo !== 'servico' || ci.stageId == null) return null
  return ci.stageId
}

function getMaterialRowDisplayInfo(
  item: CompositionItem,
  familyConjuntos: FamilyConjunto[],
  allStocks: any[] = [],
): {
  badge: 'material' | 'materia-prima' | null
  badgeLabel: string
  selectValue: string
  displayLabel: string
  swatchHex?: string | null
} {
  if (item.tipo !== 'materia-prima') {
    return { badge: null, badgeLabel: '', selectValue: '', displayLabel: '', swatchHex: null }
  }

  const activeStockIds = Array.from(
    new Set(
      (item.productItemColors || [])
        .map((p) => p.stockId)
        .filter((s): s is number => typeof s === 'number' && s > 0),
    ),
  )

  const activeColorIds = Array.from(
    new Set(
      (item.productItemColors || [])
        .map((p) => p.itemColorId)
        .filter((c): c is number => typeof c === 'number' && c > 0),
    ),
  )

  const distinctStockCount = activeStockIds.length
  const distinctColorCount = activeColorIds.length

  if (distinctStockCount > 1 || distinctColorCount > 1) {
    let resolvedMatId = item.materialId ?? null
    if (!resolvedMatId && activeStockIds.length > 0) {
      const matchStock = familyConjuntos.find((c) => c.stockId && activeStockIds.includes(c.stockId))
      if (matchStock) resolvedMatId = matchStock.materialId
    }

    const matchConjunto = familyConjuntos.find((c) => resolvedMatId != null && c.materialId === resolvedMatId)
    const matName = matchConjunto?.materialName || item.descricao || (resolvedMatId ? `Material #${resolvedMatId}` : 'Material')

    return {
      badge: 'material',
      badgeLabel: 'Material',
      selectValue: resolvedMatId ? `m:${resolvedMatId}` : (item.descricao ? `d:${item.descricao}` : ''),
      displayLabel: matName,
      swatchHex: null,
    }
  }

  let singleStockId = activeStockIds.length === 1 ? activeStockIds[0] : null
  if (!singleStockId && activeColorIds.length === 1) {
    const activeColorId = activeColorIds[0]
    let resolvedMatId = item.materialId ?? null
    if (!resolvedMatId && item.stockId) {
      const s = allStocks.find((st) => Number(st.id) === Number(item.stockId))
      resolvedMatId = s?.materialId || s?.Material?.id || null
    }
    if (resolvedMatId) {
      const matchConjunto = familyConjuntos.find((c) => c.materialId === resolvedMatId && Number(c.colorId) === Number(activeColorId))
      if (matchConjunto?.stockId) {
        singleStockId = matchConjunto.stockId
      } else {
        const matchStock = allStocks.find((s) => Number(s.materialId) === Number(resolvedMatId) && Number(s.itemColorId || s.ItemColor?.id) === Number(activeColorId))
        if (matchStock?.id) {
          singleStockId = matchStock.id
        }
      }
    }
  }
  if (!singleStockId) {
    singleStockId = item.stockId ?? activeStockIds[0] ?? null
  }
  if (singleStockId) {
    const matchConjunto = familyConjuntos.find((c) => c.stockId === singleStockId)
    if (matchConjunto) {
      return {
        badge: null,
        badgeLabel: '',
        selectValue: String(matchConjunto.familyMaterialId),
        displayLabel: matchConjunto.stockLabel || matchConjunto.materialName,
        swatchHex: matchConjunto.colorHex || null,
      }
    }

    const matchStock = allStocks.find((s) => Number(s.id) === Number(singleStockId))
    if (matchStock) {
      const rawStockCode = matchStock?.Code?.code != null && String(matchStock.Code.code).trim() !== ''
        ? String(matchStock.Code.code)
        : matchStock?.code != null && String(matchStock.code).trim() !== ''
          ? String(matchStock.code)
          : matchStock?.codeId
            ? String(matchStock.codeId)
            : ''
      const stockCode = sanitizeCode(rawStockCode)
      const stockMaterialName = (matchStock?.Material?.name || matchStock?.material || '').trim()
      const colorName = (matchStock?.ItemColor?.name || matchStock?.color || '').trim()
      const parts: string[] = []
      if (stockCode) parts.push(stockCode)
      if (stockMaterialName) parts.push(stockMaterialName)
      if (colorName && colorName !== '—') parts.push(colorName)
      const label = parts.length > 0 ? parts.join(' - ') : (stockMaterialName || matchStock?.description || `Tecido #${matchStock.id}`)
      const colorHex = matchStock?.colorHex || matchStock?.ItemColor?.hex || matchStock?.ItemColor?.Pantone?.hex || matchStock?.Pantone?.hex || null

      return {
        badge: null,
        badgeLabel: '',
        selectValue: `s:${matchStock.id}`,
        displayLabel: label,
        swatchHex: colorHex,
      }
    }
  }

  const directFamilyId = materiaPrimaFamilyMaterialIdFromItem(item, familyConjuntos)
  if (directFamilyId != null) {
    const matchConjunto = familyConjuntos.find((c) => c.familyMaterialId === directFamilyId)
    return {
      badge: null,
      badgeLabel: '',
      selectValue: String(directFamilyId),
      displayLabel: matchConjunto?.stockLabel || matchConjunto?.materialName || 'Matéria-prima',
      swatchHex: matchConjunto?.colorHex || null,
    }
  }

  if (item.materialId) {
    const matchConjunto = familyConjuntos.find((c) => c.materialId === item.materialId)
    return {
      badge: null,
      badgeLabel: '',
      selectValue: matchConjunto ? String(matchConjunto.familyMaterialId) : `m:${item.materialId}`,
      displayLabel: matchConjunto?.stockLabel || matchConjunto?.materialName || item.descricao || `Material #${item.materialId}`,
      swatchHex: matchConjunto?.colorHex || null,
    }
  }

  if (item.descricao) {
    return {
      badge: null,
      badgeLabel: '',
      selectValue: `d:${item.descricao}`,
      displayLabel: item.descricao,
      swatchHex: null,
    }
  }

  return { badge: null, badgeLabel: '', selectValue: '', displayLabel: '', swatchHex: null }
}

function getInsumoRowDisplayInfo(
  item: CompositionItem,
  insumoMaterialGroups: any[],
  familyTrimInsumoOptions: FamilyTrimInsumoOption[],
  allResources: Resource[] = [],
): {
  badge: 'insumo' | 'material' | null
  badgeLabel: string
  selectValue: string
  displayLabel: string
  swatchHex?: string | null
} {
  if (item.tipo !== 'insumo') {
    return { badge: null, badgeLabel: '', selectValue: '', displayLabel: '', swatchHex: null }
  }

  const activeResourceIds = Array.from(
    new Set(
      (item.productItemColors || [])
        .map((p) => p.resourceId)
        .filter((r): r is number => typeof r === 'number' && r > 0),
    ),
  )

  const activeColorIds = Array.from(
    new Set(
      (item.productItemColors || [])
        .map((p) => p.itemColorId)
        .filter((c): c is number => typeof c === 'number' && c > 0),
    ),
  )

  const distinctResourceCount = activeResourceIds.length
  const distinctColorCount = activeColorIds.length

  if (distinctResourceCount > 1 || distinctColorCount > 1) {
    let resolvedMatId = item.materialId ?? null
    if (!resolvedMatId && item.resourceId) {
      const matchTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId === item.resourceId)
      resolvedMatId = matchTrim?.materialId ?? null
      if (!resolvedMatId) {
        const matchRes = allResources.find((r) => r.id === item.resourceId)
        resolvedMatId = matchRes?.materialId ?? (matchRes as any)?.Material?.id ?? null
      }
    }
    if (!resolvedMatId && activeResourceIds.length > 0) {
      const matchTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId && activeResourceIds.includes(tr.resourceId))
      resolvedMatId = matchTrim?.materialId ?? null
      if (!resolvedMatId) {
        const matchRes = allResources.find((r) => activeResourceIds.includes(r.id))
        resolvedMatId = matchRes?.materialId ?? (matchRes as any)?.Material?.id ?? null
      }
    }

    const matchTrim = familyTrimInsumoOptions.find((tr) => resolvedMatId != null && tr.materialId === resolvedMatId)
    const matchRes = allResources.find((r) =>
      (resolvedMatId != null && (r.materialId === resolvedMatId || (r as any).Material?.id === resolvedMatId)) ||
      (item.resourceId != null && r.id === item.resourceId) ||
      (activeResourceIds.length > 0 && activeResourceIds.includes(r.id))
    )

    const cleanMatName =
      (matchRes as any)?.Material?.name ||
      matchTrim?.materialName ||
      (matchRes as any)?.name ||
      item.descricao ||
      (resolvedMatId ? `Material #${resolvedMatId}` : 'Insumo')

    return {
      badge: 'material',
      badgeLabel: 'Material',
      selectValue: resolvedMatId ? `m:${resolvedMatId}` : (item.descricao ? `d:${item.descricao}` : `insumo:${item.id}`),
      displayLabel: cleanMatName,
      swatchHex: null,
    }
  }

  let singleResourceId = activeResourceIds.length === 1 ? activeResourceIds[0] : null
  if (!singleResourceId && activeColorIds.length === 1) {
    const activeColorId = activeColorIds[0]
    let resolvedMatId = item.materialId ?? null
    if (!resolvedMatId && item.resourceId) {
      const r = allResources.find((res) => Number(res.id) === Number(item.resourceId))
      resolvedMatId = r?.materialId || (r as any)?.Material?.id || null
    }
    if (resolvedMatId) {
      const matchTrim = familyTrimInsumoOptions.find((tr) => tr.materialId === resolvedMatId && Number(tr.colorId) === Number(activeColorId))
      if (matchTrim?.resourceId) {
        singleResourceId = matchTrim.resourceId
      } else {
        const matchRes = allResources.find((r) => Number(r.materialId) === Number(resolvedMatId) && Number((r as any).itemColorId || (r as any).ItemColor?.id) === Number(activeColorId))
        if (matchRes?.id) {
          singleResourceId = matchRes.id
        }
      }
    }
  }
  if (!singleResourceId) {
    singleResourceId = item.resourceId ?? activeResourceIds[0] ?? null
  }
  if (singleResourceId) {
    const matchTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId === singleResourceId)
    if (matchTrim) {
      return {
        badge: null,
        badgeLabel: '',
        selectValue: `r:${singleResourceId}`,
        displayLabel: matchTrim.resourceName || matchTrim.materialName,
        swatchHex: matchTrim.colorHex || null,
      }
    }
    const matchResource = allResources.find((r) => r.id === singleResourceId)
    if (matchResource) {
      return {
        badge: null,
        badgeLabel: '',
        selectValue: `r:${singleResourceId}`,
        displayLabel: item.descricao || (matchResource as any).name || `Insumo #${singleResourceId}`,
        swatchHex: (matchResource as any).ItemColor?.hex || (matchResource as any).colorHex || null,
      }
    }
  }

  const currentVal = insumoOptionValueFromItem(item)
  if (currentVal) {
    const group = insumoMaterialGroups.find((g) => insumoOptionValueFromGroup(g) === currentVal)
    if (group) {
      return {
        badge: null,
        badgeLabel: '',
        selectValue: currentVal,
        displayLabel: group.materialName,
        swatchHex: null,
      }
    }
  }

  if (item.resourceId) {
    const matchTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId === item.resourceId)
    const matchResource = allResources.find((r) => r.id === item.resourceId)
    return {
      badge: null,
      badgeLabel: '',
      selectValue: `r:${item.resourceId}`,
      displayLabel: item.descricao || matchTrim?.resourceName || (matchResource as any)?.name || `Insumo #${item.resourceId}`,
      swatchHex: matchTrim?.colorHex || (matchResource as any)?.ItemColor?.hex || (matchResource as any)?.colorHex || null,
    }
  }

  if (item.materialId) {
    const matchTrim = familyTrimInsumoOptions.find((tr) => tr.materialId === item.materialId)
    const matchRes = allResources.find((r) => r.materialId === item.materialId || (r as any).Material?.id === item.materialId)
    return {
      badge: null,
      badgeLabel: '',
      selectValue: `m:${item.materialId}`,
      displayLabel: (matchRes as any)?.Material?.name || matchTrim?.materialName || item.descricao || `Material #${item.materialId}`,
      swatchHex: null,
    }
  }

  if (item.descricao) {
    return {
      badge: null,
      badgeLabel: '',
      selectValue: `d:${item.descricao}`,
      displayLabel: item.descricao,
      swatchHex: null,
    }
  }

  return { badge: null, badgeLabel: '', selectValue: '', displayLabel: '', swatchHex: null }
}

interface ProductItemColorEntry {
  id?: number
  collectionColorId: number
  itemColorId?: number | null
  itemColorName?: string | null
  materialId?: number | null
  stockId?: number | null
  resourceId?: number | null
}

export interface ProductData {
  id?: number
  productCode: string
  name: string
  description?: string
  referenceProduct?: string
  observations?: string
  attachments?: string[]
  CoverGeneralFile?: { fileUrl: string } | null
  collectionId: number
  familyId: number
  groupId: number
  gradeInProduct?: Array<{
    id: number
    productId: number
    gradeId: number
    grade: Grade
  }>
  productItemColors?: ProductItemColorEntry[]
  composition?: {
    id: number
    fashionProductId: number
    variations: Array<{
      id: number
      compositionId: number
      stockId: number | null
      resourceId: number | null
      description: string
      stockLocation: string
      usage: string
      stock: Stock | null
      resource: Resource | null
      colorMappings: Array<{
        id: number
        fashionProductVariationId: number
        mainMaterialVariationId: number
        itemVariationId: number
        mainMaterialVariation?: MaterialVariation
        itemVariation?: MaterialVariation
      }>
    }>
  }
  compositionItems?: {
    stockId: number | null
    resourceId: number | null
    description: string
    stockLocation: string
    usage: number
    colorMappings: Array<{
      mainMaterialVariationId: number
      itemVariationId: number
    }>
  }[]

  Script?: Array<{
    id: number
    name: string
    productId: number
    ScriptMaterial?: Array<{
      id: number
      scriptId: number
      materialId: number
      stockId?: number | null
      idealMeasurements: number | null
      weight: number | null
      costPerUnit?: string | number | null
      step: number
      Material: {
        id: number
        name: string
        density: number
        tenantId: number
        Stock: Array<{
          id: number
          description: string
          costPerKg?: number
          costPerMm?: number
          StockLocation?: {
            id: number
            name: string
            tenantId: number
          }
          StockColors: Array<{
            id: number
            stockId: number
            colorId: number
            ItemColor: {
              id: number
              name: string
              tenantId: number
            }
          }>
        }>
      }
      Stock?: {
        id: number
        codeId?: number | string | null
        description?: string | null
        materialId?: number | null
        Material?: { id: number; name?: string | null } | null
      } | null
    }>
    ScriptResource?: Array<{
      id: number
      scriptId: number
      resourceId: number
      stockId?: number | null
      weight: number | null
      costPerUnit?: string | number | null
      step: number
      unitOfMeasurementId: number | null
      Resource: Resource & {
        Category_Resource?: {
          id: number
          name: string
          tenantId: number
        }
        ResourcePrice: ResourcePrice[]
      }
      Stock?: {
        id: number
        codeId?: number | string | null
        description?: string | null
        materialId?: number | null
        Material?: { id: number; name?: string | null } | null
      } | null
      UnitOfMeasurement?: {
        id: number
        name: string
        abbreviation: string
      }
    }>
    ScriptStage?: Array<any>
  }>
  Collection?: {
    id: number
    name: string
    tenantId: number
  }
  Family?: {
    id: number
    name: string
    collectionId: number
    tenantId: number
    Collection?: {
      id: number
      name: string
      tenantId: number
    }
  }
  Group?: {
    id: number
    name: string
    tenantId: number
  }
}

interface FamilyConjunto {
  familyMaterialId: number
  collectionMaterialId: number
  materialId: number
  materialName: string
  stockId: number | null
  stockLabel: string | null
  finishing?: string | null
  colorId?: number | null
  colorName?: string | null
  colorHex?: string | null
  colorPantone?: any
  linkedResourceMaterials: Array<{
    resourceId?: number | null
    resourceName?: string | null
    materialId: number
    materialName: string
    categoryId?: number | null
    categoryName?: string | null
  }>
}

interface FamilyTrimInsumoOption {
  familyMaterialId: number
  collectionMaterialId: number
  resourceId: number | null
  resourceName: string | null
  materialId: number
  materialName: string
  categoryId?: number | null
  categoryName?: string | null
  finishing?: string
  colorId?: number | null
  colorName?: string | null
  colorHex?: string | null
  colorPantone?: any
}

interface StockColor {
  id: number
  description: string
  costPerKg?: number
  costPerMm?: number
  StockColors?: Array<{
    id: number
    stockId: number
    colorId: number
    ItemColor: {
      id: number
      name: string
      tenantId: number | null
    }
  }>
}

const Breadcrumbs: React.FC<{ items: { label: string; path?: string }[] }> = ({
  items,
}) => (
  <BreadcrumbsContainer>
    <ol>
      {items.map((item, index) => (
        <li key={index}>
          {index === items.length - 1 ? (
            <span>{item.label}</span>
          ) : item.path ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            <span>{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </BreadcrumbsContainer>
)

const DownloadIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.66675 6.66669L8.00008 10L11.3334 6.66669'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 10V2'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const RegisterComposition: React.FC = () => {
  const navigate = useNavigate()
  const { productId } = useParams<{ productId?: string }>()
  const isEditMode = !!productId
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo')
  const parentIdParam = searchParams.get('parentId')
  const variationFromId = searchParams.get('variationFrom')
  const noteIdParam = searchParams.get('noteId') || searchParams.get('anotacaoId') || searchParams.get('beneficiamentoNoteId')
  const isVariationMode = !isEditMode && !!variationFromId
  const sourceProductId = productId || (isVariationMode ? variationFromId : undefined)
  const shouldHydrateFromSource = isEditMode || isVariationMode

  const { setFeedback } = useContext(FeedbackContext)

  const initializationCompletedRef = useRef(false)
  const isInitialLoadRef = useRef(true)
  const initialEditFamilyIdRef = useRef<number | null>(null)
  const originalVariationCodeRef = useRef<string>('')

  const [loading, setLoading] = useState<boolean>(false)
  const [loadingData, setLoadingData] = useState<boolean>(true)
  const [isInitializing, setIsInitializing] = useState<boolean>(false)
  const [isGeralOpen, setIsGeralOpen] = useState<boolean>(true)
  const [isComposicaoOpen, setIsComposicaoOpen] = useState<boolean>(false)
  const [isPdfModalOpen, setIsPdfModalOpen] = useState<boolean>(false)

  const [formData, setFormData] = useState({
    codigo: '',
    nomeProduto: '',
    description: '',
    referenceProduct: '',
    observations: '',
    supplierCode: '',
    clientIdentification: '',
    collectionId: 0,
    familyId: 0,
    groupId: 0,
    episodeId: 0,
    price: 0,
    ncmId: 0,
    unitOfMeasurementId: 0,
  })

  const [selectedStockColorIds, setSelectedStockColorIds] = useState<number[]>([])
  const [allCollectionColors, setAllCollectionColors] = useState<{ id: number; name: string; hex?: string; pantoneCode?: string; pantone?: any; Pantone?: any }[]>([])
  const [allItemColors, setAllItemColors] = useState<{ id: number; name: string; hex?: string; pantone?: any; Pantone?: any }[]>([])
  const [allVariations, setAllVariations] = useState<any[]>([])
  const [selectedCollectionColors, setSelectedCollectionColors] = useState<{ id: number; name: string; hex?: string; pantoneCode?: string }[]>([])
  const selectedCollectionColorsPrevLength = React.useRef<number>(0)
  const compositionColorIds = React.useMemo(
    () => selectedCollectionColors.map((col) => col.id),
    [selectedCollectionColors],
  )
  const { startResize, columnWidthsStyle } = useCompositionColumnResize(compositionColorIds)

  const getColorColumnStyle = (colorId: number): React.CSSProperties => {
    const cssVar = getColumnCssVar(colorColumnKey(colorId))
    return {
      width: `var(${cssVar})`,
      minWidth: `var(${cssVar})`,
    }
  }
  const removeCollectionColor = (id: number) => {
    markUserDirty()
    setSelectedCollectionColors(prev => prev.filter(c => Number(c.id) !== Number(id)))
  }

  const [selectedGradeType, setSelectedGradeType] = useState<number | null>(null)

  const [allCollections, setAllCollections] = useState<Collection[]>([])
  const [filteredFamilies, setFilteredFamilies] = useState<Family[]>([])

  const [allResourceCategories, setAllResourceCategories] = useState<ResourceCategory[]>([])
  const [allResources, setAllResources] = useState<Resource[]>([])
  const allResourcesRef = useRef<Resource[]>([])
  const [allStocks, setAllStocks] = useState<any[]>([])
  const allStocksRef = useRef<any[]>([])
  const [resourcesByCategory, setResourcesByCategory] = useState<Record<number, Resource[]>>({})
  const [familyConjuntos, setFamilyConjuntos] = useState<FamilyConjunto[]>([])
  const [familyTrimInsumoOptions, setFamilyTrimInsumoOptions] = useState<FamilyTrimInsumoOption[]>([])
  const [conjuntoStocks, setConjuntoStocks] = useState<StockColor[]>([])
  const [allServices, setAllServices] = useState<StageService[]>([])

  const [compositionItems, setCompositionItems] = useState<CompositionItem[]>([])

  const [createColorModalState, setCreateColorModalState] = useState<{
    isOpen: boolean;
    name: string;
    code: string;
    existingCodes: string[];
    pantone: PantoneValue | null;
    selectedColor?: { id: number | string; name: string; pantone?: any } | null;
    isChangingPantone?: boolean;
    item: any;
    col: any;
    isLoading: boolean;
    errorMessage?: string;
    resolve?: (value: { id: number; name: string; hex?: string; colorHex?: string; pantone?: any; Pantone?: any }) => void;
    reject?: (reason?: any) => void;
  } | null>(null)

  const handleOpenCreateColorModal = useCallback(async (name: string, item: any, col: any): Promise<{ id: number; name: string; hex?: string; colorHex?: string; pantone?: any; Pantone?: any }> => {
    let existingCodes: string[] = []
    try {
      const token = localStorage.getItem('token')
      const headers = token ? { Authorization: `Bearer ${token}` } : {}
      if (item.materialId) {
        const res = await axios.get(`${FASHION_API_URL}/stocks`, {
          headers,
          params: { materialId: item.materialId, limit: 100 }
        })
        const stocksList = Array.isArray(res.data) ? res.data : res.data?.content || []
        const codes: string[] = stocksList
          .map((s: any) => s.Code?.code || s.code)
          .filter((c: any): c is string => typeof c === 'string' && c.trim().length > 0)
        existingCodes = Array.from(new Set(codes))
      }
    } catch {
      const codes: string[] = familyConjuntos
        .filter(c => c.materialId === item.materialId)
        .map(c => {
          const match = c.stockLabel?.split(' - ')?.[0]
          return match
        })
        .filter((c: any): c is string => typeof c === 'string' && c.trim().length > 0)
      existingCodes = Array.from(new Set(codes))
    }

    if (existingCodes.length === 0 && item.materialId) {
      const codes: string[] = familyConjuntos
        .filter(c => c.materialId === item.materialId)
        .map(c => {
          const match = c.stockLabel?.split(' - ')?.[0]
          return match
        })
        .filter((c: any): c is string => typeof c === 'string' && c.trim().length > 0)
      existingCodes = Array.from(new Set(codes))
    }

    let initialSelectedColor: { id: number | string; name: string; pantone?: any } | null = null
    let initialPantone: PantoneValue | null = null

    if (name && name.trim()) {
      try {
        const res = await ApiService.resources.getColors()
        const found = (res.data || []).find((c: any) => c.name?.toLowerCase().trim() === name.toLowerCase().trim())
        if (found) {
          initialSelectedColor = { id: found.id, name: found.name, pantone: found.pantone ?? null }
          initialPantone = found.pantone ?? null
        } else {
          initialSelectedColor = { id: `tmp-${Date.now()}`, name: name.trim(), pantone: null }
        }
      } catch {
        initialSelectedColor = { id: `tmp-${Date.now()}`, name: name.trim(), pantone: null }
      }
    }

    return new Promise<{ id: number; name: string; hex?: string; colorHex?: string; pantone?: any; Pantone?: any }>((resolve, reject) => {
      setCreateColorModalState({
        isOpen: true,
        name: initialSelectedColor?.name || name || '',
        code: '',
        existingCodes,
        pantone: initialPantone,
        selectedColor: initialSelectedColor,
        isChangingPantone: false,
        item,
        col,
        isLoading: false,
        resolve,
        reject,
      })
    })
  }, [familyConjuntos])

  const handleConfirmCreateColorModal = async () => {
    if (!createColorModalState) return
    const colorName = (createColorModalState.selectedColor?.name || createColorModalState.name || '').trim()
    if (!colorName) {
      setCreateColorModalState(prev => prev ? { ...prev, errorMessage: 'Cor é obrigatória' } : null)
      return
    }

    const colorCode = createColorModalState.code.trim()
    if (!colorCode) {
      setCreateColorModalState(prev => prev ? { ...prev, errorMessage: 'Código é obrigatório' } : null)
      return
    }

    if (createColorModalState.existingCodes.some(ec => ec.trim().toUpperCase() === colorCode.toUpperCase())) {
      setCreateColorModalState(prev => prev ? { ...prev, errorMessage: 'Este código já está cadastrado para este material.' } : null)
      return
    }

    setCreateColorModalState(prev => prev ? { ...prev, isLoading: true, errorMessage: undefined } : null)

    try {
      const token = localStorage.getItem('token')
      const headers = token ? { Authorization: `Bearer ${token}` } : {}
      const currentCollectionId = formData.collectionId ? Number(formData.collectionId) : (productData as any)?.collectionId ? Number((productData as any).collectionId) : undefined

      const selected = createColorModalState.selectedColor
      const chosenPantone = selected?.pantone || createColorModalState.pantone

      const createRes = await axios.post(
        `${FASHION_API_URL}/colors`,
        {
          name: colorName,
          ...(chosenPantone?.code ? {
            pantone: {
              code: chosenPantone.code,
              name: chosenPantone.name,
            },
          } : {}),
        },
        { headers }
      )
      const newColor = createRes.data
      let newStockId: number | undefined
      let newResourceId: number | undefined

      const { item, col } = createColorModalState
      const isMaterial = item.tipo === 'materia-prima' || item.type === 'FABRIC' || (!item.type && !item.tipo && !!item.materialId && !item.resourceId)

      if (isMaterial && (item.materialId || item.stockId)) {
        try {
          const resp = await axios.post(
            `${FASHION_API_URL}/materials/${item.materialId}/stock-colors`,
            {
              colorId: newColor.id,
              collectionId: currentCollectionId,
              stockId: item.stockId || undefined,
              code: colorCode,
            },
            { headers }
          )
          newStockId = resp.data?.stockId
        } catch (err: any) {
          const msg = err.response?.data?.message || 'Erro ao associar cor ao material'
          setCreateColorModalState(prev => prev ? { ...prev, isLoading: false, errorMessage: msg } : null)
          return
        }
      }

      if (!isMaterial && (item.resourceId || item.materialId)) {
        try {
          const templateResourceId = item.resourceId || getTemplateResourceIdByMaterial(item.materialId, item.categoryId)
          if (templateResourceId) {
            const resp = await axios.post(
              `${FASHION_API_URL}/resources/${templateResourceId}/resource-colors`,
              {
                colorId: newColor.id,
                collectionId: currentCollectionId,
                code: colorCode,
              },
              { headers }
            )
            newResourceId = resp.data?.resourceId ?? templateResourceId
          }
        } catch (err: any) {
          const msg = err.response?.data?.message || 'Erro ao associar cor ao recurso'
          setCreateColorModalState(prev => prev ? { ...prev, isLoading: false, errorMessage: msg } : null)
          return
        }
      }

      setCompositionItems(prev => prev.map(it => {
        if (it.id !== item.id) return it;
        const updated: ProductItemColorEntry[] = (it.productItemColors || [])
          .filter(p => p.collectionColorId !== col.id)
        const entry: ProductItemColorEntry = {
          collectionColorId: col.id,
          itemColorId: newColor.id,
          itemColorName: newColor.name,
          ...(newStockId ? { stockId: newStockId } : {}),
          ...(newResourceId ? { resourceId: newResourceId } : {}),
        }
        updated.push(entry)
        return { ...it, productItemColors: updated }
      }))

      const resolvedHex = newColor.hex || newColor.Pantone?.hex || newColor.pantone?.hex || createColorModalState.pantone?.hex || undefined;
      const resolvedPantone = newColor.Pantone || newColor.pantone || createColorModalState.pantone || undefined;

      if (isMaterial && item.materialId) {
        setFamilyConjuntos(prev => {
          const exists = prev.some(c => c.materialId === item.materialId && c.colorId === newColor.id);
          if (!exists) {
            return [...prev, {
              familyMaterialId: item.id,
              collectionMaterialId: item.id,
              materialId: item.materialId,
              materialName: item.materialName || 'Material',
              stockId: newStockId || null,
              stockLabel: `${colorCode} - ${item.materialName || ''} - ${newColor.name}`.trim(),
              finishing: null,
              colorId: newColor.id,
              colorName: newColor.name,
              colorHex: resolvedHex || null,
              colorPantone: resolvedPantone || null,
              linkedResourceMaterials: [],
            }];
          }
          return prev;
        });
      }

      if (!isMaterial && (item.resourceId || item.materialId)) {
        setFamilyTrimInsumoOptions(prev => {
          const exists = prev.some(tr => (item.materialId ? tr.materialId === item.materialId : tr.resourceId === newResourceId) && tr.colorId === newColor.id);
          if (!exists) {
            return [...prev, {
              familyMaterialId: item.id,
              collectionMaterialId: item.id,
              resourceId: newResourceId || item.resourceId || null,
              resourceName: item.materialName || item.descricao || '',
              materialId: item.materialId || 0,
              materialName: item.materialName || item.descricao || 'Insumo',
              categoryId: item.categoryId || null,
              categoryName: item.categoryName || null,
              colorId: newColor.id,
              colorName: newColor.name,
              colorHex: resolvedHex || null,
              colorPantone: resolvedPantone || null,
            }];
          }
          return prev;
        });
      }

      setAllItemColors(prev => {
        const exists = prev.some(c => String(c.id) === String(newColor.id));
        if (!exists) {
          return [...prev, {
            id: newColor.id,
            name: newColor.name,
            hex: resolvedHex,
            colorHex: resolvedHex,
            pantone: resolvedPantone,
            Pantone: resolvedPantone,
          }];
        }
        return prev.map(c => String(c.id) === String(newColor.id) ? {
          ...c,
          hex: c.hex || resolvedHex,
          colorHex: (c as any).colorHex || resolvedHex,
          pantone: c.pantone || resolvedPantone,
          Pantone: (c as any).Pantone || resolvedPantone,
        } : c);
      });

      if (createColorModalState.resolve) {
        createColorModalState.resolve({
          id: newColor.id,
          name: newColor.name,
          hex: resolvedHex,
          colorHex: resolvedHex,
          pantone: resolvedPantone,
          Pantone: resolvedPantone,
        });
      }
      setCreateColorModalState(null);
    } catch (err: any) {
      console.error('Erro ao cadastrar cor com pantone:', err)
      setCreateColorModalState(prev => prev ? {
        ...prev,
        isLoading: false,
        errorMessage: err.response?.data?.message || 'Erro ao cadastrar cor.',
      } : null)
    }
  }

  const handleCancelCreateColorModal = () => {
    if (createColorModalState?.reject) {
      createColorModalState.reject(new Error('Cancelado pelo usuário'))
    }
    setCreateColorModalState(null)
  }

  const [filteredGroups, setFilteredGroups] = useState<Group[]>([])
  const [collectionEpisodes, setCollectionEpisodes] = useState<CollectionEpisodeOption[]>([])
  const measuresRef = useRef<MeasuresHandle>(null)

  const [gradesByType, setGradesByType] = useState<Record<string, Grade[]>>({})
  const [gradeTypes, setGradeTypes] = useState<GradeType[]>([])
  const [availableGradeIds, setAvailableGradeIds] = useState<number[]>([])
  const [selectedGradeIds, setSelectedGradeIds] = useState<number[]>([])

  const [productSelectedFiles, setProductSelectedFiles] = useState<File[]>([])
  const [productAttachmentUrls, setProductAttachmentUrls] = useState<string[]>([])
  const [productExistingAttachments, setProductExistingAttachments] = useState<ExistingAttachment[]>([])

  const ATTACHMENTS_ASIDE_STORAGE_KEY = 'productCompositionAttachmentsAsideOpen'
  const [isAttachmentsAsideOpen, setIsAttachmentsAsideOpen] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(ATTACHMENTS_ASIDE_STORAGE_KEY)
      if (stored === '0') return false
      if (stored === '1') return true
    } catch (error) {
      console.warn('[RegisterComposition] não foi possível ler estado do aside de anexos:', error)
    }
    return true
  })

  useEffect(() => {
    try {
      localStorage.setItem(ATTACHMENTS_ASIDE_STORAGE_KEY, isAttachmentsAsideOpen ? '1' : '0')
    } catch (error) {
      console.warn('[RegisterComposition] não foi possível salvar estado do aside de anexos:', error)
    }
  }, [isAttachmentsAsideOpen])

  const [beneficiamentoNotes, setBeneficiamentoNotes] = useState<BeneficiamentoNota[]>([])
  const [initialBeneficiamentoNotes, setInitialBeneficiamentoNotes] = useState<BeneficiamentoNota[]>([])
  const [savingNotes, setSavingNotes] = useState(false)
  const [sectors, setSectors] = useState<BeneficiamentoSector[]>([])
  const [isBeneficiamentoOpen, setIsBeneficiamentoOpen] = useState(() => Boolean(noteIdParam))

  useEffect(() => {
    if (noteIdParam) {
      setIsBeneficiamentoOpen(true)
      const timeoutId = setTimeout(() => {
        const noteEl = document.getElementById(`beneficiamento-note-${noteIdParam}`)
        const sectionEl = document.getElementById('product-beneficiamento-section')
        const target = noteEl || sectionEl
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 500)
      return () => clearTimeout(timeoutId)
    }
  }, [noteIdParam, beneficiamentoNotes.length])

  const [rcDebugLogs, setRcDebugLogs] = useState<string[]>([])
  const rcDebug = (msg: string) => {
    console.log(msg)
    setRcDebugLogs(prev => [...prev, msg])
  }
  const [units, setUnits] = useState<Array<{ id: number; name: string }>>([])
  const [ncm, setNcm] = useState<NcmCatalogoOption | null>(null)

  const [productData, setProductData] = useState<any | null>(null)
  const isShowroomProduct = Boolean((productData as any)?.parentProductId || parentIdParam)
  const defaultReturnUrl = parentIdParam
    ? `/panel/composition-product/edit/${parentIdParam}`
    : '/panel/composition-product'

  const [allAvailableTags, setAllAvailableTags] = useState<Array<{ id: number; name: string; color?: string }>>([])
  const [selectedTags, setSelectedTags] = useState<Array<{ id: number; name: string; color?: string }>>([])
  const [isTagDropdownOpen, setIsTagDropdownOpen] = useState<boolean>(false)
  const [tagSearch, setTagSearch] = useState<string>('')
  const tagDropdownRef = useRef<HTMLDivElement>(null)
  const initialTagIdsRef = useRef<number[]>([])
  const productTicketIdRef = useRef<number | null>(null)
  const productPipelineRef = useRef<any>(null)

  const loadProductTicketAndTags = useCallback(async (targetProductId?: number, currentProduct?: any) => {
    const token = localStorage.getItem('token')
    if (!token) return

    try {
      const tagsRes = await axios.get(
        `${GATEWAY_URL}/pipelines/tag`,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      const rawTags = Array.isArray(tagsRes.data?.data)
        ? tagsRes.data.data
        : Array.isArray(tagsRes.data)
          ? tagsRes.data
          : []
      setAllAvailableTags(rawTags)

      let pipeline: any = null
      try {
        const getPipelineRes = await axios.get(
          `${GATEWAY_URL}/pipelines/pipeline`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { moduleType: 'product_development', subModule: 'fashion' },
          },
        )
        const list = getPipelineRes.data?.data || getPipelineRes.data || []
        if (Array.isArray(list) && list.length > 0) {
          pipeline = list[0]
        }
      } catch (e) {
        console.warn('Erro ao buscar pipeline por GET:', e)
      }

      if (!pipeline?.id) {
        const pipelineResponse = await axios.post(
          `${GATEWAY_URL}/pipelines/pipeline/setup-module`,
          {
            moduleType: 'product_development',
            subModule: 'fashion',
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
        const pipelineData = pipelineResponse.data?.data || pipelineResponse.data
        pipeline = Array.isArray(pipelineData) ? pipelineData[0] : pipelineData
      }

      productPipelineRef.current = pipeline

      if (pipeline?.id) {
        let ticketsResponse = await axios.get(
          `${GATEWAY_URL}/pipelines/ticket`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { pipelineId: pipeline.id, take: 1000 },
          },
        )
        let ticketList: any[] = Array.isArray(ticketsResponse.data?.data)
          ? ticketsResponse.data.data
          : Array.isArray(ticketsResponse.data)
            ? ticketsResponse.data
            : []

        const checkMatch = (t: any) => {
          if (targetProductId) {
            if (t.externalId === targetProductId || Number(t.externalId) === targetProductId) return true
            if (t.externalData?.productId === targetProductId || Number(t.externalData?.productId) === targetProductId) return true
            if (String(t.externalId) === String(targetProductId) || t.externalData?.productCode === String(targetProductId)) return true
          }
          if (currentProduct) {
            if (currentProduct.id && (t.externalId === currentProduct.id || Number(t.externalId) === currentProduct.id)) return true
            if (currentProduct.id && (t.externalData?.productId === currentProduct.id || Number(t.externalData?.productId) === currentProduct.id)) return true
            if (currentProduct.productCode && t.externalData?.productCode === currentProduct.productCode) return true
            if (currentProduct.name && (t.title === currentProduct.name || t.externalData?.productName === currentProduct.name)) return true
          }
          return false
        }

        let matchingTickets = ticketList.filter(checkMatch)

        if (matchingTickets.length === 0 && (targetProductId || currentProduct?.id)) {
          try {
            await axios.post(
              `${GATEWAY_URL}/pipelines/ticket/sync-module`,
              {
                moduleType: 'product_development',
                pipelineId: pipeline.id,
                subModule: 'fashion',
              },
              { headers: { Authorization: `Bearer ${token}` } },
            )
            ticketsResponse = await axios.get(
              `${GATEWAY_URL}/pipelines/ticket`,
              {
                headers: { Authorization: `Bearer ${token}` },
                params: { pipelineId: pipeline.id, take: 1000 },
              },
            )
            ticketList = Array.isArray(ticketsResponse.data?.data)
              ? ticketsResponse.data.data
              : Array.isArray(ticketsResponse.data)
                ? ticketsResponse.data
                : []
            matchingTickets = ticketList.filter(checkMatch)
          } catch (syncErr) {
            console.warn('Erro ao sincronizar módulo:', syncErr)
          }
        }

        if (matchingTickets.length > 0) {
          const rootTicket =
            matchingTickets.find((t: any) => !t.parentTicketId) ||
            matchingTickets[0]

          productTicketIdRef.current = rootTicket.id

          const rawSources: any[] = []
          if (Array.isArray(rootTicket.tags)) rawSources.push(...rootTicket.tags)
          if (Array.isArray(rootTicket.TagTicket)) rawSources.push(...rootTicket.TagTicket)
          if (Array.isArray(rootTicket.tagTickets)) rawSources.push(...rootTicket.tagTickets)

          try {
            const singleTicketRes = await axios.get(
              `${GATEWAY_URL}/pipelines/ticket/${rootTicket.id}/full`,
              { headers: { Authorization: `Bearer ${token}` } },
            )
            if (singleTicketRes.data?.data) {
              const fullTicket = singleTicketRes.data.data
              if (Array.isArray(fullTicket.tags)) rawSources.push(...fullTicket.tags)
              if (Array.isArray(fullTicket.TagTicket)) rawSources.push(...fullTicket.TagTicket)
              if (Array.isArray(fullTicket.tagTickets)) rawSources.push(...fullTicket.tagTickets)
            }
          } catch (e) {
            console.warn('Erro ao carregar ticket completo (/full):', e)
          }

          const seenIds = new Set<number>()
          const initialTags: Array<{ id: number; name: string; color?: string }> = []

          for (const item of rawSources) {
            const tagObj = item?.Tag || item?.tag || item
            const id = Number(tagObj?.id ?? item?.tagId ?? item?.id)
            const name = tagObj?.name ?? item?.name
            const color = tagObj?.color ?? item?.color

            if (id && name && !seenIds.has(id)) {
              seenIds.add(id)
              initialTags.push({ id, name, color })
            }
          }

          setSelectedTags(initialTags)
          initialTagIdsRef.current = initialTags.map((t) => t.id)
        }
      }
    } catch (err) {
      console.error('Erro ao carregar tags do ticket:', err)
    }
  }, [])

  useEffect(() => {
    const idToLoad = productId ? Number(productId) : sourceProductId ? Number(sourceProductId) : productData?.id
    loadProductTicketAndTags(idToLoad, productData)
  }, [loadProductTicketAndTags, productId, sourceProductId, productData])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (tagDropdownRef.current && !tagDropdownRef.current.contains(e.target as Node)) {
        setIsTagDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const hasUserEditedRef = useRef<boolean>(false)
  const markUserDirty = () => {
    hasUserEditedRef.current = true
  }

  const initialSnapshotRef = useRef<string | null>(null)
  const [showUnsavedModal, setShowUnsavedModal] = useState<boolean>(false)
  const [pendingNavigationUrl, setPendingNavigationUrl] = useState<string | null>(null)

  const getFormSnapshot = () => {
    return JSON.stringify({
      formData: {
        codigo: formData.codigo || '',
        nomeProduto: formData.nomeProduto || '',
        description: formData.description || '',
        referenceProduct: formData.referenceProduct || '',
        observations: formData.observations || '',
        supplierCode: formData.supplierCode || '',
        clientIdentification: formData.clientIdentification || '',
        collectionId: formData.collectionId || 0,
        familyId: formData.familyId || 0,
        groupId: formData.groupId || 0,
        episodeId: formData.episodeId || 0,
        price: formData.price || 0,
      },
      selectedGradeIds: [...(selectedGradeIds || [])].sort(),
      selectedGradeType: selectedGradeType || null,
      selectedTagIds: (selectedTags || []).map((t) => t.id).sort(),
      selectedCollectionColorIds: (selectedCollectionColors || []).map((c) => c.id).sort(),
      compositionItems: (compositionItems || []).map((ci) => ({
        id: ci.id,
        tipo: ci.tipo,
        materialId: ci.materialId ?? null,
        stockId: ci.stockId ?? null,
        resourceId: ci.resourceId ?? null,
        stageId: ci.stageId ?? null,
        categoryId: ci.categoryId ?? null,
        descricao: ci.descricao || '',
        unidadeMedida: ci.unidadeMedida || '',
        consumo: ci.consumo || '',
        costPerUnit: ci.costPerUnit || '',
        sizeRange: [...(ci.sizeRange || [])].sort(),
        productItemColors: (ci.productItemColors || []).map((p) => ({
          collectionColorId: p.collectionColorId,
          itemColorId: p.itemColorId ?? null,
          resourceId: p.resourceId ?? null,
        })),
      })),
      newFilesCount: productSelectedFiles.length,
      existingAttachments: (productExistingAttachments || []).map((a) => a.filePath || a.fileUrl || a.fileName),
    })
  }

  const isFormDirty = () => {
    if (!hasUserEditedRef.current) return false
    if (!initialSnapshotRef.current) return false
    return initialSnapshotRef.current !== getFormSnapshot()
  }

  useEffect(() => {
    if (!hasUserEditedRef.current) {
      initialSnapshotRef.current = getFormSnapshot()
    }
  }, [
    formData,
    selectedGradeIds,
    selectedGradeType,
    selectedTags,
    selectedCollectionColors,
    compositionItems,
    productSelectedFiles.length,
    productExistingAttachments,
  ])

  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      if (!isFormDirty()) return

      const target = e.target as HTMLElement
      if (target.closest('[data-modal-action]') || target.closest('[data-modal]')) return

      const anchor = target.closest('a')
      if (!anchor) return

      const href = anchor.getAttribute('href')
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return
      if (anchor.target === '_blank') return

      e.preventDefault()
      e.stopPropagation()
      setPendingNavigationUrl(href)
      setShowUnsavedModal(true)
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isFormDirty()) {
        e.preventDefault()
        e.returnValue = ''
      }
    }

    const handlePopState = () => {
      if (isFormDirty()) {
        window.history.pushState(null, '', window.location.href)
        setPendingNavigationUrl(returnTo || defaultReturnUrl)
        setShowUnsavedModal(true)
      }
    }

    document.addEventListener('click', handleAnchorClick, true)
    window.addEventListener('beforeunload', handleBeforeUnload)
    window.addEventListener('popstate', handlePopState)
    return () => {
      document.removeEventListener('click', handleAnchorClick, true)
      window.removeEventListener('beforeunload', handleBeforeUnload)
      window.removeEventListener('popstate', handlePopState)
    }
  }, [formData, selectedGradeIds, selectedGradeType, compositionItems, productSelectedFiles.length, productExistingAttachments, returnTo])

  const handleCancel = () => {
    if (isFormDirty()) {
      setPendingNavigationUrl(returnTo || defaultReturnUrl)
      setShowUnsavedModal(true)
    } else {
      navigate(returnTo || defaultReturnUrl)
    }
  }

  const handleDiscardFromModal = () => {
    hasUserEditedRef.current = false
    initialSnapshotRef.current = null
    setShowUnsavedModal(false)
    navigate(pendingNavigationUrl || returnTo || defaultReturnUrl)
  }

  const handleStayFromModal = () => {
    setShowUnsavedModal(false)
    setPendingNavigationUrl(null)
  }

  const handleSaveFromModal = async () => {
    setShowUnsavedModal(false)
    await executeSave(pendingNavigationUrl || defaultReturnUrl)
  }

  const uploadProductAttachmentFiles = async (files: File[]) => {
    if (!files || files.length === 0) return [] as string[]

    const uploadedUrls: string[] = []
    for (const file of files) {
      try {
        const uploaded = await AttachmentApiService.upload(file)
        if (uploaded?.fileUrl) {
          uploadedUrls.push(uploaded.fileUrl)
        } else {
          throw new Error('URL do arquivo não retornada no upload')
        }
      } catch (err) {
        console.error('Erro ao fazer upload de arquivo de anexo:', err)
        throw err
      }
    }

    return uploadedUrls
  }

  const uploadNoteImage = async (file: File): Promise<string> => {
    const uploaded = await AttachmentApiService.upload(file)
    if (uploaded?.fileUrl) return uploaded.fileUrl
    throw new Error('URL não retornada no upload de imagem de nota')
  }

  const getNoteSignedUrl = async (filePath: string): Promise<string> => {
    try {
      const url = await AttachmentApiService.getSignedUrl(filePath)
      return url || filePath
    } catch {
      return filePath
    }
  }

  const resolveNoteImageUrls = async (imageUrls: string[]): Promise<string[]> => {
    if (!imageUrls || imageUrls.length === 0) return []
    return Promise.all(imageUrls.map((url) => getNoteSignedUrl(url).catch(() => url)))
  }

  const normalizeProductAttachment = (attachment: any, fallbackIndex: number): ExistingAttachment => {
    const fileUrl = attachment?.fileUrl || attachment?.filePath || ''
    const originalName =
      attachment?.originalName ||
      attachment?.fileName ||
      fileUrl.split('/').pop() ||
      `anexo-${fallbackIndex}`

    return {
      id: Number(attachment?.id ?? fallbackIndex),
      originalName,
      fileName: attachment?.fileName || originalName,
      filePath: attachment?.filePath || fileUrl,
      fileUrl,
      fileSize: Number(attachment?.fileSize ?? 0),
      mimeType: attachment?.mimeType || '',
      isImage: attachment?.isImage === true ? true : undefined,
      isCover: Boolean(attachment?.isCover),
      coverScale: typeof attachment?.coverScale === 'number' ? attachment.coverScale : null,
      coverPosX: typeof attachment?.coverPosX === 'number' ? attachment.coverPosX : null,
      coverPosY: typeof attachment?.coverPosY === 'number' ? attachment.coverPosY : null,
    }
  }

  const getSignedUrlByFilePath = async (
    filePath: string,
    headers: { Authorization?: string },
    forceDownload?: boolean,
  ): Promise<string | null> => {
    if (!filePath) return null

    try {
      const url = await AttachmentApiService.getSignedUrl(filePath, forceDownload)
      return url || null
    } catch (error) {
      console.error('[RC] erro ao obter signed URL por filePath:', error)
      return null
    }
  }

  const resolveProductAttachmentAccessUrl = async (
    attachment: ExistingAttachment,
    action: 'view' | 'download',
  ): Promise<string | null> => {
    const token = localStorage.getItem('token')
    const headers = token ? { Authorization: `Bearer ${token}` } : {}

    const fallbackSource = attachment.fileUrl || attachment.filePath
    if (!fallbackSource) {
      return null
    }

    const signedByFilePath = await getSignedUrlByFilePath(
      fallbackSource,
      headers,
      action === 'download',
    )
    if (signedByFilePath) {
      return signedByFilePath
    }

    return fallbackSource
  }

  const hydrateSignedPreviewUrls = async (attachments: ExistingAttachment[]) => {
    if (!attachments.length) return

    const previewsToHydrate = attachments.filter((attachment) => {
      const source = attachment.filePath || attachment.fileUrl || ''
      const mimeType = String(attachment.mimeType || '').toLowerCase()
      const fileReference = String(
        attachment.originalName || attachment.fileName || source,
      ).toLowerCase()

      const isImageByType = attachment.isImage === true || mimeType.startsWith('image/')
      const isImageByExtension = /\.(png|jpe?g|gif|bmp|webp|svg|avif|heic|heif|jfif)$/i.test(fileReference)

      return Boolean(source) && (isImageByType || isImageByExtension)
    })

    if (!previewsToHydrate.length) return

    const hydratedEntries = await Promise.all(
      previewsToHydrate.map(async (attachment) => {
        const signedUrl = await resolveProductAttachmentAccessUrl(attachment, 'view')
        return {
          id: attachment.id,
          signedUrl,
        }
      }),
    )

    const hydratedById = new Map<number, string>()
    hydratedEntries.forEach((entry) => {
      if (entry.signedUrl) {
        hydratedById.set(entry.id, entry.signedUrl)
      }
    })

    if (!hydratedById.size) return

    setProductExistingAttachments((prev) =>
      prev.map((attachment) => {
        const signedUrl = hydratedById.get(attachment.id)
        if (!signedUrl) return attachment

        return {
          ...attachment,
          filePath: signedUrl,
          isImage: attachment.isImage === undefined ? true : attachment.isImage,
        }
      }),
    )
  }

  const applyProductAttachmentsState = (attachments: any[]) => {
    const normalizedAttachments = (attachments || []).map((attachment, index) =>
      normalizeProductAttachment(attachment, index + 1),
    )

    setProductExistingAttachments(normalizedAttachments)

    const urls = normalizedAttachments
      .map((attachment) => attachment.fileUrl || attachment.filePath)
      .filter((url): url is string => Boolean(url))

    setProductAttachmentUrls(Array.from(new Set(urls)))

    void hydrateSignedPreviewUrls(normalizedAttachments)

    return normalizedAttachments
  }

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const token = localStorage.getItem('token')
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const resp = await axios.get(`${GATEWAY_URL}/resources/resource/util/units`, { headers })
        console.debug('[RegisterComposition] unidade fetch response', resp.data)
        if (Array.isArray(resp.data)) {
          const excluded = ['Celsius', 'Faren', 'HB', 'HRB', 'HRC', 'J', 'MPa', 'Newton', 'Tn'];
          const filtered = resp.data.filter((u: any) => {
            const name = String(u.name || '').trim();
            return !excluded.some(e => e.toLowerCase() === name.toLowerCase());
          });
          setUnits(filtered)
          console.debug('[RegisterComposition] unidades gravadas', filtered)
        }
      } catch (err) {
        console.error('Erro ao buscar unidades de medida:', err)
      }
    }
    fetchUnits()
  }, [])




  const insumoMaterialGroups = React.useMemo(() => {
    const seen = new Set<string>()
    const result: Array<{
      resourceId?: number | null
      materialId: number
      materialName: string
      categoryId?: number | null
      categoryName?: string | null
      familyMaterialId?: number
      finishing?: string
    }> = []

    for (const lr of familyTrimInsumoOptions) {
      const hasResource = typeof lr.resourceId === 'number'
      if (!hasResource && !lr.materialId) continue
      const key = hasResource
        ? `r:${lr.resourceId}`
        : `m:${lr.materialId}:${lr.categoryId ?? ''}`
      if (seen.has(key)) continue
      seen.add(key)
      result.push({
        resourceId: hasResource ? lr.resourceId : null,
        materialId: lr.materialId,
        materialName: lr.materialName || lr.resourceName || 'Insumo',
        categoryId: lr.categoryId ?? null,
        categoryName: lr.categoryName ?? null,
        familyMaterialId: lr.familyMaterialId,
        finishing: lr.finishing,
      })
    }

    for (const r of allResources) {
      if (!r.id) continue
      const key = `r:${r.id}`
      if (seen.has(key)) continue
      seen.add(key)
      const catName = (r as any).Category_Resource?.name || (r.categoryId ? allResourceCategories.find((c) => c.id === r.categoryId)?.name : null) || null
      const baseName = (r.name ? String(r.name) : '').trim()
      const desc = (r.description ? String(r.description) : '').trim()
      const rawCode = ((r as any).Code?.code != null && String((r as any).Code.code).trim() !== ''
        ? String((r as any).Code.code)
        : (r as any).code != null && String((r as any).code).trim() !== ''
          ? String((r as any).code)
          : (r as any).codeId
            ? String((r as any).codeId)
            : '')
      const code = sanitizeCode(rawCode)

      const parts: string[] = []
      if (code) parts.push(code)
      if (baseName) parts.push(baseName)
      if (desc && desc.toLowerCase() !== baseName.toLowerCase()) {
        parts.push(desc)
      }
      let label = parts.length > 0 ? parts.join(' - ') : (baseName || desc || `Insumo #${r.id}`)
      if (catName) {
        label = `${label} (${catName})`
      }

      const cleanMatName = ((r as any).Material?.name || baseName || desc || 'Insumo').trim()
      const finishingVal = (r as any).Finishing?.type ? String((r as any).Finishing.type) : ((r as any).finishing ? String((r as any).finishing) : '—')
      result.push({
        resourceId: r.id,
        materialId: r.materialId ?? 0,
        materialName: cleanMatName,
        categoryId: r.categoryId ?? null,
        categoryName: catName,
        finishing: finishingVal,
      })
    }

    return result
  }, [familyTrimInsumoOptions, allResources, allResourceCategories])

  useEffect(() => {
    const fetchInitialData = async () => {
      setLoadingData(true)
      const token = localStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }

      try {
        const res = await axios.get(`${FASHION_API_URL}/collections`, { headers })
        const data = Array.isArray(res.data) ? res.data : []
        setAllCollections(data.map((c: any) => ({ id: c.id, name: c.name })))
      } catch (error) {
        console.error('Erro ao carregar collections:', error)
      }

      try {
        const res = await axios.get(`${FASHION_API_URL}/grades`, { headers })
        const grades: Grade[] = Array.isArray(res.data) ? res.data : []

        const typesMap = new Map<number, GradeType>()
        grades.forEach((grade) => {
          const gradeType = grade.GraduationType || grade.type;
          if (gradeType && !typesMap.has(gradeType.id)) {
            typesMap.set(gradeType.id, gradeType)
          }
        })
        setGradeTypes(Array.from(typesMap.values()))

        const byType: Record<string, Grade[]> = {}
        grades.forEach((grade) => {
          const typeName = (grade.GraduationType || grade.type)?.name || 'Tipo Desconhecido'
          if (!byType[typeName]) {
            byType[typeName] = []
          }
          byType[typeName].push(grade)
        })

        Object.keys(byType).forEach((typeName) => {
          byType[typeName].sort((a, b) => {
            const aNum = parseInt(a.name)
            const bNum = parseInt(b.name)
            if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum
            return a.name.localeCompare(b.name)
          })
        })

        setGradesByType(byType)
      } catch (error) {
        console.error('Erro ao carregar grades:', error)
      }


      try {
        const res = await axios.get(`${FASHION_API_URL}/resource-categories`, { headers })
        const categories: ResourceCategory[] = Array.isArray(res.data) ? res.data : []
        setAllResourceCategories(categories)
      } catch (error) {
        console.error('Erro ao carregar resource categories:', error)
      }

      try {
        const res = await axios.get(`${FASHION_API_URL}/resources`, { headers })
        const resources: Resource[] = Array.isArray(res.data) ? res.data : []
        setAllResources(resources)
        allResourcesRef.current = resources

        const byCategory: Record<number, Resource[]> = {}
        resources.forEach((resource) => {
          if (resource.categoryId) {
            if (!byCategory[resource.categoryId]) {
              byCategory[resource.categoryId] = []
            }
            byCategory[resource.categoryId].push(resource)
          }
        })
        setResourcesByCategory(byCategory)
      } catch (error) {
        console.error('Erro ao carregar resources:', error)
      }

      try {
        const res = await axios.get(`${FASHION_API_URL}/stocks`, { headers })
        const stocks: any[] = Array.isArray(res.data) ? res.data : []
        setAllStocks(stocks)
        allStocksRef.current = stocks
      } catch (error) {
        console.error('Erro ao carregar stocks:', error)
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage`, { headers })
        const services: StageService[] = Array.isArray(res.data) ? res.data : []
        setAllServices(services)
      } catch (error) {
        console.error('Erro ao carregar services:', error)
      }

      try {
        const res = await axios.get(`${FASHION_API_URL}/colors`, { headers })
        const colors = Array.isArray(res.data) ? res.data : []
        setAllItemColors(
          colors.map((c: any) => ({
            id: c.id,
            name: c.name,
            hex: c.hex || c.Pantone?.hex || c.pantone?.hex,
            pantone: c.Pantone || c.pantone,
            Pantone: c.Pantone || c.pantone,
          })),
        )
      } catch (error) {
        console.error('Erro ao carregar cores globais:', error)
      }

      try {
        const res = await axios.get(`${FASHION_API_URL}/sectors`, { headers })
        setSectors(Array.isArray(res.data) ? res.data : [])
      } catch (error) {
        console.error('Erro ao carregar setores de beneficiamento:', error)
      }

      setLoadingData(false)
    }

    fetchInitialData()
  }, [])


  useEffect(() => {
    if (sectors.length === 0) return
    setBeneficiamentoNotes(prev =>
      prev.map(n => (n.sectorId === 0 ? { ...n, sectorId: sectors[0].id } : n))
    )
  }, [sectors])

  useEffect(() => {
    if (!formData.collectionId) {
      setCollectionEpisodes([])
      setFilteredFamilies([])
      setFilteredGroups([])
      setAvailableGradeIds([])
      setAllCollectionColors([])
      setFamilyConjuntos([])
      setFamilyTrimInsumoOptions([])
      return
    }

    let cancelled = false

    const load = async () => {
      try {
        const token = localStorage.getItem('token')
        const res = await axios.get(
          `${FASHION_API_URL}/collections/${formData.collectionId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        )
        const col = res.data
        if (cancelled) return

        const eps = col?.Episode ?? col?.Episodes
        const list: CollectionEpisodeOption[] = Array.isArray(eps)
          ? eps
            .filter((e: { id?: number }) => typeof e?.id === 'number')
            .map((e: { id: number; name?: string }) => ({
              id: e.id,
              name: String(e.name ?? ''),
            }))
          : []
        setCollectionEpisodes(list)
        setFormData((prev) => {
          if (!prev.episodeId) return prev
          if (!list.some((e) => e.id === prev.episodeId)) {
            return { ...prev, episodeId: 0 }
          }
          return prev
        })

        const rawFamilies = col?.Family ?? col?.Families
        const famList: Family[] = Array.isArray(rawFamilies)
          ? rawFamilies.map((f: any) => ({ id: f.id, name: f.name, collectionId: formData.collectionId }))
          : []
        setFilteredFamilies(famList)

        const rawGroups = col?.GroupInCollection ?? []
        const groupList: Group[] = Array.isArray(rawGroups)
          ? rawGroups
            .map((gic: any) => gic.Group || gic.group)
            .filter((g: any) => g && g.id)
          : []
        setFilteredGroups(groupList)



        const rawGrades = col?.GradeInCollection ?? []
        const gradeIds: number[] = Array.isArray(rawGrades)
          ? rawGrades.map((gic: any) => gic.gradeId ?? gic.Grade?.id).filter((id: any) => typeof id === 'number')
          : []
        setAvailableGradeIds(gradeIds)

        const rawColors = col?.CollectionColor ?? []
        const colorList = Array.isArray(rawColors)
          ? rawColors.map((c: any) => ({
            id: c.id,
            name: c.name,
            hex: c.hex || c.Pantone?.hex || c.ItemColor?.Pantone?.hex || c.ItemColor?.hex,
            pantoneCode: c.Pantone?.code || c.code,
            pantone: c.Pantone || c.ItemColor?.Pantone,
            Pantone: c.Pantone || c.ItemColor?.Pantone,
          }))
          : []
        setAllCollectionColors(colorList)

        const rawMaterials = col?.CollectionMaterial ?? []
        if (Array.isArray(rawMaterials)) {
          const fabricMaterials = rawMaterials.filter((m: any) => m.kind !== 'TRIM')
          const trimMaterials = rawMaterials.filter((m: any) => m.kind === 'TRIM')

          const conjuntos: FamilyConjunto[] = fabricMaterials.map((cm: any) => {
            const stock = cm.Stock || null
            const stockMaterial = stock?.Material || null
            const stockMaterialName = (stockMaterial?.name || cm.Material?.name || '').trim()
            const stockDescription = (stock?.description ? String(stock.description) : '').trim()
            const rawStockCode = stock?.Code?.code != null && String(stock.Code.code).trim() !== ''
              ? String(stock.Code.code)
              : stock?.code != null && String(stock.code).trim() !== ''
                ? String(stock.code)
                : stock?.codeId
                  ? String(stock.codeId)
                  : cm.Material?.code
                    ? String(cm.Material.code)
                    : ''
            const stockCode = sanitizeCode(rawStockCode)
            const colorId = stock?.ItemColor?.id ?? stock?.itemColorId ?? null
            const colorName = stock?.ItemColor?.name ?? null
            const colorHex = stock?.ItemColor?.hex || stock?.ItemColor?.Pantone?.hex || stock?.Pantone?.hex || null
            const colorPantone = stock?.ItemColor?.Pantone || stock?.Pantone || null

            const parts: string[] = []
            if (stockCode) parts.push(stockCode)
            if (stockMaterialName) parts.push(stockMaterialName)
            if (colorName) parts.push(colorName)
            const stockLabel = parts.length > 0 ? parts.join(' - ') : (stockMaterialName || 'Material')
            const resolvedMaterialId = cm.materialId || cm.Material?.id || stockMaterial?.id || null

            return {
              familyMaterialId: cm.id,
              collectionMaterialId: cm.id,
              materialId: resolvedMaterialId ?? 0,
              materialName: stockMaterialName || stockLabel || 'Material',
              stockId: typeof cm.stockId === 'number' ? cm.stockId : null,
              stockLabel,
              finishing: getStockFinishing(stock),
              colorId,
              colorName,
              colorHex,
              colorPantone,
              linkedResourceMaterials: [],
            }
          })
          setFamilyConjuntos(conjuntos)

          console.debug('[RC] trimMaterials loaded:', trimMaterials)
          const trimOpts: FamilyTrimInsumoOption[] = trimMaterials.map((cm: any) => {
            const tr = cm.TrimResource || {}
            console.debug('[RC] processing trimMaterial item:', cm.id, 'resource tr:', tr)
            const resourceId = typeof cm.resourceId === 'number' ? cm.resourceId : typeof tr.id === 'number' ? tr.id : null
            const materialId = typeof tr.materialId === 'number' ? tr.materialId : typeof cm.materialId === 'number' ? cm.materialId : 0
            const resourceName = (tr.name ? String(tr.name) : '').trim()
            const resourceDesc = (tr.description ? String(tr.description) : '').trim()
            const rawCode = tr?.Code?.code != null && String(tr.Code.code).trim() !== ''
              ? String(tr.Code.code)
              : tr?.code != null && String(tr.code).trim() !== ''
                ? String(tr.code)
                : tr?.codeId
                  ? String(tr.codeId)
                  : ''
            const code = sanitizeCode(rawCode)
            const categoryId = typeof tr.categoryId === 'number' ? tr.categoryId : tr.Category_Resource?.id ?? null
            const categoryName = tr.Category_Resource?.name ? String(tr.Category_Resource.name) : null
            const finishingVal = tr.Finishing?.type ? String(tr.Finishing.type) : (tr.finishing ? String(tr.finishing) : '—')
            const colorId = tr.ItemColor?.id ?? tr.itemColorId ?? null
            const colorName = tr.ItemColor?.name ?? null
            const colorHex = tr.ItemColor?.hex || tr.ItemColor?.Pantone?.hex || tr.Pantone?.hex || null
            const colorPantone = tr.ItemColor?.Pantone || tr.Pantone || null
            console.debug('[RC] trimMaterial item:', cm.id, 'resolved finishing:', finishingVal)

            const parts: string[] = []
            if (code) parts.push(code)
            if (resourceName) parts.push(resourceName)
            if (colorName) parts.push(colorName)
            let label = parts.length > 0 ? parts.join(' - ') : (resourceName || 'Insumo')
            if (categoryName) {
              label = `${label} (${categoryName})`
            }

            const cleanMaterialName = (cm.Material?.name || tr?.Material?.name || resourceName || 'Insumo').trim()

            return {
              familyMaterialId: cm.id,
              collectionMaterialId: cm.id,
              resourceId,
              resourceName: label,
              materialId,
              materialName: cleanMaterialName,
              categoryId,
              categoryName,
              finishing: finishingVal,
              colorId,
              colorName,
              colorHex,
              colorPantone,
            }
          })
          console.debug('[RC] familyTrimInsumoOptions populated:', trimOpts)
          setFamilyTrimInsumoOptions(trimOpts)
        }
      } catch (err) {
        console.error('Erro ao carregar dados da coleção:', err)
        if (!cancelled) {
          setCollectionEpisodes([])
          setFilteredFamilies([])
        }
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [formData.collectionId])

  const materiaPrimaOptions: any[] = useMemo(() => {
    const list: any[] = []
    const seenStockIds = new Set<number>()

    for (const c of familyConjuntos) {
      if (c.stockId) seenStockIds.add(Number(c.stockId))
      list.push({
        id: String(c.familyMaterialId),
        name: c.stockLabel || c.materialName,
        group: 'Materiais cadastrados na coleção',
        colorHex: c.colorHex,
        hex: c.colorHex,
        Pantone: c.colorPantone,
        pantone: c.colorPantone,
        familyMaterialId: c.familyMaterialId,
        materialId: c.materialId,
        materialName: c.materialName,
        stockId: c.stockId,
        finishing: c.finishing,
      })
    }

    for (const stock of allStocks) {
      if (!stock?.id || seenStockIds.has(Number(stock.id))) continue
      seenStockIds.add(Number(stock.id))

      const rawStockCode = stock?.Code?.code != null && String(stock.Code.code).trim() !== ''
        ? String(stock.Code.code)
        : stock?.code != null && String(stock.code).trim() !== ''
          ? String(stock.code)
          : stock?.codeId
            ? String(stock.codeId)
            : ''
      const stockCode = sanitizeCode(rawStockCode)
      const stockMaterialName = (stock?.Material?.name || stock?.material || '').trim()
      const colorName = (stock?.ItemColor?.name || stock?.color || '').trim()
      const parts: string[] = []
      if (stockCode) parts.push(stockCode)
      if (stockMaterialName) parts.push(stockMaterialName)
      if (colorName && colorName !== '—') parts.push(colorName)
      const label = parts.length > 0 ? parts.join(' - ') : (stockMaterialName || stock?.description || `Tecido #${stock.id}`)
      const colorHex = stock?.colorHex || stock?.ItemColor?.hex || stock?.ItemColor?.Pantone?.hex || stock?.Pantone?.hex || null
      const colorPantone = stock?.ItemColor?.Pantone || stock?.Pantone || stock?.pantone || null
      const finishing = getStockFinishing(stock)

      list.push({
        id: `s:${stock.id}`,
        name: label,
        group: 'Outros tecidos em estoque (não cadastrados na coleção)',
        colorHex,
        hex: colorHex,
        Pantone: colorPantone,
        pantone: colorPantone,
        familyMaterialId: null,
        materialId: stock.materialId || stock.Material?.id || 0,
        materialName: stockMaterialName || stock.Material?.name || stock.descricao || '',
        stockId: stock.id,
        finishing,
      })
    }

    return list
  }, [familyConjuntos, allStocks])

  const insumoOptions: any[] = useMemo(() => {
    const list: any[] = []
    const seenResourceIds = new Set<number>()

    for (const tr of familyTrimInsumoOptions) {
      if (tr.resourceId) seenResourceIds.add(Number(tr.resourceId))
      const optVal = tr.resourceId ? `r:${tr.resourceId}` : String(tr.familyMaterialId)
      list.push({
        id: optVal,
        name: tr.resourceName || tr.materialName,
        group: 'Insumos cadastrados na coleção',
        colorHex: tr.colorHex,
        hex: tr.colorHex,
        Pantone: tr.colorPantone,
        pantone: tr.colorPantone,
        resourceId: tr.resourceId,
        familyMaterialId: tr.familyMaterialId,
        materialId: tr.materialId,
        materialName: tr.materialName,
        finishing: tr.finishing,
      })
    }

    for (const r of allResources) {
      if (!r?.id || seenResourceIds.has(Number(r.id))) continue
      seenResourceIds.add(Number(r.id))

      const catName = (r as any).Category_Resource?.name || (r.categoryId ? allResourceCategories.find((c) => c.id === r.categoryId)?.name : null) || null
      const baseName = (r.name ? String(r.name) : '').trim()
      const desc = (r.description ? String(r.description) : '').trim()
      const rawCode = ((r as any).Code?.code != null && String((r as any).Code.code).trim() !== ''
        ? String((r as any).Code.code)
        : (r as any).code != null && String((r as any).code).trim() !== ''
          ? String((r as any).code)
          : (r as any).codeId
            ? String((r as any).codeId)
            : '')
      const code = sanitizeCode(rawCode)

      const parts: string[] = []
      if (code) parts.push(code)
      if (baseName) parts.push(baseName)
      if (desc && desc.toLowerCase() !== baseName.toLowerCase()) {
        parts.push(desc)
      }
      let label = parts.length > 0 ? parts.join(' - ') : (baseName || desc || `Insumo #${r.id}`)
      if (catName) {
        label = `${label} (${catName})`
      }
      const finishingVal = (r as any).Finishing?.type ? String((r as any).Finishing.type) : ((r as any).finishing ? String((r as any).finishing) : '—')
      const colorHex = (r as any).ItemColor?.hex || (r as any).ItemColor?.Pantone?.hex || null
      const colorPantone = (r as any).ItemColor?.Pantone || null
      const cleanMatName = ((r as any).Material?.name || baseName || desc || '').trim()

      list.push({
        id: `r:${r.id}`,
        name: label,
        group: 'Outros insumos cadastrados (não cadastrados na coleção)',
        colorHex,
        hex: colorHex,
        Pantone: colorPantone,
        pantone: colorPantone,
        resourceId: r.id,
        familyMaterialId: null,
        materialId: r.materialId ?? (r as any).Material?.id ?? 0,
        materialName: cleanMatName,
        finishing: finishingVal,
      })
    }

    return list
  }, [familyTrimInsumoOptions, allResources, allResourceCategories])

  useEffect(() => {
    if (!shouldHydrateFromSource || !sourceProductId) return

    const loadProduct = async () => {
      setIsInitializing(true)
      setProductExistingAttachments([])
      setProductAttachmentUrls([])

      try {
        const token = localStorage.getItem('token')
        const headers = { Authorization: `Bearer ${token}` }

        const res = await axios.get(`${FASHION_API_URL}/${sourceProductId}`, { headers })
        const product: ProductData = res.data

        const coverFileUrl = (product as any).CoverGeneralFile?.fileUrl
        const rawAttachmentRows = ((product as any).Attachments || []) as any[]
        const fashionAttachments = rawAttachmentRows
          .filter((row) => row?.GeneralFile?.fileUrl)
          .map((row, index) => {
            const url = row.GeneralFile.fileUrl as string
            const nameFromUrl = url.split('/').pop() || `anexo-${index + 1}`
            const decodedName = (() => {
              try {
                return decodeURIComponent(nameFromUrl)
              } catch {
                return nameFromUrl
              }
            })()
            const looksLikeImage = /\.(png|jpe?g|gif|bmp|webp|svg|avif|heic|heif|jfif)$/i.test(
              decodedName,
            )
            return {
              id: index + 1,
              originalName: decodedName,
              fileName: decodedName,
              filePath: url,
              fileUrl: url,
              fileSize: 0,
              mimeType: looksLikeImage ? 'image/jpeg' : '',
              isImage: looksLikeImage ? true : undefined,
              isCover: Boolean(coverFileUrl && url === coverFileUrl),
              coverScale: typeof row.coverScale === 'number' ? row.coverScale : null,
              coverPosX: typeof row.coverPosX === 'number' ? row.coverPosX : null,
              coverPosY: typeof row.coverPosY === 'number' ? row.coverPosY : null,
            }
          })

        applyProductAttachmentsState(fashionAttachments)

        rcDebug('=== PRODUTO CARREGADO ===')
        rcDebug('Product completo: ' + JSON.stringify(product, null, 2))
        rcDebug('Composition (back-end): ' + JSON.stringify(product.composition, null, 2))
        rcDebug('ProductItemColor entries (lowercase): ' + JSON.stringify(product.productItemColors || [], null, 2))
        rcDebug('ProductItemColor entries (uppercase): ' + JSON.stringify((product as any).ProductItemColor || [], null, 2))

        setProductData(product)

        const existingBeneficiamentoNotes: any[] = (product as any).BeneficiamentoNote || []
        if (existingBeneficiamentoNotes.length > 0) {
          const notesWithSignedUrls = await Promise.all(
            existingBeneficiamentoNotes.map(async (n: any) => {
              const noteUrls = (n.Files || []).map((f: any) => f.GeneralFile?.fileUrl).filter(Boolean) as string[]
              const author = n.createdByName || n.CreatedByUser?.name || ''
              const updatedAuthor = n.updatedByName || n.UpdatedByUser?.name || ''
              return {
                ...newBeneficiamentoNota(n.sectorId, author),
                id: n.id,
                sectorId: n.sectorId,
                description: n.description || '',
                imageOriginalUrls: noteUrls,
                imageUrls: await resolveNoteImageUrls(noteUrls),
                createdByIdUser: n.createdByIdUser ?? n.CreatedByUser?.id ?? null,
                updatedByIdUser: n.updatedByIdUser ?? n.UpdatedByUser?.id ?? null,
                createdByName: author,
                updatedByName: updatedAuthor,
                CreatedByUser: n.CreatedByUser,
                UpdatedByUser: n.UpdatedByUser,
                createdAt: n.createdAt,
                updatedAt: n.updatedAt,
              }
            })
          )
          setBeneficiamentoNotes(notesWithSignedUrls)
          setInitialBeneficiamentoNotes(notesWithSignedUrls)
        }

        originalVariationCodeRef.current = product.productCode || ''

        setFormData({
          codigo: isVariationMode ? '' : (product.productCode || ''),
          nomeProduto: product.name || '',
          description: product.description || '',
          referenceProduct: product.referenceProduct || '',
          observations: product.observations || '',
          supplierCode: (product as any).supplierCode || '',
          clientIdentification: (product as any).clientIdentification || '',
          collectionId: product.collectionId || 0,
          familyId: product.familyId || 0,
          groupId: product.groupId || 0,
          episodeId: (product as any).episodeId ?? (product as any).Episode?.id ?? 0,
          price: (product as any).price ?? (product as any).finalPrice ?? 0,
          ncmId: (product as any).ncmId ?? (product as any).Ncm?.id ?? 0,
          unitOfMeasurementId: (product as any).unitOfMeasurementId ?? (product as any).UnitOfMeasurement?.id ?? 0,
        });
        setNcm(ncmSelecionado((product as any).ncmId ?? (product as any).Ncm?.id, (product as any).Ncm?.ncm ?? (product as any).ncm));

        if (isEditMode) {
          initialEditFamilyIdRef.current = product.familyId || null
        }

        setTimeout(() => {
          setFormData(prev => ({
            ...prev,
            groupId: product.groupId || 0
          }));

          if (product.groupId) {
            setFilteredGroups(prev => {
              if (!prev.some(g => g.id === product.groupId)) {
                return [...prev, {
                  id: product.groupId,
                  name: product.Group?.name || `Grupo ${product.groupId}`
                }];
              }
              return prev;
            });
          }

          console.log('DEBUG FORM DATA ATUALIZADO:', {
            groupId: product.groupId,
            groupName: product.Group?.name,
            filteredGroups: filteredGroups,
            filteredGroupsLength: filteredGroups.length
          });
        }, 100);

        console.log('DEBUG GRADES - gradeIds do produto:', product.gradeInProduct?.map(g => g.gradeId) || []);
        console.log('DEBUG GRADES - availableGradeIds:', availableGradeIds);
        console.log('DEBUG GRADES - product.gradeInProduct:', product.gradeInProduct);

        if (product.gradeInProduct?.length || (product as any).GradeInProduct?.length) {
          const gradeInProduct = product.gradeInProduct || (product as any).GradeInProduct || [];
          if (gradeInProduct.length > 0) {
            const firstGradeData = gradeInProduct[0];

            const firstGrade = firstGradeData.grade || firstGradeData.Grade;
            const typeId = firstGrade?.GraduationType?.id || firstGrade?.type?.id || firstGradeData.grade?.GraduationType?.id;
            if (typeId) setSelectedGradeType(typeId);
          }
        }

        const buildScriptStockLabel = (stk: any, fallbackMaterialName?: string | null) => {
          if (!stk) return ''
          const matName = (stk?.Material?.name || fallbackMaterialName || '').trim()
          const desc = (stk?.description ? String(stk.description) : '').trim()
          const rawCode = (stk?.Code?.code != null && String(stk.Code.code).trim() !== ''
            ? String(stk.Code.code)
            : stk?.code != null && String(stk.code).trim() !== ''
              ? String(stk.code)
              : stk?.codeId
                ? String(stk.codeId)
                : '')
          const code = sanitizeCode(rawCode)

          const parts: string[] = []
          if (code) parts.push(code)
          if (matName) parts.push(matName)
          if (desc && desc.toLowerCase() !== matName.toLowerCase()) {
            parts.push(desc)
          }
          return parts.join(' - ') || `Stock #${stk?.id ?? ''}`
        }

        let itemIdCounter = 1;
        let loadedResources = allResourcesRef.current;
        if (!loadedResources || loadedResources.length === 0) {
          try {
            const resR = await axios.get(`${FASHION_API_URL}/resources`, { headers });
            loadedResources = Array.isArray(resR.data) ? resR.data : [];
            setAllResources(loadedResources);
            allResourcesRef.current = loadedResources;
          } catch (err) {
            console.error('Erro ao carregar resources no loadProduct:', err);
          }
        }

        if (product.Script?.length) {
          const items = product.Script.flatMap((script: any) => {
            const scriptItems: any[] = [];

            if (script.ScriptMaterial?.length) {
              script.ScriptMaterial.forEach((sm: any) => {
                if (sm.Material?.id || sm.materialId || sm.Stock || sm.stockId) {
                  const material = sm.Material || null;
                  const persistedStock = sm.Stock || null;
                  const fallbackStock = material?.Stock?.[0] || null;
                  const stockForLocation = persistedStock || fallbackStock;
                  const stockIdValue = sm.stockId ?? persistedStock?.id ?? null;
                  const matId = material?.id ?? sm.materialId ?? null;
                  const matName = material?.name || persistedStock?.description || '';
                  const descricao = persistedStock
                    ? buildScriptStockLabel(persistedStock, material?.name)
                    : (matName || '');

                  scriptItems.push({
                    id: itemIdCounter++,
                    tipo: 'materia-prima' as const,
                    materialId: matId,
                    stockId: stockIdValue,
                    resourceId: null,
                    categoryId: null,
                    descricao,
                    unidadeMedida: sm.UnitOfMeasurement?.name || '',
                    unitOfMeasurementId: sm.unitOfMeasurementId || null,
                    localEstoque: stockForLocation?.StockLocation?.name || '',
                    skinSize: sm.skinSize != null ? String(sm.skinSize) : '',
                    consumo: sm.weight?.toString() || sm.idealMeasurements?.toString() || '',
                    costPerUnit: scriptCostPerUnitToInput(sm.costPerUnit),
                    finishing: getStockFinishing(persistedStock || fallbackStock) || (material?.Finishing?.type ? String(material.Finishing.type) : (material?.finishing ? String(material.finishing) : '—')),
                    availableVariations: [],
                    colorMappings: [],
                    sizeRange: (sm.ScriptMaterialGrade ?? []).map((g: any) => g.gradeId),
                  });
                }
              });
            }


            if (script.ScriptResource?.length) {
              script.ScriptResource.forEach((sr: any) => {
                if (sr.Resource?.id) {
                  const resource = sr.Resource;

                  let derivedMaterialId: number | null = resource.materialId ?? null;
                  let derivedCategoryId: number | null = resource.categoryId ?? null;
                  if (!derivedMaterialId) {
                    const found = (loadedResources || []).find((r) => r.id === resource.id);
                    if (found) {
                      derivedMaterialId = found.materialId ?? derivedMaterialId;
                      derivedCategoryId = found.categoryId ?? derivedCategoryId;
                    }
                  }

                  const persistedStock = sr.Stock || null;
                  const stockIdValue = sr.stockId ?? persistedStock?.id ?? null;

                  scriptItems.push({
                    id: itemIdCounter++,
                    tipo: 'insumo' as const,
                    materialId: derivedMaterialId,
                    stockId: stockIdValue,
                    resourceId: resource.id,
                    categoryId: derivedCategoryId,
                    descricao: resource.name || resource.description || '',
                    unidadeMedida: sr.UnitOfMeasurement?.name || (resource as any).UnitOfMeasurement?.name || '',
                    unitOfMeasurementId: sr.unitOfMeasurementId || (resource as any).unitOfMeasurementId || null,
                    localEstoque: '',
                    skinSize: sr.skinSize != null ? String(sr.skinSize) : '',
                    consumo: sr.weight?.toString() || '',
                    costPerUnit: scriptCostPerUnitToInput(sr.costPerUnit),
                    finishing: resource.Finishing?.type ? String(resource.Finishing.type) : (resource.finishing ? String(resource.finishing) : '—'),
                    availableVariations: [],
                    colorMappings: [],
                    sizeRange: (sr.ScriptResourceGrade ?? []).map((g: any) => g.gradeId),
                  });
                }
              });
            }

            if (script.ScriptStage?.length) {
              script.ScriptStage.forEach((st: any) => {
                if (st.Stage?.id) {
                  const stage = st.Stage;
                  scriptItems.push({
                    id: itemIdCounter++,
                    tipo: 'servico' as const,
                    materialId: null,
                    stockId: null,
                    resourceId: null,
                    stageId: stage.id,
                    categoryId: null,
                    descricao: stage.name || stage.description || '',
                    unidadeMedida: st.UnitOfMeasurement?.name || '',
                    unitOfMeasurementId: st.unitOfMeasurementId || null,
                    localEstoque: '',
                    consumo: st.deliveryTime || '',
                    costPerUnit: scriptCostPerUnitToInput(st.costPerUnit),
                    availableVariations: [],
                    colorMappings: [],
                  });
                }
              });
            }

            return scriptItems;
          });

          console.log('Items de composição criados a partir do Script:', items);

          const serverColors: any[] =
            (product as any).productItemColors ||
            (product as any).ProductItemColor ||
            [];
          rcDebug('[RC] serverColors do produto: ' + JSON.stringify(serverColors, null, 2));
          console.debug('[RC] serverColors with StockColors info', serverColors.map(sc => ({
            id: sc.id,
            stockColorId: sc.stockColorId,
            stockInfo: sc.StockColors ? { stockId: sc.StockColors.stockId, materialId: sc.StockColors.Stock?.materialId } : null
          })));

          setAllItemColors(prev => {
            const extras: { id: number; name: string }[] = [];
            serverColors.forEach((sc: any) => {
              let name: string | null = null;
              let id: number | null = null;
              if (sc.Stock?.ItemColor?.name) {
                name = sc.Stock.ItemColor.name;
                id = sc.Stock.ItemColor.id ?? sc.Stock.itemColorId;
              } else if (sc.Resource?.ItemColor?.name) {
                name = sc.Resource.ItemColor.name;
                id = sc.Resource.ItemColor.id ?? sc.Resource.itemColorId;
              } else if (sc.ItemColor?.name) {
                name = sc.ItemColor.name;
                id = sc.itemColorId;
              }
              if (name && id != null && !prev.some(c => c.id === id) && !extras.some(c => c.id === id)) {
                extras.push({ id, name });
              }
            });
            return extras.length ? [...prev, ...extras] : prev;
          });
          const uniqueCollectionColorIds = Array.from(
            new Set(serverColors.map((sc: any) => sc.collectionColorId).filter(Boolean)),
          );

          const assignedServerColorIds = new Set<number>();
          let itemsWithColors = items.map((item) => {
            const itemColors: ProductItemColorEntry[] = [];

            for (const colId of uniqueCollectionColorIds) {
              const pc = serverColors.find((candidate: any) => {
                if (candidate.id && assignedServerColorIds.has(candidate.id)) return false;
                if (candidate.collectionColorId !== colId) return false;

                if (item.tipo === 'materia-prima') {
                  if (candidate.resourceId && !candidate.stockId && !candidate.materialId) return false;
                  if (item.stockId && (candidate.stockId === item.stockId || candidate.Stock?.id === item.stockId)) return true;
                  if (item.materialId && (candidate.Stock?.materialId === item.materialId || candidate.materialId === item.materialId)) return true;
                  return false;
                }
                if (item.tipo === 'insumo') {
                  if (item.resourceId && (candidate.resourceId === item.resourceId || candidate.Resource?.id === item.resourceId)) return true;
                  if (item.materialId && (candidate.Resource?.materialId === item.materialId || candidate.materialId === item.materialId)) return true;
                  return false;
                }
                return false;
              });

              if (pc) {
                if (pc.id) assignedServerColorIds.add(pc.id);
                const resolvedItemColorId =
                  pc.Stock?.ItemColor?.id ??
                  pc.Stock?.itemColorId ??
                  pc.Resource?.ItemColor?.id ??
                  pc.Resource?.itemColorId ??
                  pc.itemColorId ??
                  null;

                itemColors.push({
                  id: pc.id,
                  collectionColorId: pc.collectionColorId,
                  itemColorId: resolvedItemColorId,
                  itemColorName: pc.Stock?.ItemColor?.name ?? pc.Resource?.ItemColor?.name ?? null,
                  materialId: item.materialId ?? pc.materialId,
                  resourceId: item.tipo === 'insumo' ? (pc.resourceId || (pc.Resource ? pc.Resource.id : null)) : null,
                  stockId: item.tipo === 'materia-prima' ? (pc.stockId || pc.Stock?.id || null) : null,
                });
              }
            }

            return {
              ...item,
              productItemColors: itemColors,
            } as CompositionItem & { stockId?: number };
          });

          itemsWithColors = await Promise.all(itemsWithColors.map(async (it) => {
            if (it.tipo === 'materia-prima') {
              if (!it.stockId && it.materialId) {
                try {
                  const token = localStorage.getItem('token')
                  const headers = token ? { Authorization: `Bearer ${token}` } : {}
                  const res = await axios.get(`${FASHION_API_URL}/stocks`, { headers, params: { materialId: it.materialId } })
                  const stocks: any[] = Array.isArray(res.data) ? res.data : []
                  if (stocks.length > 0) {
                    it.stockId = stocks[0].id
                  }
                } catch (e) {
                  console.error('erro ao buscar stock para material (edição)', e)
                }
              }

              if (it.stockId && !it.materialId) {
                try {
                  const token = localStorage.getItem('token')
                  const headers = token ? { Authorization: `Bearer ${token}` } : {}
                  const res = await axios.get(`${FASHION_API_URL}/stocks/${it.stockId}`, { headers })
                  if (res.data && res.data.materialId) {
                    it.materialId = res.data.materialId
                  }
                } catch (e) {
                  console.error('erro ao buscar material a partir do stock (edição)', e)
                }
              }
            } else if (it.tipo === 'insumo') {
              if (it.resourceId && !it.materialId) {
                const matchTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId === it.resourceId)
                const matchRes = (allResourcesRef.current || []).find((r) => r.id === it.resourceId)
                const resolved = matchTrim?.materialId ?? matchRes?.materialId ?? (matchRes as any)?.Material?.id ?? null
                if (resolved) {
                  it.materialId = resolved
                }
              }
            }
            return it
          }));

          rcDebug('Items de composição após anexar cores do servidor: ' + JSON.stringify(itemsWithColors, null, 2));
          setCompositionItems(itemsWithColors);
          rcDebug('[RC] composição inicializada (itemsWithColors): ' + JSON.stringify(itemsWithColors, null, 2));

          (async () => {
            const enriched = await Promise.all(itemsWithColors.map(async (it) => {
              let variations: any[] = [];
              if (it.tipo === 'materia-prima') {
                const stockIds = new Set<number>();

                if (it.stockId) stockIds.add(it.stockId);
                (it.productItemColors || []).forEach((pc: any) => {
                  if (pc.stockId) stockIds.add(pc.stockId);
                  else if (pc.StockColors?.stockId) stockIds.add(pc.StockColors.stockId);
                });

                if (stockIds.size) {
                  for (const sid of stockIds) {
                    const vs = await fetchStockColors(sid);
                    variations.push(...vs);
                  }
                } else if (it.materialId) {
                  variations = await fetchStockColors(undefined, it.materialId);
                }

                variations = variations.filter((v, i, a) => a.findIndex(x => x.id === v.id) === i);
              } else if (it.resourceId) {
                variations = await fetchResourceColors(it.resourceId);
              }

              const mapped = variations.map(v => ({
                id: v.id,
                colorId: v.colorId,
                stockId: it.stockId || null,
                resourceId: it.resourceId || null,
                color: { id: v.id, name: v.color.name },
                stock: null,
                resource: null,
              }));

              setAllVariations(prev => {
                const combined = [...prev];
                mapped.forEach(m => { if (!combined.some(x => x.id === m.id)) combined.push(m); });
                return combined;
              });

              const colorMappings = mapped.map(m => {
                let selectedVariation: number | null = null;
                if (it.productItemColors && Array.isArray(it.productItemColors)) {
                  const matching = it.productItemColors.find((pc: any) =>
                    (pc.itemColorId && (pc.itemColorId === m.id || pc.itemColorId === m.colorId)) ||
                    (pc.itemColorName && pc.itemColorName === m.color?.name)
                  );
                  if (matching) selectedVariation = m.id;
                }
                return {
                  mainVariationId: m.id,
                  mainColorName: m.color.name,
                  itemVariationId: selectedVariation,
                };
              });

              console.debug('[RC] item', it.id, 'variations', mapped, 'mappings', colorMappings);

              return {
                ...it,
                availableVariations: mapped,
                colorMappings,
              };
            }));
            setCompositionItems(enriched);
            rcDebug('[RC] composição enriquecida com variações por item: ' + JSON.stringify(enriched, null, 2));
          })();

          if (product.Script) {
            const allColorIds: number[] = [];
            const colorMap: Record<number, string> = {};

            product.Script.forEach(script => {
              if (script.ScriptMaterial) {
                script.ScriptMaterial.forEach(sm => {
                  if (sm.Material?.Stock) {
                    sm.Material.Stock.forEach(stock => {
                      if (stock.StockColors) {
                        stock.StockColors.forEach(sc => {
                          if (!allColorIds.includes(sc.id)) {
                            allColorIds.push(sc.id);
                          }

                          if (sc.ItemColor?.name) {
                            colorMap[sc.id] = sc.ItemColor.name;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });

            const pics = ((product as any).ProductItemColor || []) as any[];
            pics.forEach(pic => {
              if (pic.stockColorId && typeof pic.stockColorId === 'number') {

                if (!allColorIds.includes(pic.stockColorId)) {
                  allColorIds.push(pic.stockColorId);
                }
              }
            });

            rcDebug('DEBUG CORES - Cores encontradas no Script: ' + JSON.stringify(allColorIds));
            rcDebug('DEBUG CORES - Mapa de cores: ' + JSON.stringify(colorMap));
            rcDebug('[RC] baseFabricColors candidatos: ' + JSON.stringify(allColorIds.map(id => {
              const varRec = allVariations.find(v => v.id === id);
              return {
                variationId: id,
                colorId: varRec ? varRec.colorId : id,
                colorName: colorMap[id] || `Cor ${id}`,
              };
            }), null, 2));

            if (allColorIds.length > 0) {
              setSelectedStockColorIds(allColorIds);
            }
          }
        } else {
          rcDebug('[RC] produto sem Script (composição) no retorno da API.');

          const variations = (product as any).composition?.variations || [];
          rcDebug('[RC] product.composition.variations (fallback): ' + JSON.stringify(variations, null, 2));

          if (variations.length) {
            const items = variations.map((v: any) => {
              const isMateriaPrima = Boolean(v.stockId);
              return {
                id: itemIdCounter++,
                tipo: isMateriaPrima ? 'materia-prima' as const : 'insumo' as const,
                materialId: v.stock?.materialId ?? null,
                stockId: v.stockId ?? null,
                resourceId: v.resourceId ?? null,
                categoryId: null,
                descricao: v.description || '',
                unidadeMedida: '',
                unitOfMeasurementId: null,
                localEstoque: v.stockLocation || '',
                consumo: v.usage != null ? String(v.usage) : '',
                finishing: isMateriaPrima ? getStockFinishing(v.stock) : (v.resource?.Finishing?.type ? String(v.resource.Finishing.type) : (v.resource?.finishing ? String(v.resource.finishing) : '—')),
                availableVariations: [],
                colorMappings: [],
              };
            });
            console.debug('[RC] Items de composição criados a partir de product.composition:', items);
            setCompositionItems(items);
          } else {
            rcDebug('[RC] product.composition também vazio - nenhuma composição carregada.');
          }
        }

        setTimeout(() => {
          setFormData(prev => ({
            ...prev,
            groupId: product.groupId || 0
          }));
        }, 100);
        setIsInitializing(false)
        initializationCompletedRef.current = true
      } catch (error) {
        console.error('Erro ao carregar produto:', error)
        setFeedback({
          isOpen: true,
          statusOk: false,
          message: 'Erro ao carregar dados do produto.',
        })
        setIsInitializing(false)
      }
    }

    loadProduct();

    return () => {
      isInitialLoadRef.current = true
      initializationCompletedRef.current = false
    }
  }, [shouldHydrateFromSource, sourceProductId]);

  useEffect(() => {
    if (!shouldHydrateFromSource || !productData) return
    if (!allCollectionColors || allCollectionColors.length === 0) return

    try {
      const productColors = (productData as any).ProductItemColor || []
      const collectionColorIds: number[] = productColors
        .map((pc: any) => pc.collectionColorId)
        .filter((id: any) => id !== null && id !== undefined)
      const uniqueIds = Array.from(new Set(collectionColorIds))

      const selected = uniqueIds.map(id => {
        const found = allCollectionColors.find(c => Number(c.id) === Number(id));
        if (found) return found;

        const pic = (productData as any)?.ProductItemColor?.find((p: any) => p.collectionColorId === id);
        const name = pic?.ItemColor?.name || pic?.ResourceColor?.ItemColor?.name || pic?.stockColorId &&
          (pic.ItemColor?.name || `Cor ${pic.stockColorId}`) || `Cor ${id}`;
        return { id, name };
      });

      if (selected.length > 0) {
        setSelectedCollectionColors(selected);
      }
    } catch (err) {
      console.error('Erro ao popular selectedCollectionColors no modo edição:', err)
    }
  }, [shouldHydrateFromSource, productData, allCollectionColors])



  useEffect(() => {
    if (!shouldHydrateFromSource) return;

    if (selectedGradeIds.length > 0 && availableGradeIds.length > 0) {
      selectedGradeIds.forEach(gradeId => {
        const gradeDetail = Array.isArray(availableGradeIds) && typeof availableGradeIds[0] === 'object'
          ? availableGradeIds.find((g: any) => g.id === gradeId)
          : null;

        if (gradeDetail && typeof gradeDetail !== 'number') {
          console.log(`DEBUG GRADES - Informações completas da grade ${gradeId}:`, {
            id: (gradeDetail as any).id,
            name: (gradeDetail as any).name,
            typeId: (gradeDetail as any).typeId,
            typeName: (gradeDetail as any).GraduationType?.name || (gradeDetail as any).type?.name || 'Tipo não encontrado'
          });
        } else {

          if (Array.isArray(availableGradeIds) && typeof availableGradeIds[0] === 'number') {
            console.log(`DEBUG GRADES - Grade ${gradeId} está na lista de IDs disponíveis`);
          } else {
            console.log(`DEBUG GRADES - Grade ${gradeId} não encontrada em availableGradeIds`);
          }
        }
      });
    }
  }, [shouldHydrateFromSource, selectedGradeIds, availableGradeIds]);




  useEffect(() => {
    if (!shouldHydrateFromSource || !productData) {
      return;
    }

    if (!availableGradeIds || availableGradeIds.length === 0) {
      const timer = setTimeout(() => {
        if (productData && availableGradeIds && availableGradeIds.length > 0) {

          const gradeInProduct = productData.gradeInProduct || (productData as any).GradeInProduct || [];

          if (gradeInProduct?.length) {
            const gradeIdsFromProduct = gradeInProduct.map((g: any) => {
              const gradeId = g.gradeId || (g.Grade ? g.Grade.id : g.gradeId);
              return gradeId;
            }).filter(Boolean);

            const validGradeIds = gradeIdsFromProduct.filter((gradeId: number) => {
              const isIncluded = availableGradeIds.some((g: any) => {
                const id = typeof g === 'object' ? g.id : g;
                return id === gradeId;
              });
              return isIncluded;
            });

            if (validGradeIds.length > 0) {
              const validGradeObjects = validGradeIds.map((gradeId: number) => {
                const gradeObj = availableGradeIds.find((g: any) => {
                  const id = typeof g === 'object' ? g.id : g;
                  return id === gradeId;
                });
                return gradeObj || gradeId;
              });

              setSelectedGradeIds(validGradeObjects);

              if (validGradeObjects.length > 0) {
                const firstGrade = validGradeObjects[0];
                if (typeof firstGrade === 'object' && firstGrade !== null) {
                  const gradeAsAny = firstGrade as any;
                  const gradeType = gradeAsAny.GraduationType?.id || gradeAsAny.typeId;
                  if (gradeType) {
                    setSelectedGradeType(gradeType);
                  }
                }
              }
            }
          }
        }
      }, 100);

      return () => clearTimeout(timer);
    }

    const gradeInProduct = productData.gradeInProduct || (productData as any).GradeInProduct || [];

    if (gradeInProduct?.length) {
      const gradeIdsFromProduct = gradeInProduct.map((g: any) => {
        const gradeId = g.gradeId || (g.Grade ? g.Grade.id : g.gradeId);
        return gradeId;
      }).filter(Boolean);

      const validGradeIds = gradeIdsFromProduct.filter((gradeId: number) => {
        const isIncluded = availableGradeIds.some((g: any) => {
          const id = typeof g === 'object' ? g.id : g;
          return id === gradeId;
        });
        return isIncluded;
      });

      if (validGradeIds.length > 0) {
        const validGradeObjects = validGradeIds.map((gradeId: number) => {
          const gradeObj = availableGradeIds.find((g: any) => {
            const id = typeof g === 'object' ? g.id : g;
            return id === gradeId;
          });
          return gradeObj || gradeId;
        });

        setSelectedGradeIds(validGradeObjects);

        if (validGradeObjects.length > 0) {
          const firstGrade = validGradeObjects[0];
          if (typeof firstGrade === 'object' && firstGrade !== null) {
            const gradeAsAny = firstGrade as any;
            const gradeType = gradeAsAny.GraduationType?.id || gradeAsAny.typeId;
            if (gradeType) {
              setSelectedGradeType(gradeType);
            }
          }
        }
      }
    }
  }, [shouldHydrateFromSource, productData, availableGradeIds]);


  useEffect(() => {
    const previousLength = selectedCollectionColorsPrevLength.current
    const currentLength = selectedCollectionColors.length

    if (currentLength > 0 && previousLength === 0) {
      const el = document.getElementById('composition-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }

    selectedCollectionColorsPrevLength.current = currentLength

    if (!currentLength) {
      setCompositionItems(prev =>
        prev.map(item => ({ ...item, productItemColors: [] })),
      )
      return
    }

    setCompositionItems(prev => prev.map(item => {
      const prevArr: ProductItemColorEntry[] = item.productItemColors ? [...item.productItemColors] : []

      selectedCollectionColors.forEach(col => {
        if (!prevArr.some(p => p.collectionColorId === col.id)) {
          prevArr.push({ collectionColorId: col.id, itemColorId: null })
        }
      })

      const filtered = prevArr.filter(p => selectedCollectionColors.some(sc => sc.id === p.collectionColorId))
      return { ...item, productItemColors: filtered }
    }))
  }, [selectedCollectionColors])




  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    markUserDirty()
    const { name, value } = e.target
    if (name === 'familyId') {
      setFormData((prev) => ({
        ...prev,
        familyId: Number(value),
      }))
      return
    }

    const isNumericIdField = name.endsWith('Id') && name !== 'clientIdentification'

    setFormData((prev) => ({
      ...prev,
      [name]: isNumericIdField ? (value === '' ? 0 : Number(value)) : value,
    }))
  }

  const handleGradeTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    markUserDirty()
    const typeId = Number(e.target.value)
    setSelectedGradeType(typeId || null)
    setSelectedGradeIds([])
  }

  const handleGradeToggle = (gradeId: number) => {
    if (!availableGradeIds.includes(gradeId)) return
    markUserDirty()

    setSelectedGradeIds((prev) =>
      prev.includes(gradeId) ? prev.filter((id) => id !== gradeId) : [...prev, gradeId]
    )
  }



  const handleStockColorSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const stockId = Number(e.target.value)
    if (!stockId) return
    markUserDirty()
    const stock = conjuntoStocks.find(s => s.id === stockId)
    if (!stock) return
    const scIds: number[] = (stock.StockColors || []).map((sc: any) => sc.id)
    setSelectedStockColorIds(prev => Array.from(new Set([...prev, ...scIds])))
  }

  const removeStockColor = (stockId: number) => {
    markUserDirty()
    setSelectedStockColorIds(selectedStockColorIds.filter(id => id !== stockId))
  }

  const addCompositionItem = () => {
    markUserDirty()
    const newId = compositionItems.length > 0 ? Math.max(...compositionItems.map((i) => i.id)) + 1 : 1
    const hasMaterialItem = compositionItems.some((i) => i.tipo === 'materia-prima')
    const isFirst = compositionItems.length === 0

    setCompositionItems([
      ...compositionItems,
      {
        id: newId,
        tipo: isFirst && !hasMaterialItem ? 'materia-prima' : 'insumo',
        stockId: null,
        resourceId: null,
        categoryId: null,
        descricao: '',
        unidadeMedida: '',
        unitOfMeasurementId: null,
        localEstoque: '',
        skinSize: '',
        consumo: '',
        costPerUnit: '',
        finishing: null,
        availableVariations: [],
        sizeRange: [],
        productItemColors: selectedCollectionColors.map(c => ({ collectionColorId: c.id, itemColorId: null })),
      },
    ])
  }

  const removeCompositionItem = (id: number) => {
    markUserDirty()
    setCompositionItems(compositionItems.filter((item) => item.id !== id))
  }

  const handleSizeRangeToggle = (itemId: number, gradeId: number) => {
    markUserDirty()
    setCompositionItems(prev => prev.map(item =>
      item.id === itemId
        ? {
          ...item,
          sizeRange: (item.sizeRange ?? []).includes(gradeId)
            ? (item.sizeRange ?? []).filter(g => g !== gradeId)
            : [...(item.sizeRange ?? []), gradeId],
        }
        : item
    ))
  }

  const handleCompositionTypeChange = (itemId: number, tipo: 'materia-prima' | 'insumo' | 'servico' | '') => {
    markUserDirty()
    setCompositionItems((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? {
            ...item,
            tipo,
            materialId: null,
            stockId: null,
            resourceId: null,
            stageId: null,
            categoryId: null,
            descricao: '',
            unidadeMedida: '',
            skinSize: '',
            consumo: '',
            costPerUnit: '',
            finishing: null,
            availableVariations: [],
            productItemColors: item.productItemColors,
          }
          : item
      )
    )
  }

  const handleMaterialSelectChange = (itemId: number, val: string) => {
    markUserDirty()
    if (!val) {
      setCompositionItems((prev) =>
        prev.map((ci) =>
          ci.id === itemId
            ? {
              ...ci,
              materialId: null,
              stockId: null,
              descricao: '',
              finishing: null,
              productItemColors: [],
            }
            : ci,
        ),
      )
      return
    }

    if (val.startsWith('s:')) {
      const targetStockId = Number(val.replace('s:', ''))
      const stock = allStocks.find((s) => Number(s.id) === targetStockId)
      if (stock) {
        const rawStockCode = stock?.Code?.code != null && String(stock.Code.code).trim() !== ''
          ? String(stock.Code.code)
          : stock?.code != null && String(stock.code).trim() !== ''
            ? String(stock.code)
            : stock?.codeId
              ? String(stock.codeId)
              : ''
        const stockCode = sanitizeCode(rawStockCode)
        const stockMaterialName = (stock?.Material?.name || stock?.material || '').trim()
        const colorName = (stock?.ItemColor?.name || stock?.color || '').trim()
        const parts: string[] = []
        if (stockCode) parts.push(stockCode)
        if (stockMaterialName) parts.push(stockMaterialName)
        if (colorName && colorName !== '—') parts.push(colorName)
        const label = parts.length > 0 ? parts.join(' - ') : (stockMaterialName || stock?.description || `Tecido #${stock.id}`)
        const colorId = stock?.ItemColor?.id ?? stock?.itemColorId ?? null
        const resolvedMaterialId = stock.materialId || stock.Material?.id || null

        if (colorId && colorName) {
          setAllItemColors((prev) => {
            if (!prev.some((c) => Number(c.id) === Number(colorId))) {
              return [
                ...prev,
                {
                  id: Number(colorId),
                  name: String(colorName),
                  hex: stock.colorHex || stock.ItemColor?.hex || stock.ItemColor?.Pantone?.hex,
                  pantone: stock.ItemColor?.Pantone || stock.pantone,
                },
              ]
            }
            return prev
          })
        }

        setCompositionItems((prev) =>
          prev.map((ci) => {
            if (ci.id !== itemId) return ci
            const updatedProductItemColors = (ci.productItemColors || []).map((pic) => {
              if (selectedCollectionColors.length === 1 || !pic.itemColorId) {
                return {
                  ...pic,
                  itemColorId: colorId ? Number(colorId) : pic.itemColorId,
                  itemColorName: colorName || pic.itemColorName,
                  stockId: stock.id,
                  materialId: resolvedMaterialId || pic.materialId,
                }
              }
              return pic
            })
            return {
              ...ci,
              tipo: 'materia-prima',
              materialId: resolvedMaterialId,
              stockId: stock.id,
              descricao: label,
              finishing: getStockFinishing(stock) || null,
              productItemColors: updatedProductItemColors,
            }
          }),
        )
      }
      return
    }

    if (val.startsWith('m:')) {
      const matId = Number(val.replace('m:', ''))
      const matchingConjuntos = familyConjuntos.filter((c) => c.materialId === matId)
      const matchingStock = allStocks.find((s) => Number(s.materialId) === matId)
      const matName = matchingConjuntos[0]?.materialName || matchingStock?.Material?.name || matchingStock?.material || ''
      const finishing = matchingConjuntos[0]?.finishing || (matchingStock ? getStockFinishing(matchingStock) : null)

      setCompositionItems((prev) =>
        prev.map((ci) => {
          if (ci.id !== itemId) return ci
          return {
            ...ci,
            tipo: 'materia-prima',
            materialId: matId,
            stockId: matchingConjuntos[0]?.stockId ?? matchingStock?.id ?? null,
            descricao: matName || ci.descricao,
            finishing: finishing ?? ci.finishing,
          }
        }),
      )
      return
    }

    if (val.startsWith('d:')) {
      return
    }

    const familyMaterialId = Number(val)
    const conjunto = familyConjuntos.find((c) => c.familyMaterialId === familyMaterialId)
    if (conjunto) {
      if (conjunto.colorId && conjunto.colorName) {
        setAllItemColors((prev) => {
          if (!prev.some((c) => Number(c.id) === Number(conjunto.colorId))) {
            return [...prev, { id: Number(conjunto.colorId), name: String(conjunto.colorName) }]
          }
          return prev
        })
      }

      setCompositionItems((prev) =>
        prev.map((ci) => {
          if (ci.id !== itemId) return ci
          const updatedProductItemColors = (ci.productItemColors || []).map((pic) => {
            if (selectedCollectionColors.length === 1 || !pic.itemColorId) {
              return {
                ...pic,
                itemColorId: conjunto.colorId ? Number(conjunto.colorId) : pic.itemColorId,
                itemColorName: conjunto.colorName || pic.itemColorName,
                stockId: conjunto.stockId ?? pic.stockId,
                materialId: conjunto.materialId || pic.materialId,
              }
            }
            return pic
          })
          return {
            ...ci,
            tipo: 'materia-prima',
            materialId: conjunto.materialId,
            stockId: conjunto.stockId ?? null,
            descricao: conjunto.stockLabel || conjunto.materialName,
            finishing: conjunto.finishing || null,
            productItemColors: updatedProductItemColors,
          }
        }),
      )
    }
  }

  const handleInsumoSelectChange = (itemId: number, val: string) => {
    markUserDirty()
    if (!val) {
      setCompositionItems((prev) =>
        prev.map((ci) =>
          ci.id === itemId
            ? {
              ...ci,
              resourceId: null,
              materialId: null,
              categoryId: null,
              descricao: '',
              finishing: null,
              productItemColors: [],
            }
            : ci,
        ),
      )
      return
    }

    if (val.startsWith('d:')) {
      return
    }

    handleInsumoGroupSelect(itemId, val)
  }

  const handleServiceSelect = (itemId: number, stageId: number) => {
    markUserDirty()
    const stage = allServices.find(s => s.id === stageId)
    setCompositionItems((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? {
            ...item,
            tipo: 'servico',
            stageId,
            materialId: null,
            stockId: null,
            resourceId: null,
            categoryId: null,
            descricao: stage?.name || item.descricao,
            availableVariations: [],
            productItemColors: item.productItemColors,
          }
          : item
      )
    )
  }


  const handleProductAttachmentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || [])
    if (!files.length) return
    markUserDirty()

    const valid: File[] = []
    const invalid: File[] = []
    for (const file of files) {
      if (isProductImageFile(file) || isAllowedDocumentUpload(file)) {
        valid.push(file)
      } else {
        invalid.push(file)
      }
    }

    if (valid.length > 0) {
      setProductSelectedFiles((prev) => [...prev, ...valid])
    }

    if (invalid.length > 0) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message:
          invalid.length === 1
            ? `Tipo de arquivo não permitido: ${invalid[0].name}. Use imagens ou documentos (PDF, Office, TXT, CSV, RTF).`
            : `${invalid.length} arquivo(s) ignorados por tipo não permitido. Use imagens ou documentos (PDF, Office, TXT, CSV, RTF).`,
      })
    }

    if (event.target) event.target.value = ''
  }

  const handleProductAttachmentRemove = (index: number) => {
    markUserDirty()
    setProductSelectedFiles((prev) => prev.filter((_, i) => i !== index))
  }

  const handleProductSelectFromGallery = (galleryFiles: ExistingAttachment[]) => {
    markUserDirty()
    const newUrls: string[] = []
    const newExisting: ExistingAttachment[] = []

    galleryFiles.forEach((file) => {
      const fileUrl = file.fileUrl || file.filePath || ''
      if (fileUrl) {
        newUrls.push(fileUrl)
        newExisting.push({
          ...file,
          filePath: file.filePath || fileUrl,
          fileUrl,
        })
      }
    })

    setProductAttachmentUrls((prev) => Array.from(new Set([...prev, ...newUrls])))
    setProductExistingAttachments((prev) => {
      const existingIds = new Set(prev.map((a) => a.id))
      const toAdd = newExisting.filter((a) => !existingIds.has(a.id))
      return [...prev, ...toAdd]
    })
  }

  const handleViewProductExistingAttachment = async (attachment: ExistingAttachment) => {
    const url = await resolveProductAttachmentAccessUrl(attachment, 'view')
    if (!url) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Não foi possível abrir o anexo.',
      })
      return
    }

    await openSignedAttachment(url)
  }

  const handleDownloadProductExistingAttachment = async (attachment: ExistingAttachment) => {
    const url = await resolveProductAttachmentAccessUrl(attachment, 'download')
    if (!url) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Não foi possível baixar o anexo.',
      })
      return
    }

    await downloadRemoteFile(url, attachment.originalName || attachment.fileName || 'anexo')
  }

  const handleProductExistingAttachmentRemove = async (attachmentId: number) => {
    const targetAttachment = productExistingAttachments.find((attachment) => attachment.id === attachmentId)
    if (!targetAttachment) return
    markUserDirty()

    setProductExistingAttachments((prev) => prev.filter((attachment) => attachment.id !== attachmentId))
    setProductAttachmentUrls((prev) =>
      prev.filter(
        (url) =>
          url !== (targetAttachment.fileUrl || '') &&
          url !== (targetAttachment.filePath || ''),
      ),
    )
  }

  const handleSetProductAttachmentCover = async (
    attachment: ExistingAttachment,
    scale: number,
    posX: number,
    posY: number,
  ) => {
    markUserDirty()
    const attachmentSource = attachment.fileUrl || attachment.filePath || ''

    setProductExistingAttachments((prev) =>
      prev.map((item) => {
        const itemSource = item.fileUrl || item.filePath || ''
        const isSameItemById = item.id === attachment.id
        const isSameItemBySource = Boolean(attachmentSource) && itemSource === attachmentSource
        const isSameItem = isSameItemById || isSameItemBySource

        return {
          ...item,
          isCover: isSameItem,
          coverScale: isSameItem ? scale : item.coverScale,
          coverPosX: isSameItem ? posX : item.coverPosX,
          coverPosY: isSameItem ? posY : item.coverPosY,
        }
      }),
    )
  }

  const handleRemoveProductAttachmentCover = async () => {
    markUserDirty()
    setProductExistingAttachments((prev) =>
      prev.map((item) => ({ ...item, isCover: false })),
    )
  }

  const handleInsumoGroupSelect = async (itemId: number, materialAndCategory: string | null) => {
    if (!materialAndCategory) return
    markUserDirty()
    const raw = String(materialAndCategory)

    let selectedGroupResourceId: number | null = null
    let selectedMaterialId: number | null = null
    let selectedCategoryId: number | null = null

    if (raw.startsWith('r:')) {
      selectedGroupResourceId = Number(raw.slice(2)) || null
    } else if (raw.startsWith('m:')) {
      selectedMaterialId = Number(raw.slice(2)) || null
    } else {
      const [materialRaw, categoryRaw] = raw.split(':')
      selectedMaterialId = materialRaw ? Number(materialRaw) : null
      selectedCategoryId = categoryRaw ? Number(categoryRaw) : null
    }

    const matchTrim = familyTrimInsumoOptions.find((t) =>
      (selectedGroupResourceId != null && t.resourceId === selectedGroupResourceId) ||
      (selectedMaterialId != null && t.materialId === selectedMaterialId) ||
      String(t.familyMaterialId) === raw ||
      (t.resourceId != null && String(t.resourceId) === raw)
    )

    if (matchTrim) {
      selectedMaterialId = matchTrim.materialId || selectedMaterialId
      selectedCategoryId = matchTrim.categoryId || selectedCategoryId
      if (matchTrim.resourceId) {
        selectedGroupResourceId = matchTrim.resourceId
      }
      if (matchTrim.colorId && matchTrim.colorName) {
        setAllItemColors((prev) => {
          if (!prev.some((c) => Number(c.id) === Number(matchTrim.colorId))) {
            return [
              ...prev,
              {
                id: Number(matchTrim.colorId),
                name: String(matchTrim.colorName),
                hex: matchTrim.colorHex || undefined,
                pantone: matchTrim.colorPantone,
              },
            ]
          }
          return prev
        })
      }
    }

    const matchResource = selectedGroupResourceId
      ? allResources.find((r) => r.id === selectedGroupResourceId)
      : null
    if (matchResource) {
      selectedMaterialId = matchResource.materialId || selectedMaterialId
      selectedCategoryId = matchResource.categoryId || selectedCategoryId
      const rColorId = (matchResource as any).itemColorId || (matchResource as any).ItemColor?.id
      const rColorName = (matchResource as any).ItemColor?.name || (matchResource as any).color
      if (rColorId && rColorName) {
        setAllItemColors((prev) => {
          if (!prev.some((c) => Number(c.id) === Number(rColorId))) {
            return [
              ...prev,
              {
                id: Number(rColorId),
                name: String(rColorName),
                hex: (matchResource as any).ItemColor?.hex || (matchResource as any).colorHex,
                pantone: (matchResource as any).ItemColor?.Pantone || (matchResource as any).pantone,
              },
            ]
          }
          return prev
        })
      }
    }

    const selectedGroup = insumoMaterialGroups.find(g => {
      if (selectedGroupResourceId !== null) {
        return g.resourceId === selectedGroupResourceId
      }
      return (
        g.materialId === selectedMaterialId &&
        Number(g.categoryId ?? 0) === Number(selectedCategoryId ?? 0)
      )
    }) || null

    if (selectedGroup) {
      selectedMaterialId = selectedGroup.materialId ?? selectedMaterialId
      selectedCategoryId = selectedGroup.categoryId ?? selectedCategoryId
    }

    const resolvedResourceId =
      selectedGroupResourceId ??
      matchTrim?.resourceId ??
      selectedGroup?.resourceId ??
      matchResource?.id ??
      (selectedMaterialId
        ? getTemplateResourceIdByMaterial(selectedMaterialId, selectedCategoryId)
        : null)

    if (!resolvedResourceId) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Não foi possível localizar o recurso correspondente para o insumo selecionado.',
      })
      return;
    }

    const colors = selectedMaterialId
      ? await fetchResourceMaterialColors(selectedMaterialId)
      : []
    const variations: MaterialVariation[] = colors.map((c: any) => ({
      id: c.id,
      colorId: c.colorId || c.id,
      stockId: null,
      resourceId: resolvedResourceId,
      color: { id: c.colorId || c.id, name: c.color?.name || c.name || '' },
      stock: null,
      resource: null,
    }))

    setCompositionItems(prev => {
      const next = prev.map(item =>
        item.id === itemId
          ? {
            ...item,
            materialId: selectedMaterialId,
            stockId: null,
            resourceId: resolvedResourceId,
            categoryId: selectedCategoryId,
            descricao: matchTrim?.resourceName || selectedGroup?.materialName || (matchResource ? String(matchResource.name || '') : '') || item.descricao,
            availableVariations: variations,
            finishing: matchTrim?.finishing || selectedGroup?.finishing || (matchResource as any)?.Finishing?.type || (matchResource as any)?.finishing || '—',
            productItemColors: selectedCollectionColors.map(c => ({
              collectionColorId: c.id,
              itemColorId: matchTrim?.colorId || (matchResource as any)?.itemColorId || (matchResource as any)?.ItemColor?.id ? Number(matchTrim?.colorId || (matchResource as any)?.itemColorId || (matchResource as any)?.ItemColor?.id) : null,
              itemColorName: matchTrim?.colorName || (matchResource as any)?.ItemColor?.name || (matchResource as any)?.color ? String(matchTrim?.colorName || (matchResource as any)?.ItemColor?.name || (matchResource as any)?.color) : undefined,
              resourceId: resolvedResourceId,
              materialId: selectedMaterialId || undefined,
            })),
          }
          : item
      );
      const updated = next.find(i => i.id === itemId);
      console.debug('[RC] handleInsumoGroupSelect updated item', updated);
      return next;
    });
  }

  const fetchStockColors = async (stockId?: number, materialId?: number) => {
    try {
      const token = localStorage.getItem('token')
      const headers = token ? { Authorization: `Bearer ${token}` } : {}
      if (stockId) {
        const resp = await axios.get(`${FASHION_API_URL}/stocks/${stockId}`, { headers })
        const stock = resp.data
        if (stock) {
          const cid = stock.itemColorId || stock.ItemColor?.id
          if (cid) {
            return [{
              id: cid,
              colorId: cid,
              stockId: stock.id,
              color: { id: cid, name: stock.ItemColor?.name || `Cor ${cid}` },
            }]
          }
        }
      }

      const targetMatId = materialId || undefined
      if (targetMatId) {
        const resp = await axios.get(`${FASHION_API_URL}/stocks`, { headers, params: { materialId: targetMatId } })
        const stocks: any[] = Array.isArray(resp.data) ? resp.data : []
        const seen: Record<number, boolean> = {}
        const colors: any[] = []
        for (const stk of stocks) {
          const cid = stk.itemColorId || stk.ItemColor?.id
          if (cid && !seen[cid]) {
            seen[cid] = true
            colors.push({
              id: cid,
              colorId: cid,
              stockId: stk.id,
              color: { id: cid, name: stk.ItemColor?.name || `Cor ${cid}` },
            })
          }
        }
        return colors
      }
    } catch (err) {
      console.error('Erro ao buscar cores do stock', err)
    }
    return []
  }

  const getTemplateResourceIdByMaterial = (materialId?: number | null, categoryId?: number | null): number | null => {
    if (!materialId) return null

    if (categoryId && resourcesByCategory[categoryId]) {
      const byCategory = resourcesByCategory[categoryId] || []
      const exact = byCategory.find((r) => Number(r.materialId) === Number(materialId))
      if (exact?.id) return exact.id
    }

    const allResources = Object.values(resourcesByCategory).flat()
    const match = allResources.find((r) => Number(r.materialId) === Number(materialId))
    return match?.id || null
  }

  const fetchResourceMaterialColors = async (resourceMaterialId: number) => {
    try {
      const token = localStorage.getItem('token')
      const headers = token ? { Authorization: `Bearer ${token}` } : {}
      const resp = await axios.get(`${FASHION_API_URL}/colors`, {
        headers,
        params: { resourceMaterialId },
      })
      const colors = Array.isArray(resp.data) ? resp.data : []
      return colors.map((c: any) => ({
        id: c.id,
        colorId: c.id,
        name: c.name,
        color: { id: c.id, name: c.name || `Cor ${c.id}` },
      }))
    } catch (err) {
      console.error('Erro ao buscar cores por material de recurso', err)
      return []
    }
  }

  const fetchResourceColors = async (resourceId: number) => {
    try {
      const token = localStorage.getItem('token')
      const headers = token ? { Authorization: `Bearer ${token}` } : {}
      const resp = await axios.get(`${FASHION_API_URL}/resources/${resourceId}/colors`, { headers })
      const colors = Array.isArray(resp.data) ? resp.data : []
      return colors.map((rc: any) => ({ id: rc.itemColorId, color: { id: rc.itemColorId, name: rc.ItemColor?.name || `Cor ${rc.itemColorId}` } }))
    } catch (err) {
      console.error('Erro ao buscar cores do recurso', err)
    }
    return []
  }

  const handleStockChange = async (itemId: number, stockId: number) => {
    let variations: MaterialVariation[] = []
    let stockDescription = ''
    try {
      const token = localStorage.getItem('token')
      const headers = { Authorization: `Bearer ${token}` }

      try {
        const stockRes = await axios.get(`${FASHION_API_URL}/stocks/${stockId}`, {
          headers,
        })
        if (stockRes.data) {
          stockDescription = stockRes.data.description || stockRes.data.name || `Stock ${stockId}`
        }
      } catch (stockError) {
        console.error('Erro ao carregar descrição do stock:', stockError)
        const stockInList = conjuntoStocks.find(s => s.id === stockId);
        if (stockInList) {
          stockDescription = stockInList.description || `Stock ${stockId}`;
        }
      }

      const colors = await fetchStockColors(stockId)
      variations = colors.map((c: any) => ({
        id: c.id,
        colorId: c.id,
        stockId,
        resourceId: null,
        color: { id: c.id, name: c.color.name },
        stock: null,
        resource: null,
      }))
    } catch (error) {
      console.error('Erro ao carregar variações:', error)
    }

    if (itemId && stockId) {
      try {
        const token = localStorage.getItem('token')
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const res = await axios.get(`${FASHION_API_URL}/stocks/${stockId}`, { headers })
        if (res.data && res.data.materialId) {
          setCompositionItems(prev =>
            prev.map(it =>
              it.id === itemId
                ? { ...it, materialId: res.data.materialId }
                : it
            )
          )
        }
      } catch (err) {
        console.error('erro ao buscar material a partir do stock (handleStockChange)', err)
      }
    }

    setCompositionItems((prev) =>
      prev.map((item) =>
        item.id === itemId
          ? {
            ...item,
            stockId,
            descricao: item.tipo === 'materia-prima' ? item.descricao : stockDescription || item.descricao,
            availableVariations: variations,
            productItemColors: item.productItemColors,
          }
          : item
      )
    )
  }

  useEffect(() => {
    compositionItems.forEach(async (item) => {
      if (item.tipo === 'materia-prima' && item.stockId && item.materialId == null) {
        try {
          const token = localStorage.getItem('token')
          const headers = token ? { Authorization: `Bearer ${token}` } : {}
          const res = await axios.get(`${FASHION_API_URL}/stocks/${item.stockId}`, { headers })
          const mat = res.data?.materialId
          if (mat) {
            console.debug('[RC] povoando materialId a partir do stock (effect)', { itemId: item.id, stockId: item.stockId, materialId: mat })
            setCompositionItems(prev =>
              prev.map(it =>
                it.id === item.id ? { ...it, materialId: mat } : it
              )
            )
          }
        } catch (err) {
          console.error('erro ao buscar material a partir do stock (effect)', err)
        }
      }
    })
  }, [compositionItems])

  const handleUnidadeMedidaChange = (itemId: number, unidadeId: number) => {
    const item = compositionItems.find((i) => i.id === itemId)
    if (!item) return

    const selectedUnit = units.find(u => u.id === unidadeId)
    const unidade = selectedUnit?.name || ''
    console.debug('[RC] alteração unidade item', itemId, 'de', item.unitOfMeasurementId, 'para', unidadeId, 'cores anteriores', item.productItemColors)

    setCompositionItems((prev) => {
      const updated = prev.map((i) =>
        i.id === itemId ? { ...i, unidadeMedida: unidade, unitOfMeasurementId: unidadeId } : i
      )
      const updatedItem = updated.find(i => i.id === itemId)
      console.debug('[RC] item após mudança unidade', updatedItem)
      console.debug('[RC] compositionItems after unidade change', updated)
      return updated
    })
  }

  const handleCompositionFieldChange = (
    itemId: number,
    field: keyof CompositionItem,
    value: string
  ) => {
    setCompositionItems((prev) =>
      prev.map((item) => (item.id === itemId ? { ...item, [field]: value } : item))
    )
  }

  const executeSave = async (targetUrl?: string | null): Promise<boolean> => {
    if (!formData.nomeProduto.trim()) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Por favor, preencha o nome do produto.',
      })
      return false
    }

    if (!formData.collectionId) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Por favor, selecione uma coleção.',
      })
      return false
    }

    if (!formData.codigo?.trim()) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Por favor, preencha o código do produto.',
      })
      return false
    }

    if (!formData.familyId || formData.familyId <= 0) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Por favor, selecione uma família.',
      })
      return false
    }

    if (isVariationMode) {
      const newCode = formData.codigo.trim()
      if (!newCode) {
        setFeedback({
          isOpen: true,
          statusOk: false,
          message: 'Informe um código para criar a variação do produto.',
        })
        return false
      }
    }

    if (selectedGradeIds.length === 0) {
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'É obrigatório selecionar pelo menos uma grade.',
      })
      return false
    }

    setLoading(true)

    let attachmentsToSend = [...productAttachmentUrls]
    if (productSelectedFiles.length > 0) {
      try {
        const uploaded = await uploadProductAttachmentFiles(productSelectedFiles)
        attachmentsToSend = [...attachmentsToSend, ...uploaded]
        setProductAttachmentUrls(attachmentsToSend)
        setProductSelectedFiles([])
      } catch (uploadError) {
        console.error('Erro ao enviar anexos:', uploadError)
        setLoading(false)
        setFeedback({
          isOpen: true,
          statusOk: false,
          message: 'Erro ao enviar anexos. Tente novamente.',
        })
        return false
      }
    }

    const currentCoverAttachment = productExistingAttachments.find((attachment) => attachment.isCover)
    const coverAttachmentUrl = currentCoverAttachment
      ? currentCoverAttachment.fileUrl || currentCoverAttachment.filePath || null
      : null
    const coverImageScale = currentCoverAttachment ? currentCoverAttachment.coverScale ?? null : null
    const coverImagePosX = currentCoverAttachment ? currentCoverAttachment.coverPosX ?? null : null
    const coverImagePosY = currentCoverAttachment ? currentCoverAttachment.coverPosY ?? null : null

    const payload = {
      productCode: typeof formData.codigo === 'string' ? formData.codigo.trim() || null : (formData.codigo ? String(formData.codigo).trim() : null),
      name: formData.nomeProduto,
      price: isEditMode
        ? (formData.price != null && Number(formData.price) > 0 ? Number(formData.price) : null)
        : (formData.price != null && Number(formData.price) > 0 ? Number(formData.price) : undefined),
      description: typeof formData.description === 'string' ? formData.description.trim() || null : (formData.description ? String(formData.description).trim() : null),
      referenceProduct: typeof formData.referenceProduct === 'string' ? formData.referenceProduct.trim() || null : (formData.referenceProduct ? String(formData.referenceProduct).trim() : null),
      observations: typeof formData.observations === 'string' ? formData.observations.trim() || null : (formData.observations ? String(formData.observations).trim() : null),
      supplierCode: typeof formData.supplierCode === 'string' ? formData.supplierCode.trim() || null : (formData.supplierCode ? String(formData.supplierCode).trim() : null),
      clientIdentification: typeof formData.clientIdentification === 'string' ? formData.clientIdentification.trim() || null : (formData.clientIdentification ? String(formData.clientIdentification).trim() : null),
      collectionId: formData.collectionId,
      familyId: formData.familyId,
      groupId: formData.groupId > 0 ? formData.groupId : (isEditMode ? null : undefined),
      ...(isEditMode
        ? { episodeId: formData.episodeId > 0 ? formData.episodeId : null }
        : formData.episodeId > 0
          ? { episodeId: formData.episodeId }
          : {}),
      ...(isEditMode
        ? { ncmId: formData.ncmId > 0 ? formData.ncmId : null }
        : formData.ncmId > 0
          ? { ncmId: formData.ncmId }
          : {}),
      ...(isEditMode
        ? { unitOfMeasurementId: formData.unitOfMeasurementId > 0 ? formData.unitOfMeasurementId : null }
        : formData.unitOfMeasurementId > 0
          ? { unitOfMeasurementId: formData.unitOfMeasurementId }
          : {}),
      gradeIds: selectedGradeIds,
      attachments: attachmentsToSend,
      coverAttachmentUrl,
      coverImageScale,
      coverImagePosX,
      coverImagePosY,
      compositionItems: compositionItems
        .filter((item) => item.tipo === 'materia-prima' || item.tipo === 'insumo' || item.tipo === 'servico')
        .map((item) => {
          const base: any = {
            tipo: item.tipo,
            usage: item.consumo ? Number(String(item.consumo).replace(',', '.')) : undefined,
            skinSize: item.skinSize ? Number(String(item.skinSize).replace(',', '.')) : undefined,
            unitOfMeasurementId: item.unitOfMeasurementId || undefined,
          }
          const rawCost = item.costPerUnit?.trim()
          if (rawCost) {
            const n = Number(String(rawCost).replace(',', '.'))
            if (!Number.isNaN(n)) {
              base.costPerUnit = n
            }
          }

          if (item.tipo === 'materia-prima') {
            return {
              ...base,
              materialId: item.materialId || undefined,
              stockId: item.stockId || undefined,
              sizeRange: item.sizeRange ?? [],
            }
          }

          if (item.tipo === 'insumo') {
            return {
              ...base,
              resourceId: item.resourceId || undefined,
              materialId: item.materialId || undefined,
              sizeRange: item.sizeRange ?? [],
            }
          }

          return {
            ...base,
            stageId: item.stageId || undefined,
            deliveryTime: item.consumo || undefined,
          }
        }),

      productItemColors: (() => {
        const serverProductColors: any[] =
          (productData as any)?.ProductItemColor ||
          (productData as any)?.productItemColors ||
          []

        const fromCoresSection = selectedCollectionColors.map(col => {
          const existing = serverProductColors.find(
            (p: any) =>
              p.collectionColorId === col.id && !p.stockId && !p.resourceId,
          )

          return {
            ...(existing?.id != null ? { id: existing.id } : {}),
            collectionColorId: col.id,
          }
        })

        const fromComposition = compositionItems.flatMap(item =>
          (item.productItemColors || [])
            .filter(p => p.itemColorId)
            .map(p => {
              const base: any = {
                id: p.id,
                collectionColorId: p.collectionColorId,
                itemColorId: p.itemColorId,
              }

              if (item.tipo === 'materia-prima') {
                if (item.materialId) {
                  base.materialId = item.materialId
                }
                if (p.stockId) {
                  base.stockId = p.stockId
                } else if (item.stockId) {
                  base.stockId = item.stockId
                }
              } else if (item.tipo === 'insumo') {
                if (item.materialId) {
                  base.materialId = item.materialId
                }
                if (p.resourceId) {
                  base.resourceId = p.resourceId
                } else if (item.resourceId) {
                  base.resourceId = item.resourceId
                }
                if (p.stockId) {
                  base.stockId = p.stockId
                }
              }

              return base
            }),
        )

        const productItemColorKey = (entry: any) => {
          if (
            entry.itemColorId ||
            entry.stockId ||
            entry.resourceId ||
            entry.materialId
          ) {
            return `comp:${entry.collectionColorId}_${entry.itemColorId || ''}_${entry.stockId || ''}_${entry.resourceId || ''}_${entry.materialId || ''}`
          }
          return `tag:${entry.collectionColorId}`
        }

        const unique = new Map<string, any>()
        const mergeEntry = (entry: any) => {
          const key = productItemColorKey(entry)
          const existing = unique.get(key)
          if (!existing || (existing.id == null && entry.id != null)) {
            unique.set(key, entry)
          }
        }

        fromCoresSection.forEach(mergeEntry)
        fromComposition.forEach(mergeEntry)

        return Array.from(unique.values())
      })(),
      beneficiamentoNotes: [] as any[],
    }

    try {
      const resolvedNotes = await Promise.all(
        beneficiamentoNotes.map(async (nota) => {
          let uploadedUrls: string[] = []
          if (nota.imageFiles.length > 0) {
            uploadedUrls = await Promise.all(nota.imageFiles.map(f => uploadNoteImage(f)))
          }
          return {
            id: nota.id || undefined,
            sectorId: nota.sectorId,
            description: nota.description || undefined,
            imageUrls: [...nota.imageOriginalUrls, ...uploadedUrls],
            createdByIdUser: nota.CreatedByUser?.id || undefined,
            updatedByIdUser: nota.UpdatedByUser?.id || undefined,
          }
        })
      )
      payload.beneficiamentoNotes = resolvedNotes
    } catch (noteUploadError) {
      console.error('Erro ao enviar imagens de notas de beneficiamento:', noteUploadError)
      setLoading(false)
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: 'Erro ao enviar imagens das notas. Tente novamente.',
      })
      return false
    }

    try {
      const token = localStorage.getItem('token')
      console.log('[RegisterComposition] payload', JSON.stringify(payload, null, 2));
      console.log('[RegisterComposition] payload compositionItems', payload.compositionItems);
      console.log('[RegisterComposition] compositionItems (raw)', JSON.stringify(compositionItems, null, 2));
      console.log('[RegisterComposition] compositionItems payload mapping', payload.compositionItems.map((i: any) => ({
        tipo: i.tipo,
        materialId: i.materialId,
        resourceId: i.resourceId,
        stockId: i.stockId,
        stageId: i.stageId,
        deliveryTime: i.deliveryTime,
        unitOfMeasurementId: i.unitOfMeasurementId,
      })));
      console.log('[RegisterComposition] payload colors', payload.productItemColors);

      let targetSavedProductId: number | null = null

      if (isEditMode && productId) {
        targetSavedProductId = Number(productId)
        await axios.put(`${FASHION_API_URL}/${productId}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })

        await measuresRef.current?.save(Number(productId))

        setFeedback({
          isOpen: true,
          statusOk: true,
          message: 'Produto atualizado com sucesso!',
        })
      } else {
        const createResp = await axios.post(`${FASHION_API_URL}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })

        const createdId = createResp.data?.id
        if (createdId) {
          targetSavedProductId = Number(createdId)
          await measuresRef.current?.save(createdId)
        }

        setFeedback({
          isOpen: true,
          statusOk: true,
          message: 'Produto cadastrado com sucesso!',
        })
      }

      if (targetSavedProductId) {
        try {
          let ticketId = productTicketIdRef.current
          if (!ticketId) {
            let pipeline = productPipelineRef.current
            if (!pipeline?.id) {
              const getPipelineRes = await axios.get(
                `${GATEWAY_URL}/pipelines/pipeline`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                  params: { moduleType: 'product_development', subModule: 'fashion' },
                },
              )
              const list = getPipelineRes.data?.data || getPipelineRes.data || []
              if (Array.isArray(list) && list.length > 0) {
                pipeline = list[0]
              }
            }
            if (pipeline?.id) {
              await axios.post(
                `${GATEWAY_URL}/pipelines/ticket/sync-module`,
                {
                  moduleType: 'product_development',
                  pipelineId: pipeline.id,
                  subModule: 'fashion',
                },
                { headers: { Authorization: `Bearer ${token}` } },
              )

              const ticketsRes = await axios.get(
                `${GATEWAY_URL}/pipelines/ticket`,
                {
                  headers: { Authorization: `Bearer ${token}` },
                  params: { pipelineId: pipeline.id, take: 1000 },
                },
              )
              const tList = Array.isArray(ticketsRes.data?.data) ? ticketsRes.data.data : []
              const matched = tList.find(
                (t: any) =>
                  t.externalId === targetSavedProductId ||
                  t.externalData?.productId === targetSavedProductId,
              )
              if (matched) ticketId = matched.id
            }
          }

          if (ticketId) {
            const currentTagIds = selectedTags.map((t) => t.id)
            const prevTagIds = initialTagIdsRef.current
            const toAdd = currentTagIds.filter((id) => !prevTagIds.includes(id))
            const toRemove = prevTagIds.filter((id) => !currentTagIds.includes(id))

            for (const tagId of toAdd) {
              await axios.post(
                `${GATEWAY_URL}/pipelines/ticket/${ticketId}/tags/${tagId}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } },
              )
            }
            for (const tagId of toRemove) {
              await axios.delete(
                `${GATEWAY_URL}/pipelines/ticket/${ticketId}/tags/${tagId}`,
                { headers: { Authorization: `Bearer ${token}` } },
              )
            }
            initialTagIdsRef.current = currentTagIds
          }
        } catch (ticketSyncErr) {
          console.error('Erro ao sincronizar tags do ticket no funil:', ticketSyncErr)
        }
      }

      hasUserEditedRef.current = false
      initialSnapshotRef.current = null
      navigate(targetUrl || returnTo || defaultReturnUrl)
      return true
    } catch (err: any) {
      console.error('Erro ao salvar produto:', err, err.response?.data)
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: err.response?.data?.message || 'Erro ao salvar produto. Tente novamente.',
      })
      return false
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      await executeSave()
    } catch (err: any) {
      console.error('Erro ao salvar produto:', err)
      setLoading(false)
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: err?.message || 'Erro inesperado ao salvar produto. Tente novamente.',
      })
    }
  }

  const breadcrumbItems = parentIdParam
    ? [
      { label: 'Ficha técnica de produto', path: '/panel/composition-product' },
      { label: 'Produto Pai', path: `/panel/composition-product/edit/${parentIdParam}` },
      { label: isEditMode ? 'Editar mostruário' : 'Cadastrar mostruário' },
    ]
    : [
      { label: 'Ficha técnica de produto', path: '/panel/composition-product' },
      { label: isEditMode ? (isShowroomProduct ? 'Editar mostruário' : 'Editar produto') : (isVariationMode ? 'Criar variação de produto' : 'Cadastrar produto') },
    ]

  const hasMaterialItem = React.useMemo(
    () => compositionItems.some((i) => i.tipo === 'materia-prima'),
    [compositionItems],
  )

  const isFormValid = formData.nomeProduto.trim() !== '' && formData.collectionId > 0

  const displayGrades = React.useMemo(() => {
    if (!selectedGradeType) return []

    const gradeType = gradeTypes.find(t => t.id === selectedGradeType)
    if (!gradeType) return []

    const gradesOfType = gradesByType[gradeType.name] || []
    return gradesOfType.filter(grade => availableGradeIds.includes(grade.id))
  }, [selectedGradeType, gradeTypes, gradesByType, availableGradeIds])

  if (loadingData || (shouldHydrateFromSource && isInitializing)) {
    return <OrdenoLoading variant="fullscreen" text="Carregando dados do produto..." />
  }

  const handleSaveNotes = async (_localId?: number) => {
    if (!productId || isNaN(Number(productId))) {
      setInitialBeneficiamentoNotes([...beneficiamentoNotes])
      setFeedback({
        isOpen: true,
        statusOk: true,
        message: 'Anotações salvas com sucesso!',
      })
      return
    }

    try {
      setSavingNotes(true)
      const token = localStorage.getItem('token')

      const resolvedNotes = await Promise.all(
        beneficiamentoNotes.map(async (nota) => {
          let uploadedUrls: string[] = []
          if (nota.imageFiles && nota.imageFiles.length > 0) {
            uploadedUrls = await Promise.all(nota.imageFiles.map((f) => uploadNoteImage(f)))
          }
          return {
            id: nota.id || undefined,
            sectorId: nota.sectorId,
            description: nota.description || undefined,
            imageUrls: [...(nota.imageOriginalUrls || []), ...uploadedUrls],
            createdByIdUser: nota.CreatedByUser?.id || undefined,
            updatedByIdUser: nota.UpdatedByUser?.id || undefined,
          }
        })
      )

      await axios.put(
        `${FASHION_API_URL}/${productId}`,
        { beneficiamentoNotes: resolvedNotes },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      const notesToNotify = beneficiamentoNotes.filter((n) => n.mentionedUserIds && n.mentionedUserIds.length > 0)
      if (notesToNotify.length > 0) {
        const productName = (productData as any)?.name || (productData as any)?.code || `Produto #${productId}`
        await Promise.allSettled(
          notesToNotify.map((n) =>
            axios.post(
              `${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/comments`,
              {
                comment: `[produto:${productId}|${productName}] ${n.description}`,
                mentionedUserIds: n.mentionedUserIds,
              },
              { headers: { Authorization: `Bearer ${token}` } }
            )
          )
        )
      }

      const productRes = await axios.get(`${FASHION_API_URL}/${productId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const product = productRes.data
      const updatedNotes: any[] = product?.BeneficiamentoNote || []
      const reloadedNotes = await Promise.all(
        updatedNotes.map(async (n: any) => {
          const noteUrls = (n.Files || []).map((f: any) => f.GeneralFile?.fileUrl).filter(Boolean) as string[]
          const author = n.createdByName || n.CreatedByUser?.name || ''
          const updatedAuthor = n.updatedByName || n.UpdatedByUser?.name || ''
          return {
            ...newBeneficiamentoNota(n.sectorId, author),
            id: n.id,
            sectorId: n.sectorId,
            description: n.description || '',
            imageOriginalUrls: noteUrls,
            imageUrls: await resolveNoteImageUrls(noteUrls),
            createdByIdUser: n.createdByIdUser ?? n.CreatedByUser?.id ?? null,
            updatedByIdUser: n.updatedByIdUser ?? n.UpdatedByUser?.id ?? null,
            createdByName: author,
            updatedByName: updatedAuthor,
            CreatedByUser: n.CreatedByUser,
            UpdatedByUser: n.UpdatedByUser,
            createdAt: n.createdAt,
            updatedAt: n.updatedAt,
          }
        })
      )

      setBeneficiamentoNotes(reloadedNotes)
      setInitialBeneficiamentoNotes(reloadedNotes)
      setFeedback({
        isOpen: true,
        statusOk: true,
        message: 'Anotações salvas com sucesso!',
      })
    } catch (err: any) {
      console.error('Erro ao salvar anotações:', err)
      const errorMsg =
        err?.message === 'Network Error'
          ? 'Erro de conexão: certifique-se de que o backend está em execução.'
          : err?.response?.data?.message || 'Erro ao salvar anotações. Tente novamente.'
      setFeedback({
        isOpen: true,
        statusOk: false,
        message: errorMsg,
      })
    } finally {
      setSavingNotes(false)
    }
  }

  const handleCancelNotes = (localId?: number) => {
    if (typeof localId === 'number') {
      const initialNote = initialBeneficiamentoNotes.find((n) => n.localId === localId)
      if (initialNote) {
        setBeneficiamentoNotes((prev) =>
          prev.map((n) => (n.localId === localId ? { ...initialNote } : n))
        )
      } else {
        setBeneficiamentoNotes((prev) => prev.filter((n) => n.localId !== localId))
      }
    } else {
      beneficiamentoNotes.forEach((nota) => {
        nota.imagePreviews.forEach((preview) => {
          if (!initialBeneficiamentoNotes.some((inNota) => inNota.imagePreviews.includes(preview))) {
            URL.revokeObjectURL(preview)
          }
        })
      })
      setBeneficiamentoNotes(initialBeneficiamentoNotes)
    }
    setFeedback({
      isOpen: true,
      statusOk: true,
      message: 'Alterações em anotações descartadas.',
    })
  }

  return (
    <>
      <SubHeaderContainer style={{ margin: '0 -1.2rem 0' }}>
        <LeftSide>
          <SectionName>{isEditMode ? 'Editar ficha técnica de produto' : (isVariationMode ? 'Criar variação de produto' : 'Cadastrar ficha técnica de produto')}</SectionName>
        </LeftSide>
        <ActionButtons>
          {isEditMode && (
            <ImportButton type='button' onClick={() => setIsPdfModalOpen(true)}>
              <DownloadIcon />
              Gerar PDF
            </ImportButton>
          )}
          <ImportButton type='button'>
            <DownloadIcon />
            Importar produto base
          </ImportButton>
          <CancelButton type='button' onClick={handleCancel}>
            Cancelar
          </CancelButton>
          <SaveButton type='button' onClick={handleSubmit} disabled={!isFormValid || loading}>
            <img src={save} alt='Salvar' />
            {loading ? 'Salvando...' : (isEditMode ? 'Atualizar produto' : 'Salvar produto')}
          </SaveButton>
        </ActionButtons>
      </SubHeaderContainer>

      <Breadcrumbs items={breadcrumbItems} />

      <MainContainer>

        <form onSubmit={handleSubmit}>
          <PageGrid $asideOpen={isAttachmentsAsideOpen}>
            <FormColumn>
              <StyledCard>
                <CollapsePanelHeader
                  $open={isGeralOpen}
                  onClick={() => setIsGeralOpen((prev) => !prev)}
                >
                  <CardTitle>Geral</CardTitle>
                  {isGeralOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </CollapsePanelHeader>
                {isGeralOpen && <FormGrid cols={2}>
                  <StyledFormGroup>
                    <label htmlFor='codigo'>
                      Código do produto <span style={{ color: '#e53e3e' }}>*</span>
                    </label>
                    <input
                      type='text'
                      id='codigo'
                      name='codigo'
                      value={formData.codigo}
                      onChange={handleChange}
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='nomeProduto'>
                      Nome do produto <span style={{ color: '#e53e3e' }}>*</span>
                    </label>
                    <input
                      type='text'
                      id='nomeProduto'
                      name='nomeProduto'
                      value={formData.nomeProduto}
                      onChange={handleChange}
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='description'>Descrição</label>
                    <input
                      type='text'
                      id='description'
                      name='description'
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='referenceProduct'>Produto referência</label>
                    <input
                      type='text'
                      id='referenceProduct'
                      name='referenceProduct'
                      value={formData.referenceProduct}
                      onChange={handleChange}
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='price'>Valor (preço do produto)</label>
                    <CurrencyInput
                      id='price'
                      name='price'
                      value={formData.price}
                      onValueChange={(_value, _name, values) => {
                        setFormData(prev => ({ ...prev, price: values?.float ?? 0 }))
                      }}
                      placeholder='R$ 0,00'
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='collectionId'>
                      Coleção vinculada <span style={{ color: '#e53e3e' }}>*</span>
                    </label>
                    <select
                      id='collectionId'
                      name='collectionId'
                      value={formData.collectionId || ''}
                      onChange={handleChange}
                      disabled={isEditMode}
                    >
                      <option value=''>Selecione</option>
                      {allCollections.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                  </StyledFormGroup>

                  <StyledFormGroup>
                    <label htmlFor='familyId'>
                      Família <span style={{ color: '#e53e3e' }}>*</span>
                    </label>
                    <select
                      id='familyId'
                      name='familyId'
                      value={formData.familyId || ''}
                      onChange={handleChange}
                      disabled={!formData.collectionId}
                    >
                      <option value=''>Selecione</option>
                      {filteredFamilies.map((f) => (
                        <option key={f.id} value={f.id}>
                          {f.name}
                        </option>
                      ))}
                    </select>
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='episodeId'>Episódio</label>
                    <select
                      id='episodeId'
                      name='episodeId'
                      value={formData.episodeId || ''}
                      onChange={handleChange}
                      disabled={!formData.collectionId}
                    >
                      <option value=''>Nenhum</option>
                      {collectionEpisodes.map((ep) => (
                        <option key={ep.id} value={ep.id}>
                          {ep.name}
                        </option>
                      ))}
                    </select>
                  </StyledFormGroup>
                  <CollectionStyles.StyledFormGroup>
                    <label htmlFor='groupId' style={{ minHeight: '16px', display: 'block' }}>Grupo</label>
                    <select
                      id='groupId'
                      name='groupId'
                      value={formData.groupId || ''}
                      onChange={(e) => handleChange(e)}
                      disabled={!formData.collectionId}
                    >
                      <option value=''>Selecione</option>
                      {filteredGroups.map((g) => (
                        <option key={g.id} value={g.id}>
                          {g.name}
                        </option>
                      ))}
                    </select>
                  </CollectionStyles.StyledFormGroup>

                  <StyledFormGroup>
                    <label htmlFor='ncmId'>NCM</label>
                    <InfiniteSelect
                      mode='crud'
                      value={ncm}
                      onSelect={(option) => {
                        const escolhido = ncmDaOpcao(option)
                        setNcm(escolhido)
                        setFormData((prev) => ({ ...prev, ncmId: escolhido ? escolhido.id : 0 }))
                      }}
                      endpointConfig={ncmCatalogoEndpoint}
                      placeholder='Buscar NCM (opcional)'
                      emptyOptionsMessage='Nenhum item disponível'
                      errorOptionsMessage='Código não existe na tabela oficial de NCM'
                      allowCreate={false}
                      allowDelete={false}
                    />
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='unitOfMeasurementId'>Unidade comercial</label>
                    <select
                      id='unitOfMeasurementId'
                      name='unitOfMeasurementId'
                      value={formData.unitOfMeasurementId || ''}
                      onChange={handleChange}
                    >
                      <option value=''>Selecione (opcional)</option>
                      {units.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                  </StyledFormGroup>
                  <StyledFormGroup>
                    <label htmlFor='gradeTypes'>
                      Tipo de graduação <span style={{ color: '#e53e3e' }}>*</span>
                    </label>
                    <select
                      value={selectedGradeType || ''}
                      onChange={handleGradeTypeChange}
                      disabled={!formData.collectionId || availableGradeIds.length === 0}
                    >
                      <option value=''>Selecione</option>
                      {gradeTypes
                        .filter(type => {
                          const gradesOfType = gradesByType[type.name] || []
                          return gradesOfType.some(g => availableGradeIds.includes(g.id))
                        })
                        .map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                    </select>
                  </StyledFormGroup>

                  <LeftColumnGroup>
                    {displayGrades.length > 0 && (
                      <StyledFormGroup>
                        <label>
                          Graduação <span style={{ color: '#e53e3e' }}>*</span>
                        </label>
                        <GraduationGrid>
                          {displayGrades.map((grade) => (
                            <GraduationButton
                              key={grade.id}
                              type='button'
                              $isSelected={selectedGradeIds.includes(grade.id)}
                              onClick={() => handleGradeToggle(grade.id)}
                            >
                              {grade.name}
                            </GraduationButton>
                          ))}
                        </GraduationGrid>
                      </StyledFormGroup>
                    )}

                    <StyledFormGroup ref={tagDropdownRef}>
                      <label>Tags do card</label>
                      <TagSelectContainer
                        onClick={() => setIsTagDropdownOpen((prev) => !prev)}
                        $isOpen={isTagDropdownOpen}
                      >
                        <TagChipsContainer>
                          {selectedTags.length > 0 ? (
                            selectedTags.map((tag) => (
                              <TagChip
                                key={tag.id}
                                style={{
                                  backgroundColor: tag.color || '#F87171',
                                  color: getTagTextColor(tag.color),
                                }}
                              >
                                <span>{tag.name}</span>
                                <button
                                  type='button'
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    markUserDirty()
                                    setSelectedTags((prev) => prev.filter((t) => t.id !== tag.id))
                                  }}
                                >
                                  <X size={12} />
                                </button>
                              </TagChip>
                            ))
                          ) : (
                            <TagPlaceholder>Selecione as tags...</TagPlaceholder>
                          )}
                        </TagChipsContainer>
                        <ChevronDown size={16} color='#696969' style={{ marginLeft: 'auto', flexShrink: 0 }} />
                      </TagSelectContainer>

                      {isTagDropdownOpen && (
                        <TagDropdownMenu>
                          {allAvailableTags.length > 5 && (
                            <TagSearchInput
                              type='text'
                              placeholder='Buscar tags...'
                              value={tagSearch}
                              onChange={(e) => setTagSearch(e.target.value)}
                              onClick={(e) => e.stopPropagation()}
                              autoFocus
                            />
                          )}
                          <TagOptionsList>
                            {allAvailableTags
                              .filter((tag) =>
                                tag.name.toLowerCase().includes(tagSearch.toLowerCase()),
                              )
                              .map((tag) => {
                                const isSelected = selectedTags.some((t) => t.id === tag.id)
                                return (
                                  <TagOptionItem
                                    key={tag.id}
                                    $isSelected={isSelected}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      markUserDirty()
                                      if (isSelected) {
                                        setSelectedTags((prev) => prev.filter((t) => t.id !== tag.id))
                                      } else {
                                        setSelectedTags((prev) => [...prev, tag])
                                      }
                                    }}
                                  >
                                    <TagChip
                                      style={{
                                        backgroundColor: tag.color || '#F87171',
                                        color: getTagTextColor(tag.color),
                                      }}
                                    >
                                      <span>{tag.name}</span>
                                    </TagChip>
                                    {isSelected && <Check size={14} color='#0090D3' />}
                                  </TagOptionItem>
                                )
                              })}
                            {allAvailableTags.filter((tag) =>
                              tag.name.toLowerCase().includes(tagSearch.toLowerCase()),
                            ).length === 0 && (
                                <TagEmptyState>Nenhuma tag encontrada</TagEmptyState>
                              )}
                          </TagOptionsList>
                        </TagDropdownMenu>
                      )}
                    </StyledFormGroup>
                  </LeftColumnGroup>

                  <ObservationsFormGroup>
                    <label htmlFor='observations'>Observações</label>
                    <textarea
                      id='observations'
                      name='observations'
                      rows={4}
                      value={formData.observations}
                      onChange={handleChange}
                    />
                  </ObservationsFormGroup>

                  <StyledFormGroup>
                    <label htmlFor='supplierCode'>Código do fornecedor</label>
                    <input
                      type='text'
                      id='supplierCode'
                      name='supplierCode'
                      value={formData.supplierCode}
                      onChange={handleChange}
                      placeholder='Digite aqui'
                      autoComplete='off'
                    />
                  </StyledFormGroup>

                  <StyledFormGroup>
                    <label htmlFor='clientIdentification'>Identificação do cliente</label>
                    <input
                      type='text'
                      id='clientIdentification'
                      name='clientIdentification'
                      value={formData.clientIdentification}
                      onChange={handleChange}
                      placeholder='Digite aqui'
                      autoComplete='off'
                    />
                  </StyledFormGroup>

                </FormGrid>}
              </StyledCard>

              <Colors
                allColors={allCollectionColors}
                selectedColors={selectedCollectionColors}
                onAdd={(col) => {
                  markUserDirty()
                  if (!selectedCollectionColors.some(sc => sc.id === col.id)) {
                    setSelectedCollectionColors(prev => [...prev, col])
                  }
                }}
                onRemove={removeCollectionColor}
                disabled={!formData.collectionId || allCollectionColors.length === 0}
              />

              <StyledCard id="composition-section">
                <CollapsePanelHeader
                  $open={isComposicaoOpen}
                  onClick={() => setIsComposicaoOpen((prev) => !prev)}
                >
                  <CardTitle>Composição</CardTitle>
                  {isComposicaoOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </CollapsePanelHeader>
                {isComposicaoOpen && <>
                  {compositionItems.length > 0 && (
                    <>
                      <CompositionTableWrapper style={columnWidthsStyle}>
                        <CompositionTable>
                          <CompositionTableHeader>
                            <ResizableCompositionHeaderCell columnKey='tipo' onResizeStart={startResize}>
                              Tipo
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='material' onResizeStart={startResize}>
                              Material/Insumo
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='acabamento' onResizeStart={startResize}>
                              Acabamento
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='skinSize' onResizeStart={startResize}>
                              Tamanho de pele
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='consumo' onResizeStart={startResize}>
                              Consumo
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='unidade' onResizeStart={startResize}>
                              Un. de medida
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='sizeRange' onResizeStart={startResize}>
                              Faixa de tamanho
                            </ResizableCompositionHeaderCell>
                            <ResizableCompositionHeaderCell columnKey='custo' onResizeStart={startResize}>
                              Custo / un.
                            </ResizableCompositionHeaderCell>
                            {selectedCollectionColors.map(col => (
                              <ResizableCompositionHeaderCell
                                key={`col-header-${col.id}`}
                                columnKey={colorColumnKey(col.id)}
                                onResizeStart={startResize}
                                style={getColorColumnStyle(col.id)}
                              >
                                {col.name}
                              </ResizableCompositionHeaderCell>
                            ))}
                            <CompositionTableHeaderCell data-col='actions' />
                          </CompositionTableHeader>

                          {compositionItems.map((item, index) => {
                            return (
                              <CompositionTableRow key={item.id}>
                                <TableCell $col='tipo'>
                                  <TableSelect
                                    value={item.tipo || ''}
                                    onChange={(e) => handleCompositionTypeChange(item.id, e.target.value as 'materia-prima' | 'insumo' | 'servico' | '')}
                                  >
                                    <option value=''>Tipo</option>
                                    <option value='materia-prima'>
                                      Material
                                    </option>
                                    <option value='insumo'>Insumo</option>
                                    <option value='servico'>Serviço</option>
                                  </TableSelect>
                                </TableCell>

                                <TableCell $col='material'>
                                  {item.tipo === 'materia-prima' ? (
                                    (() => {
                                      const displayInfo = getMaterialRowDisplayInfo(item, familyConjuntos, allStocks)
                                      const resolvedMatId = displayInfo.selectValue?.startsWith('m:')
                                        ? Number(displayInfo.selectValue.slice(2))
                                        : (item.materialId || undefined)
                                      const selectedOption =
                                        displayInfo.badge === 'material'
                                          ? {
                                            id: displayInfo.selectValue,
                                            name: displayInfo.displayLabel,
                                            colorHex: null,
                                            hex: null,
                                            materialId: resolvedMatId,
                                            materialName: displayInfo.displayLabel,
                                            isMaterialGroup: true,
                                          }
                                          : (materiaPrimaOptions.find((o: any) => String(o.id) === String(displayInfo.selectValue)) ||
                                            (displayInfo.selectValue
                                              ? {
                                                id: displayInfo.selectValue,
                                                name: displayInfo.displayLabel,
                                                colorHex: displayInfo.swatchHex,
                                                hex: displayInfo.swatchHex,
                                                materialId: item.materialId || undefined,
                                              }
                                              : null))

                                      return (
                                        <InfiniteSelect
                                          placeholder='Selecione material'
                                          mode='readonly'
                                          triggerVariant='cell'
                                          options={materiaPrimaOptions}
                                          showDefaultFields={false}
                                          dropdownMinWidth={650}
                                          value={selectedOption}
                                          onSelect={(option) => handleMaterialSelectChange(item.id, option ? String(option.id) : '')}
                                          getOptionLabel={(opt) => opt.name}
                                        />
                                      )
                                    })()
                                  ) : item.tipo === 'insumo' ? (
                                    (() => {
                                      const displayInfo = getInsumoRowDisplayInfo(item, insumoMaterialGroups, familyTrimInsumoOptions, allResources)
                                      const resolvedMatId = displayInfo.selectValue?.startsWith('m:')
                                        ? Number(displayInfo.selectValue.slice(2))
                                        : (item.materialId || undefined)
                                      const selectedOption =
                                        displayInfo.badge === 'material'
                                          ? {
                                            id: displayInfo.selectValue,
                                            name: displayInfo.displayLabel,
                                            colorHex: null,
                                            hex: null,
                                            materialId: resolvedMatId,
                                            materialName: displayInfo.displayLabel,
                                            isMaterialGroup: true,
                                          }
                                          : (insumoOptions.find((o: any) => String(o.id) === String(displayInfo.selectValue)) ||
                                            (displayInfo.selectValue
                                              ? {
                                                id: displayInfo.selectValue,
                                                name: displayInfo.displayLabel,
                                                colorHex: displayInfo.swatchHex,
                                                hex: displayInfo.swatchHex,
                                                materialId: item.materialId || undefined,
                                              }
                                              : null))

                                      return (
                                        <InfiniteSelect
                                          placeholder='Selecione insumo'
                                          mode='readonly'
                                          triggerVariant='cell'
                                          options={insumoOptions}
                                          showDefaultFields={false}
                                          dropdownMinWidth={650}
                                          value={selectedOption}
                                          onSelect={(option) => handleInsumoSelectChange(item.id, option ? String(option.id) : '')}
                                          getOptionLabel={(opt) => opt.name}
                                        />
                                      )
                                    })()
                                  ) : item.tipo === 'servico' ? (
                                    <TableSelect
                                      value={
                                        (() => {
                                          const currentStageId = servicoStageIdFromItem(item)
                                          if (currentStageId != null && allServices.some((s) => s.id === currentStageId)) {
                                            return String(currentStageId)
                                          }
                                          if (item.stageId) return `stage:${item.stageId}`
                                          if (item.descricao) return `d:${item.descricao}`
                                          return ''
                                        })()
                                      }
                                      onChange={(e) => {
                                        const val = e.target.value
                                        if (!val) {
                                          setCompositionItems((prev) =>
                                            prev.map((ci) =>
                                              ci.id === item.id
                                                ? { ...ci, stageId: null, descricao: '' }
                                                : ci
                                            )
                                          )
                                          return
                                        }
                                        if (val.startsWith('stage:') || val.startsWith('d:')) {
                                          return
                                        }
                                        handleServiceSelect(item.id, Number(val))
                                      }}
                                    >
                                      <option value=''>Selecione serviço</option>
                                      {(() => {
                                        const currentStageId = servicoStageIdFromItem(item)
                                        const isMatchedInServices = currentStageId != null && allServices.some((s) => s.id === currentStageId)

                                        const customServiceVal = item.stageId ? `stage:${item.stageId}` : (item.descricao ? `d:${item.descricao}` : '')

                                        return (
                                          <>
                                            {!isMatchedInServices && customServiceVal && (
                                              <option value={customServiceVal}>
                                                {item.descricao || `Serviço #${item.stageId}`}
                                              </option>
                                            )}
                                            {allServices
                                              .map((s) => (
                                                <option key={s.id} value={String(s.id)}>
                                                  {s.name}
                                                </option>
                                              ))}
                                          </>
                                        )
                                      })()}
                                    </TableSelect>
                                  ) : (
                                    <span
                                      style={{
                                        display: 'block',
                                        padding: '12px 14px',
                                        fontSize: 13,
                                        color: '#9ca3af',
                                      }}
                                    >
                                      N/D
                                    </span>
                                  )}
                                </TableCell>

                                <TableCell $col='acabamento'>
                                  <span
                                    style={{
                                      display: 'block',
                                      padding: '12px 14px',
                                      fontSize: 13,
                                      color: '#374151',
                                    }}
                                  >
                                    {item.tipo === 'materia-prima' || item.tipo === 'insumo' ? (item.finishing || '—') : '—'}
                                  </span>
                                </TableCell>

                                <TableCell $col='skinSize'>
                                  <TableInput
                                    type='text'
                                    inputMode='decimal'
                                    autoComplete='off'
                                    value={item.skinSize ?? ''}
                                    onChange={(e) => {
                                      handleCompositionFieldChange(
                                        item.id,
                                        'skinSize',
                                        sanitizeCompositionDecimalInput(e.target.value),
                                      )
                                    }}
                                  />
                                </TableCell>

                                <TableCell $col='consumo'>
                                  <TableInput
                                    type='text'
                                    inputMode='decimal'
                                    autoComplete='off'
                                    value={item.consumo}
                                    onChange={(e) => {
                                      handleCompositionFieldChange(
                                        item.id,
                                        'consumo',
                                        sanitizeCompositionDecimalInput(e.target.value),
                                      )
                                    }}
                                  />
                                </TableCell>

                                <TableCell $col='unidade'>
                                  <TableSelect
                                    value={item.unitOfMeasurementId || ''}
                                    onChange={(e) => handleUnidadeMedidaChange(item.id, Number(e.target.value))}
                                  >
                                    <option value=''></option>
                                    {units.map((u) => (
                                      <option key={u.id} value={u.id}>
                                        {u.name}
                                      </option>
                                    ))}
                                  </TableSelect>
                                </TableCell>

                                <TableCell $col='sizeRange'>
                                  {(item.tipo === 'materia-prima' || item.tipo === 'insumo') && displayGrades.length > 0 ? (
                                    <GraduationGrid style={{ padding: '6px 8px' }}>
                                      {displayGrades.map((grade) => (
                                        <GraduationButton
                                          key={grade.id}
                                          type='button'
                                          $isSelected={(item.sizeRange ?? []).includes(grade.id)}
                                          onClick={() => handleSizeRangeToggle(item.id, grade.id)}
                                        >
                                          {grade.name}
                                        </GraduationButton>
                                      ))}
                                    </GraduationGrid>
                                  ) : (
                                    <span style={{ display: 'block', padding: '12px 14px', fontSize: 13, color: '#9ca3af' }}>—</span>
                                  )}
                                </TableCell>

                                <TableCell $col='custo'>
                                  <CurrencyInput
                                    id={`costPerUnit-${item.id}`}
                                    name={`costPerUnit-${item.id}`}
                                    value={
                                      item.costPerUnit !== undefined &&
                                      item.costPerUnit !== null &&
                                      item.costPerUnit !== '' &&
                                      !isNaN(Number(String(item.costPerUnit).replace(',', '.')))
                                        ? Number(String(item.costPerUnit).replace(',', '.'))
                                        : undefined
                                    }
                                    onValueChange={(_value, _name, values) => {
                                      handleCompositionFieldChange(
                                        item.id,
                                        'costPerUnit',
                                        values?.float !== undefined && values?.float !== null
                                          ? String(values.float)
                                          : '',
                                      )
                                    }}
                                    placeholder='R$ 0,00'
                                    style={{
                                      height: '36px',
                                      fontSize: '13px',
                                      padding: '6px 14px',
                                      boxSizing: 'border-box',
                                    }}
                                  />
                                </TableCell>

                                {selectedCollectionColors.map(col => {
                                  if (item.tipo === 'servico') {
                                    return (
                                      <TableCell
                                        key={`color-cell-${col.id}`}
                                        style={getColorColumnStyle(col.id)}
                                      />
                                    )
                                  }
                                  const existing = item.productItemColors?.find(p => p.collectionColorId === col.id);
                                  const isMaterial = item.tipo === 'materia-prima';
                                  const currentCollectionId = formData.collectionId ? Number(formData.collectionId) : (productData as any)?.collectionId ? Number((productData as any).collectionId) : undefined;
                                  const params: any = {};
                                  if (isMaterial) {
                                    const baseMaterial = item.materialId;
                                    if (baseMaterial != null) {
                                      params.materialId = baseMaterial;
                                    } else if (item.stockId != null) {
                                      params.stockId = item.stockId;
                                    }
                                  } else {
                                    if (item.materialId != null) {
                                      params.resourceMaterialId = item.materialId;
                                    } else if (item.resourceId != null) {
                                      params.resourceId = item.resourceId;
                                    }
                                  }

                                  const hasParams = params && Object.keys(params).length > 0;

                                  const templateResourceId = item.materialId ? getTemplateResourceIdByMaterial(item.materialId, item.categoryId) : (item.resourceId || null);

                                  const dynamicEndpoint = {
                                    baseUrl: FASHION_API_URL,
                                    listPath: '/colors',
                                    createPath: '/colors',
                                    deletePath: '/colors',
                                    searchParam: 'search',
                                    additionalParams: hasParams ? params : undefined,
                                  };

                                  let currentColorId: number | null = null;
                                  if (existing?.itemColorId) currentColorId = existing.itemColorId;

                                  const getColorObj = (id: number) => {
                                    const varMatch = allItemColors.find(ai => ai.id === id) ||
                                      allCollectionColors.find(ac => ac.id === id);
                                    const matchConjunto = familyConjuntos.find(c => c.colorId === id);
                                    const matchTrim = familyTrimInsumoOptions.find(tr => tr.colorId === id);
                                    const variation = allVariations?.find(v => v.colorId === id || v.id === id);
                                    const hex = varMatch?.hex || (varMatch as any)?.colorHex || varMatch?.Pantone?.hex || varMatch?.pantone?.hex || matchConjunto?.colorHex || matchTrim?.colorHex || variation?.color?.Pantone?.hex || variation?.color?.hex;
                                    const pantone = varMatch?.pantone || varMatch?.Pantone || matchConjunto?.colorPantone || matchTrim?.colorPantone || variation?.color?.Pantone;
                                    if (varMatch) return { ...varMatch, hex: hex || undefined, colorHex: hex || undefined, pantone, Pantone: pantone };
                                    if (matchConjunto) return { id, name: matchConjunto.colorName, hex: hex || undefined, colorHex: hex || undefined, pantone, Pantone: pantone };
                                    if (matchTrim) return { id, name: matchTrim.colorName, hex: hex || undefined, colorHex: hex || undefined, pantone, Pantone: pantone };
                                    if (item.resourceItemColorId === id && item.resourceItemColorName) return { id, name: item.resourceItemColorName, hex: hex || undefined, colorHex: hex || undefined };
                                    if (variation) return { id, name: variation.color?.name || `Cor ${id}`, hex: hex || undefined, colorHex: hex || undefined, pantone, Pantone: pantone };
                                    return { id, name: `Cor ${id}`, hex: hex || undefined, colorHex: hex || undefined };
                                  };

                                  const getColorName = (id: number) => {
                                    return getColorObj(id).name || `Cor ${id}`;
                                  };

                                  const handleCreateColor = async (name: string) => {
                                    const token = localStorage.getItem('token');
                                    const headers = token ? { Authorization: `Bearer ${token}` } : {};
                                    const createRes = await axios.post(`${FASHION_API_URL}/colors`, { name }, { headers });
                                    const newColor = createRes.data;
                                    let newStockId: number | undefined;
                                    let newResourceId: number | undefined;

                                    if (isMaterial && item.materialId) {
                                      try {
                                        const resp = await axios.post(
                                          `${FASHION_API_URL}/materials/${item.materialId}/stock-colors`,
                                          { colorId: newColor.id, collectionId: currentCollectionId },
                                          { headers }
                                        );
                                        newStockId = resp.data?.stockId;
                                      } catch (err) {
                                        console.error('erro ao associar cor a estoque/material', err);
                                      }
                                    }

                                    if (!isMaterial && (item.materialId || item.resourceId)) {
                                      try {
                                        const templateResourceId = getTemplateResourceIdByMaterial(item.materialId, item.categoryId) || item.resourceId;
                                        if (templateResourceId) {
                                          const resp = await axios.post(
                                            `${FASHION_API_URL}/resources/${templateResourceId}/resource-colors`,
                                            { colorId: newColor.id, collectionId: currentCollectionId },
                                            { headers }
                                          );
                                          newResourceId = resp.data?.resourceId ?? templateResourceId;
                                        }
                                      } catch (err) {
                                        console.error('erro ao associar cor a recurso/insumo', err);
                                      }
                                    }

                                    setCompositionItems(prev => prev.map(it => {
                                      if (it.id !== item.id) return it;
                                      const updated: ProductItemColorEntry[] = (it.productItemColors || [])
                                        .filter(p => p.collectionColorId !== col.id);
                                      const entry: ProductItemColorEntry = {
                                        collectionColorId: col.id,
                                        itemColorId: newColor.id,
                                        itemColorName: newColor.name,
                                        ...(newStockId ? { stockId: newStockId } : {}),
                                        ...(newResourceId ? { resourceId: newResourceId } : {}),
                                      };
                                      updated.push(entry);
                                      return { ...it, productItemColors: updated };
                                    }));

                                    setAllItemColors((prev) => {
                                      const exists = prev.some((c) => String(c.id) === String(newColor.id));
                                      if (!exists) {
                                        return [
                                          ...prev,
                                          {
                                            id: newColor.id,
                                            name: newColor.name,
                                            hex: newColor.hex || newColor.Pantone?.hex,
                                            pantone: newColor.Pantone,
                                          },
                                        ];
                                      }
                                      return prev;
                                    });

                                    return { ...newColor, newStockId, newResourceId };
                                  };

                                  const templateResourceIdOrCategory = !isMaterial && item.materialId
                                    ? (getTemplateResourceIdByMaterial(item.materialId, item.categoryId) || item.categoryId)
                                    : null;

                                  if (!isMaterial && !item.resourceId && !templateResourceIdOrCategory) {
                                    return (
                                      <TableCell
                                        key={`color-cell-${col.id}`}
                                        style={getColorColumnStyle(col.id)}
                                      >
                                        <TableSelect disabled value=''>
                                          <option value=''>Selecione material</option>
                                        </TableSelect>
                                      </TableCell>
                                    );
                                  } else {
                                    return (
                                      <TableCell
                                        key={`color-cell-${col.id}`}
                                        style={getColorColumnStyle(col.id)}
                                      >
                                        <SelectContainer $flush>
                                          <InfiniteSelect
                                            triggerVariant='cell'
                                            key={`${col.id}-${JSON.stringify(params)}`}
                                            placeholder='Selecione cor do item'
                                            mode='crud'
                                            showSelectedBelow={false}
                                            endpointConfig={dynamicEndpoint}
                                            disabled={!hasParams}
                                            initialOptions={(() => {
                                              const availableColors: { id: number; name: string; hex?: string; pantone?: any }[] = []
                                              if (item.tipo === 'materia-prima') {
                                                const matchingConjuntos = familyConjuntos.filter((c) => {
                                                  if (item.materialId && c.materialId === item.materialId) return true
                                                  if (item.stockId && c.stockId === item.stockId) return true
                                                  return false
                                                })
                                                matchingConjuntos.forEach((c) => {
                                                  if (c.colorId && c.colorName && !availableColors.some((x) => x.id === c.colorId)) {
                                                    availableColors.push({
                                                      id: c.colorId,
                                                      name: c.colorName,
                                                      hex: c.colorHex || undefined,
                                                      pantone: c.colorPantone || undefined,
                                                    })
                                                  }
                                                })
                                                const matchingStocks = allStocks.filter((s) => {
                                                  if (item.materialId && Number(s.materialId) === Number(item.materialId)) return true
                                                  if (item.stockId && Number(s.id) === Number(item.stockId)) return true
                                                  return false
                                                })
                                                matchingStocks.forEach((s) => {
                                                  const colorId = s.itemColorId || s.ItemColor?.id
                                                  const colorName = s.ItemColor?.name || s.color
                                                  if (colorId && colorName && !availableColors.some((x) => x.id === colorId)) {
                                                    availableColors.push({
                                                      id: colorId,
                                                      name: colorName,
                                                      hex: s.colorHex || s.ItemColor?.hex || s.ItemColor?.Pantone?.hex || undefined,
                                                      pantone: s.pantone || s.ItemColor?.Pantone || undefined,
                                                    })
                                                  }
                                                })
                                              } else if (item.tipo === 'insumo') {
                                                 const baseResource = item.resourceId
                                                   ? allResources.find((r) => r.id === item.resourceId)
                                                   : null
                                                 const baseTrim = item.resourceId
                                                   ? familyTrimInsumoOptions.find((tr) => tr.resourceId === item.resourceId)
                                                   : null
                                                 const resolvedMaterialId = item.materialId || baseResource?.materialId || baseTrim?.materialId || null
                                                 const baseName = (baseResource?.name || baseTrim?.materialName || item.descricao || '').trim().toLowerCase()

                                                 if (resolvedMaterialId) {
                                                   const matchingTrims = familyTrimInsumoOptions.filter((tr) => tr.materialId === resolvedMaterialId)
                                                   matchingTrims.forEach((tr) => {
                                                     if (tr.colorId && tr.colorName && !availableColors.some((x) => x.id === tr.colorId)) {
                                                       availableColors.push({
                                                         id: tr.colorId,
                                                         name: tr.colorName,
                                                         hex: tr.colorHex || undefined,
                                                         pantone: tr.colorPantone || undefined,
                                                       })
                                                     }
                                                   })
                                                   const matchingResources = allResources.filter((r) => Number(r.materialId) === Number(resolvedMaterialId))
                                                   matchingResources.forEach((r) => {
                                                     const colorId = (r as any).itemColorId || (r as any).ItemColor?.id
                                                     const colorName = (r as any).ItemColor?.name || (r as any).color
                                                     if (colorId && colorName && !availableColors.some((x) => x.id === colorId)) {
                                                       availableColors.push({
                                                         id: colorId,
                                                         name: colorName,
                                                         hex: (r as any).ItemColor?.hex || (r as any).ItemColor?.Pantone?.hex || undefined,
                                                         pantone: (r as any).ItemColor?.Pantone || undefined,
                                                       })
                                                     }
                                                   })
                                                 } else if (item.resourceId) {
                                                   const matchingTrims = familyTrimInsumoOptions.filter((tr) => {
                                                     if (tr.resourceId === item.resourceId) return true
                                                     const trName = (tr.materialName || tr.resourceName || '').trim().toLowerCase()
                                                     const isSameName = baseName && (trName === baseName || trName.includes(baseName) || baseName.includes(trName))
                                                     const isSameCategory = item.categoryId ? tr.categoryId === item.categoryId : true
                                                     return isSameName && isSameCategory
                                                   })
                                                   matchingTrims.forEach((tr) => {
                                                     if (tr.colorId && tr.colorName && !availableColors.some((x) => x.id === tr.colorId)) {
                                                       availableColors.push({
                                                         id: tr.colorId,
                                                         name: tr.colorName,
                                                         hex: tr.colorHex || undefined,
                                                         pantone: tr.colorPantone || undefined,
                                                       })
                                                     }
                                                   })
                                                   const matchingResources = allResources.filter((r) => {
                                                     if (Number(r.id) === Number(item.resourceId)) return true
                                                     const rName = (r.name || '').trim().toLowerCase()
                                                     const isSameName = baseName && (rName === baseName || rName.includes(baseName) || baseName.includes(rName))
                                                     const isSameCategory = item.categoryId ? Number(r.categoryId) === Number(item.categoryId) : true
                                                     return isSameName && isSameCategory
                                                   })
                                                   matchingResources.forEach((r) => {
                                                     const colorId = (r as any).itemColorId || (r as any).ItemColor?.id
                                                     const colorName = (r as any).ItemColor?.name || (r as any).color
                                                     if (colorId && colorName && !availableColors.some((x) => x.id === colorId)) {
                                                       availableColors.push({
                                                         id: colorId,
                                                         name: colorName,
                                                         hex: (r as any).ItemColor?.hex || (r as any).ItemColor?.Pantone?.hex || undefined,
                                                         pantone: (r as any).ItemColor?.Pantone || undefined,
                                                       })
                                                     }
                                                   })
                                                 }
                                               }
                                              return currentColorId
                                                ? [getColorObj(currentColorId), ...availableColors.filter((c) => c.id !== currentColorId)]
                                                : availableColors
                                            })()}
                                            value={currentColorId ? getColorObj(currentColorId) : null}
                                            onItemCreate={item.materialId ? ((name: string) => handleOpenCreateColorModal(name, item, col)) : undefined}
                                            onItemDelete={async (deletedColorId: number) => {
                                              const token = localStorage.getItem('token');
                                              const headers = token ? { Authorization: `Bearer ${token}` } : {};
                                              const queryParams = new URLSearchParams();
                                              if (currentCollectionId) queryParams.set('collectionId', String(currentCollectionId));
                                              if (item.materialId) queryParams.set('materialId', String(item.materialId));

                                              let targetStockId: number | undefined;
                                              if (item.tipo === 'materia-prima') {
                                                const matchedConjunto = familyConjuntos.find((c) => {
                                                  const matchMat = item.materialId ? c.materialId === item.materialId : (item.stockId ? c.stockId === item.stockId : false);
                                                  return matchMat && Number(c.colorId) === Number(deletedColorId);
                                                });
                                                targetStockId = matchedConjunto?.stockId ?? undefined;
                                              }

                                              let targetResourceId: number | undefined;
                                              if (item.tipo === 'insumo') {
                                                const baseResource = item.resourceId ? allResources.find((r) => r.id === item.resourceId) : null;
                                                const baseTrim = item.resourceId ? familyTrimInsumoOptions.find((tr) => tr.resourceId === item.resourceId) : null;
                                                const resolvedMaterialId = item.materialId || baseResource?.materialId || baseTrim?.materialId || null;
                                                const baseName = (baseResource?.name || baseTrim?.materialName || item.descricao || '').trim().toLowerCase();

                                                const matchedTrim = familyTrimInsumoOptions.find((tr) => {
                                                  if (resolvedMaterialId) {
                                                    return tr.materialId === resolvedMaterialId && Number(tr.colorId) === Number(deletedColorId);
                                                  }
                                                  if (item.resourceId) {
                                                    if (tr.resourceId === item.resourceId && Number(tr.colorId) === Number(deletedColorId)) return true;
                                                    const trName = (tr.materialName || tr.resourceName || '').trim().toLowerCase();
                                                    const isSameName = baseName && (trName === baseName || trName.includes(baseName) || baseName.includes(trName));
                                                    const isSameCategory = item.categoryId ? tr.categoryId === item.categoryId : true;
                                                    return isSameName && isSameCategory && Number(tr.colorId) === Number(deletedColorId);
                                                  }
                                                  return false;
                                                });
                                                targetResourceId = matchedTrim?.resourceId ?? undefined;
                                              }

                                              if (targetStockId) queryParams.set('stockId', String(targetStockId));
                                              if (targetResourceId) queryParams.set('resourceId', String(targetResourceId));

                                              const url = `${FASHION_API_URL}/colors/${deletedColorId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
                                              await axios.delete(url, { headers });

                                              setFamilyConjuntos(prev => prev.filter(c => {
                                                if (Number(c.colorId) === Number(deletedColorId)) {
                                                  if (item.materialId && c.materialId === item.materialId) return false;
                                                  if (targetStockId && c.stockId === targetStockId) return false;
                                                  return true;
                                                }
                                                return true;
                                              }));

                                              setFamilyTrimInsumoOptions(prev => prev.filter(tr => {
                                                if (Number(tr.colorId) === Number(deletedColorId)) {
                                                  if (item.materialId && tr.materialId === item.materialId) return false;
                                                  if (targetResourceId && tr.resourceId === targetResourceId) return false;
                                                  return true;
                                                }
                                                return true;
                                              }));

                                              setCompositionItems(prev => prev.map(it => {
                                                const isSameScope = item.materialId ? it.materialId === item.materialId : it.id === item.id;
                                                if (!isSameScope) return it;
                                                const updated = (it.productItemColors || []).map(p => {
                                                  if (String(p.itemColorId) === String(deletedColorId)) {
                                                    return { ...p, itemColorId: null, itemColorName: null, stockId: null, resourceId: null };
                                                  }
                                                  return p;
                                                });
                                                return { ...it, productItemColors: updated };
                                              }));

                                              setAllItemColors(prev => prev.filter(c => Number(c.id) !== Number(deletedColorId)));
                                            }}
                                            dropdownForceFixed={true}
                                            dropdownZIndex={2147483600 + index * 10}
                                            onSelect={async (option: any) => {
                                              const token = localStorage.getItem('token');
                                              const currentCollectionId = formData.collectionId ? Number(formData.collectionId) : (productData as any)?.collectionId ? Number((productData as any).collectionId) : undefined;

                                              if (option && option.id != null && option.name) {
                                                setAllItemColors(prev => {
                                                  const exists = prev.some(c => String(c.id) === String(option.id));
                                                  const optHex = option.hex || option.Pantone?.hex || option.pantone?.hex;
                                                  const optPantone = option.Pantone || option.pantone;
                                                  if (!exists) {
                                                    return [...prev, {
                                                      id: option.id,
                                                      name: option.name,
                                                      hex: optHex,
                                                      colorHex: optHex,
                                                      pantone: optPantone,
                                                      Pantone: optPantone,
                                                    }];
                                                  }
                                                  return prev.map(c => String(c.id) === String(option.id) ? {
                                                    ...c,
                                                    hex: c.hex || optHex,
                                                    colorHex: (c as any).colorHex || optHex,
                                                    pantone: c.pantone || optPantone,
                                                    Pantone: (c as any).Pantone || optPantone,
                                                  } : c);
                                                });
                                              }
                                              const colorVal = option ? Number(option.id) : null;
                                              let stockColorVal: number | undefined;
                                              let entryResourceId: number | undefined;

                                              if (colorVal != null) {
                                                 if (item.tipo === 'materia-prima') {
                                                   const baseStock = item.stockId ? allStocks.find((s) => Number(s.id) === Number(item.stockId)) : null;
                                                   const baseConjunto = item.stockId ? familyConjuntos.find((c) => c.stockId === item.stockId) : null;
                                                   const resolvedMatId = item.materialId || baseStock?.materialId || baseConjunto?.materialId || null;

                                                   if (resolvedMatId) {
                                                     const matchedConjunto = familyConjuntos.find((c) => {
                                                       return c.materialId === resolvedMatId && Number(c.colorId) === Number(colorVal);
                                                     });
                                                     if (matchedConjunto?.stockId) {
                                                       stockColorVal = matchedConjunto.stockId;
                                                     } else {
                                                       const matchedStock = allStocks.find((s) => {
                                                         const sColorId = s.itemColorId || s.ItemColor?.id;
                                                         return Number(s.materialId) === Number(resolvedMatId) && Number(sColorId) === Number(colorVal);
                                                       });
                                                       if (matchedStock?.id) {
                                                         stockColorVal = matchedStock.id;
                                                       }
                                                     }
                                                   } else if (item.stockId) {
                                                     const baseColorId = baseStock?.itemColorId || baseStock?.ItemColor?.id || baseConjunto?.colorId;
                                                     if (baseColorId && Number(baseColorId) === Number(colorVal)) {
                                                       stockColorVal = item.stockId;
                                                     }
                                                   }
                                                 } else if (item.tipo === 'insumo') {
                                                   const baseResource = item.resourceId
                                                     ? allResources.find((r) => r.id === item.resourceId)
                                                     : null;
                                                   const baseTrim = item.resourceId
                                                     ? familyTrimInsumoOptions.find((tr) => tr.resourceId === item.resourceId)
                                                     : null;
                                                   const resolvedMaterialId = item.materialId || baseResource?.materialId || baseTrim?.materialId || null;
                                                   const baseName = (baseResource?.name || baseTrim?.materialName || item.descricao || '').trim().toLowerCase();

                                                   if (resolvedMaterialId) {
                                                     const matchedTrim = familyTrimInsumoOptions.find((tr) => {
                                                       return tr.materialId === resolvedMaterialId && Number(tr.colorId) === Number(colorVal);
                                                     });
                                                     if (matchedTrim?.resourceId) {
                                                       entryResourceId = matchedTrim.resourceId;
                                                     } else {
                                                       const matchedRes = allResources.find((r) => {
                                                         const rColorId = (r as any).itemColorId || (r as any).ItemColor?.id;
                                                         return Number(r.materialId) === Number(resolvedMaterialId) && Number(rColorId) === Number(colorVal);
                                                       });
                                                       if (matchedRes?.id) {
                                                         entryResourceId = matchedRes.id;
                                                       }
                                                     }
                                                   } else if (item.resourceId) {
                                                     const baseColorId = (baseResource as any)?.itemColorId || (baseResource as any)?.ItemColor?.id || baseTrim?.colorId;
                                                     if (baseColorId && Number(baseColorId) === Number(colorVal)) {
                                                       entryResourceId = item.resourceId;
                                                     } else {
                                                       const matchedTrim = familyTrimInsumoOptions.find((tr) => {
                                                         const trName = (tr.materialName || tr.resourceName || '').trim().toLowerCase();
                                                         const isSameName = baseName && (trName === baseName || trName.includes(baseName) || baseName.includes(trName));
                                                         const isSameCategory = item.categoryId ? tr.categoryId === item.categoryId : true;
                                                         return isSameName && isSameCategory && Number(tr.colorId) === Number(colorVal);
                                                       });
                                                       if (matchedTrim?.resourceId) {
                                                         entryResourceId = matchedTrim.resourceId;
                                                       } else {
                                                         const matchedRes = allResources.find((r) => {
                                                           const rName = (r.name || '').trim().toLowerCase();
                                                           const isSameName = baseName && (rName === baseName || rName.includes(baseName) || baseName.includes(rName));
                                                           const isSameCategory = item.categoryId ? Number(r.categoryId) === Number(item.categoryId) : true;
                                                           const rColorId = (r as any).itemColorId || (r as any).ItemColor?.id;
                                                           return isSameName && isSameCategory && Number(rColorId) === Number(colorVal);
                                                         });
                                                         if (matchedRes?.id) {
                                                           entryResourceId = matchedRes.id;
                                                         }
                                                       }
                                                     }
                                                   }
                                                 }
                                               }

                                               if (colorVal != null && !stockColorVal && !entryResourceId && (item.materialId || item.stockId || item.resourceId)) {
                                                 try {
                                                   if (isMaterial && (item.materialId || item.stockId)) {
                                                     const resp = await axios.post(
                                                       `${FASHION_API_URL}/materials/${item.materialId}/stock-colors`,
                                                       {
                                                         colorId: colorVal,
                                                         collectionId: currentCollectionId,
                                                         stockId: item.stockId || undefined,
                                                       },
                                                       { headers: token ? { Authorization: `Bearer ${token}` } : {} }
                                                     );
                                                     stockColorVal = resp.data?.stockId;
                                                     if (!stockColorVal) {
                                                       const list = await fetchStockColors(item.stockId || undefined, item.materialId || undefined);
                                                       const match = list.find((v: any) => v.colorId === colorVal || v.id === colorVal);
                                                       if (match) stockColorVal = match.stockId || match.id;
                                                     }
                                                   } else if (templateResourceId || item.resourceId) {
                                                     try {
                                                       const resId = item.resourceId || templateResourceId;
                                                       const resp = await axios.post(
                                                         `${FASHION_API_URL}/resources/${resId}/resource-colors`,
                                                         { colorId: colorVal, collectionId: currentCollectionId },
                                                         { headers: token ? { Authorization: `Bearer ${token}` } : {} }
                                                       );
                                                       entryResourceId = resp.data?.resourceId;
                                                       if (entryResourceId) {
                                                         const baseTrim = familyTrimInsumoOptions.find((tr) => tr.resourceId === resId);
                                                         const baseRes = allResources.find((r) => r.id === resId);
                                                         const newTrimOpt: FamilyTrimInsumoOption = {
                                                           familyMaterialId: baseTrim?.familyMaterialId ?? item.id,
                                                           collectionMaterialId: baseTrim?.collectionMaterialId ?? item.id,
                                                           resourceId: entryResourceId,
                                                           resourceName: baseTrim?.resourceName || (baseRes?.name ? String(baseRes.name) : '') || item.descricao,
                                                           materialId: item.materialId || baseTrim?.materialId || baseRes?.materialId || 0,
                                                           materialName: baseTrim?.materialName || (baseRes as any)?.Material?.name || item.descricao || 'Insumo',
                                                           categoryId: item.categoryId || baseTrim?.categoryId || baseRes?.categoryId || null,
                                                           categoryName: baseTrim?.categoryName || null,
                                                           finishing: item.finishing || baseTrim?.finishing,
                                                           colorId: colorVal,
                                                           colorName: option?.name || getColorName(colorVal),
                                                           colorHex: option?.hex || option?.Pantone?.hex,
                                                           colorPantone: option?.Pantone || option?.pantone,
                                                         };
                                                         setFamilyTrimInsumoOptions((prev) => {
                                                           if (!prev.some((tr) => tr.resourceId === entryResourceId)) {
                                                             return [...prev, newTrimOpt];
                                                           }
                                                           return prev;
                                                         });
                                                       }
                                                     } catch (err) {
                                                       console.error('erro ao criar recurso para cor do insumo', err);
                                                     }
                                                   }
                                                 } catch (e) {
                                                   console.error('erro ao determinar stockColorId para cor selecionada', e);
                                                 }
                                               }

                                              setCompositionItems(prev => prev.map(it => {
                                                if (it.id !== item.id) return it;
                                                const updated: ProductItemColorEntry[] = (it.productItemColors || [])
                                                  .filter(p => p.collectionColorId !== col.id);
                                                if (colorVal !== null) {
                                                  const entry: ProductItemColorEntry = {
                                                    collectionColorId: col.id,
                                                    itemColorId: colorVal,
                                                    itemColorName: option?.name || getColorName(colorVal),
                                                    ...(stockColorVal ? { stockId: stockColorVal } : {}),
                                                    ...(entryResourceId ? { resourceId: entryResourceId } : {}),
                                                    ...(item.materialId ? { materialId: item.materialId } : {}),
                                                  };
                                                  updated.push(entry);
                                                }
                                                let nextStockId = it.stockId;
                                                let nextResourceId = it.resourceId;
                                                let nextDescricao = it.descricao;

                                                const activeStocks = Array.from(new Set(updated.map((p) => p.stockId).filter((s): s is number => typeof s === 'number' && s > 0)));
                                                const activeResources = Array.from(new Set(updated.map((p) => p.resourceId).filter((r): r is number => typeof r === 'number' && r > 0)));

                                                if (it.tipo === 'materia-prima') {
                                                  const targetStock = activeStocks.length === 1 ? activeStocks[0] : (stockColorVal || null);
                                                  if (targetStock) {
                                                    nextStockId = targetStock;
                                                    const matchedConjunto = familyConjuntos.find((c) => Number(c.stockId) === Number(targetStock));
                                                    const matchedStock = allStocks.find((s) => Number(s.id) === Number(targetStock));
                                                    if (matchedConjunto?.stockLabel) {
                                                      nextDescricao = matchedConjunto.stockLabel;
                                                    } else if (matchedStock) {
                                                      const rawStockCode = matchedStock?.Code?.code != null && String(matchedStock.Code.code).trim() !== ''
                                                        ? String(matchedStock.Code.code)
                                                        : matchedStock?.code != null && String(matchedStock.code).trim() !== ''
                                                          ? String(matchedStock.code)
                                                          : matchedStock?.codeId
                                                            ? String(matchedStock.codeId)
                                                            : '';
                                                      const stockCode = sanitizeCode(rawStockCode);
                                                      const stockMaterialName = (matchedStock?.Material?.name || matchedStock?.material || '').trim();
                                                      const colorName = (matchedStock?.ItemColor?.name || matchedStock?.color || '').trim();
                                                      const parts: string[] = [];
                                                      if (stockCode) parts.push(stockCode);
                                                      if (stockMaterialName) parts.push(stockMaterialName);
                                                      if (colorName && colorName !== '—') parts.push(colorName);
                                                      nextDescricao = parts.length > 0 ? parts.join(' - ') : (stockMaterialName || matchedStock?.description || `Tecido #${matchedStock.id}`);
                                                    }
                                                  }
                                                } else if (it.tipo === 'insumo') {
                                                  const targetResource = activeResources.length === 1 ? activeResources[0] : (entryResourceId || null);
                                                  if (targetResource) {
                                                    nextResourceId = targetResource;
                                                    const matchTrim = familyTrimInsumoOptions.find((tr) => Number(tr.resourceId) === Number(targetResource));
                                                    const matchResource = allResources.find((r) => Number(r.id) === Number(targetResource));
                                                    nextDescricao = matchTrim?.resourceName || matchTrim?.materialName || (matchResource ? String(matchResource.name || '') : it.descricao);
                                                  }
                                                }

                                                return {
                                                  ...it,
                                                  stockId: nextStockId,
                                                  resourceId: nextResourceId,
                                                  descricao: nextDescricao,
                                                  productItemColors: updated,
                                                };
                                              }));
                                            }}

                                            getOptionLabel={(opt: any) => opt.name
                                              || (allItemColors.find(ai => String(ai.id) === String(opt.id))?.name)
                                              || (allCollectionColors.find(ac => String(ac.id) === String(opt.id))?.name)
                                              || `Cor ${opt.id}`}
                                          />
                                        </SelectContainer>
                                      </TableCell>
                                    );
                                  }
                                })}

                                <TableCell $col='actions'>
                                  <DeleteButton type='button' onClick={() => removeCompositionItem(item.id)}>
                                    <img src={trash} alt='Excluir' />
                                  </DeleteButton>
                                </TableCell>
                              </CompositionTableRow>
                            );
                          })}
                        </CompositionTable>
                      </CompositionTableWrapper>


                    </>
                  )}

                  <AddItemButton type='button' onClick={addCompositionItem}>
                    <img src={plus} alt='Adicionar' />
                    Adicionar item
                  </AddItemButton>
                </>}
              </StyledCard>

              <Beneficiamento
                title="Anotações"
                notes={beneficiamentoNotes}
                onChange={(notes) => {
                  setBeneficiamentoNotes(notes)
                }}
                sectors={sectors}
                isOpen={isBeneficiamentoOpen}
                onToggle={() => setIsBeneficiamentoOpen(prev => !prev)}
                onSave={handleSaveNotes}
                onCancel={handleCancelNotes}
                isSaving={savingNotes}
              />
              {!isShowroomProduct && (
                <Aprovations
                  productId={isEditMode ? Number(productId) : undefined}
                  productCode={formData.codigo}
                />
              )}
              <Measures
                ref={measuresRef}
                productId={Number(productId)}
                groupId={formData.groupId}
                selectedGrades={selectedGradeIds
                  .map((id: number) => Object.values(gradesByType).flat().find((g) => g.id === id))
                  .filter(Boolean) as { id: number; name: string }[]}
              />
            </FormColumn>
            <AsideColumn>
              <ProductAttachmentsAside
                selectedFiles={productSelectedFiles}
                existingAttachments={productExistingAttachments}
                onFileChange={handleProductAttachmentChange}
                onRemoveFile={handleProductAttachmentRemove}
                onViewAttachment={handleViewProductExistingAttachment}
                onDownloadAttachment={handleDownloadProductExistingAttachment}
                onRemoveExistingAttachment={handleProductExistingAttachmentRemove}
                onSetCoverAttachment={handleSetProductAttachmentCover}
                onRemoveCoverAttachment={handleRemoveProductAttachmentCover}
                onSelectFromGallery={handleProductSelectFromGallery}
                formatFileSize={(bytes) => `${(bytes / 1024).toFixed(1)} KB`}
                isOpen={isAttachmentsAsideOpen}
                onToggleOpen={(next) => setIsAttachmentsAsideOpen(next)}
              />
            </AsideColumn>
          </PageGrid>
        </form>
      </MainContainer>
      {isPdfModalOpen && (
        <GeneratePDFModal
          onClickClose={() => setIsPdfModalOpen(false)}
          productData={productData}
          gradesByType={gradesByType}
          gradeTypes={gradeTypes}
          coverImageUrl={
            (productExistingAttachments.find(a => a.isCover) as any)?.previewUrl ||
            productExistingAttachments.find(a => a.isCover)?.fileUrl ||
            productExistingAttachments.find(a => a.isCover)?.filePath ||
            (productExistingAttachments.find(a => a.isImage) as any)?.previewUrl ||
            productExistingAttachments.find(a => a.isImage)?.fileUrl ||
            productExistingAttachments.find(a => a.isImage)?.filePath ||
            productData?.CoverGeneralFile?.fileUrl || null
          }
          attachmentImageUrls={productExistingAttachments
            .filter((attachment) => {
              const mimeType = String(attachment.mimeType || '').toLowerCase()
              const fileReference = String(
                attachment.originalName || attachment.fileName || attachment.fileUrl || attachment.filePath || '',
              ).toLowerCase()
              return (
                attachment.isImage === true ||
                mimeType.startsWith('image/') ||
                /\.(png|jpe?g|gif|bmp|webp|svg|avif|heic|heif|jfif)$/i.test(fileReference)
              )
            })
            .sort((a, b) => Number(Boolean(b.isCover)) - Number(Boolean(a.isCover)))
            .map((attachment) => (attachment as any).previewUrl || attachment.fileUrl || attachment.filePath)
            .filter(Boolean) as string[]}
          coverScale={
            productExistingAttachments.find(a => a.isCover)?.coverScale ??
            (productData as any)?.coverScale ??
            (productData as any)?.coverImageScale ??
            null
          }
          coverPosX={
            productExistingAttachments.find(a => a.isCover)?.coverPosX ??
            (productData as any)?.coverPosX ??
            (productData as any)?.coverImagePosX ??
            null
          }
          coverPosY={
            productExistingAttachments.find(a => a.isCover)?.coverPosY ??
            (productData as any)?.coverPosY ??
            (productData as any)?.coverImagePosY ??
            null
          }
          compositionItems={compositionItems}
          liveObservations={formData.observations}
          liveAnotacoes={beneficiamentoNotes.map(n => ({
            ...n,
            sectorName: sectors.find(s => s.id === n.sectorId)?.name || (n as any).Sector?.name || (n as any).sectorName || '',
          }))}
          liveCores={selectedCollectionColors}
          liveMedidas={selectedGradeIds}
          extraData={{
            price: formData.price,
            collectionName: allCollections.find(c => c.id === formData.collectionId)?.name || 'Nenhuma',
            familyName: filteredFamilies.find(f => f.id === formData.familyId)?.name || 'Indefinida',
            groupName: filteredGroups.find(g => g.id === formData.groupId)?.name || 'Nenhum',
            episodeName: collectionEpisodes.find(e => e.id === formData.episodeId)?.name || 'Nenhum',
            gradeTypeName: gradeTypes.find(t => t.id === Number(selectedGradeType))?.name || 'Indefinido',
            supplierCode: formData.supplierCode || 'Não informado',
            clientIdentification: formData.clientIdentification || 'Não informado'
          }}
        />
      )}

      <ConfirmationModal
        isOpen={showUnsavedModal}
        title='Alterações não salvas'
        message='Você possui alterações não salvas no produto. Deseja salvar antes de sair ou descartar as alterações?'
        actions={[
          {
            label: 'Descartar alterações',
            variant: 'danger-outline',
            onClick: handleDiscardFromModal,
          },
          {
            label: 'Continuar editando',
            variant: 'outline',
            onClick: handleStayFromModal,
          },
          {
            label: 'Salvar alterações',
            variant: 'primary',
            onClick: handleSaveFromModal,
          },
        ]}
      />

      {createColorModalState?.isOpen && (
        <ModalTest>
          <ContainerOfModal width='580px'>
            <ModalHeader style={{ marginBottom: '24px' }}>
              <ModalHeaderTitle>Cadastrar Nova Cor</ModalHeaderTitle>
              <ModalCloseDiv onClick={handleCancelCreateColorModal}>
                <X size={20} />
              </ModalCloseDiv>
            </ModalHeader>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {createColorModalState.errorMessage && (
                <div style={{ padding: '8px 12px', background: '#fee2e2', color: '#b91c1c', borderRadius: 8, fontSize: 13, fontWeight: 500 }}>
                  {createColorModalState.errorMessage}
                </div>
              )}
              <ModalInputDiv>
                <ModalLabel>
                  Cor <span style={{ color: 'red', marginLeft: 2 }}>*</span>
                </ModalLabel>
                <InfiniteSelect
                  mode="crud"
                  value={createColorModalState.selectedColor}
                  onSelect={(option) => {
                    setCreateColorModalState(prev => prev ? {
                      ...prev,
                      selectedColor: option,
                      name: option?.name || '',
                      pantone: option?.pantone ?? null,
                      errorMessage: undefined,
                    } : null)
                  }}
                  fetchFunction={async (limit, offset, search?) => {
                    const response = await ApiService.resources.getColors()
                    const items = response.data || []
                    const filtered = search
                      ? items.filter((c: any) => c.name?.toLowerCase().includes(search.toLowerCase()))
                      : items
                    const result = filtered.map((c: any) => ({ id: c.id, name: c.name, pantone: c.pantone ?? null }))
                    ;(result as any)._consumedCount = 0
                    if (offset > 0) return []
                    return result
                  }}
                  onItemCreate={async (createdName: string) => {
                    const tempItem = { id: `tmp-${Date.now() as any}`, name: createdName.trim(), pantone: null }
                    setCreateColorModalState(prev => prev ? {
                      ...prev,
                      selectedColor: tempItem,
                      name: tempItem.name,
                      pantone: null,
                      errorMessage: undefined,
                    } : null)
                    return tempItem as any
                  }}
                  onItemDelete={async (colorId: any) => {
                    const isTemp = typeof colorId === 'string' && String(colorId).startsWith('tmp-')
                    if (!isTemp) {
                      await ApiService.resources.deleteColor(colorId)
                    }
                    setCreateColorModalState(prev => prev && prev.selectedColor?.id === colorId ? {
                      ...prev,
                      selectedColor: null,
                      name: '',
                      pantone: null,
                    } : prev)
                  }}
                  placeholder="Buscar ou criar cor"
                  allowCreate={true}
                  allowDelete={true}
                  showCreateOnlyIfNotExists={true}
                  minCreateLength={2}
                />
              </ModalInputDiv>

              {createColorModalState.selectedColor && (!createColorModalState.selectedColor.pantone?.code || createColorModalState.isChangingPantone) && (
                <ModalInputDiv style={{ padding: 10, backgroundColor: '#f0f7ff', borderRadius: 8, border: '1px solid #bfdbfe' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                    <ModalLabel style={{ fontSize: 11, color: '#374151', fontWeight: 500 }}>
                      {createColorModalState.isChangingPantone ? 'Alterar Pantone para ' : 'Pantone para '}<strong>{createColorModalState.selectedColor.name}</strong> <span style={{ color: '#e53e3e' }}>*</span>
                    </ModalLabel>
                    {createColorModalState.isChangingPantone && (
                      <button
                        type="button"
                        onClick={() => setCreateColorModalState(prev => prev ? { ...prev, isChangingPantone: false } : null)}
                        style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 11, textDecoration: 'underline' }}
                      >
                        Cancelar
                      </button>
                    )}
                  </div>
                  <PantoneSelect
                    value={createColorModalState.pantone || createColorModalState.selectedColor.pantone}
                    onSelect={(p) => {
                      setCreateColorModalState(prev => {
                        if (!prev) return null
                        const updatedColor = prev.selectedColor ? { ...prev.selectedColor, pantone: p || null } : null
                        return {
                          ...prev,
                          selectedColor: updatedColor,
                          pantone: p || null,
                          isChangingPantone: false,
                          errorMessage: undefined,
                        }
                      })
                    }}
                    placeholder="Buscar Pantone (mín. 3 letras)"
                  />
                </ModalInputDiv>
              )}

              {createColorModalState.selectedColor?.pantone?.code && !createColorModalState.isChangingPantone && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: -4, fontSize: 12, color: '#555' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    {createColorModalState.selectedColor.pantone.hex && (
                      <span style={{
                        display: 'inline-block', width: 12, height: 12, borderRadius: 3,
                        backgroundColor: createColorModalState.selectedColor.pantone.hex.startsWith('#')
                          ? createColorModalState.selectedColor.pantone.hex
                          : `#${createColorModalState.selectedColor.pantone.hex}`,
                        border: '1px solid rgba(0,0,0,0.15)',
                      }} />
                    )}
                    <span>Pantone: <strong>{createColorModalState.selectedColor.pantone.code}</strong> - {createColorModalState.selectedColor.pantone.name}</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => setCreateColorModalState(prev => prev ? { ...prev, isChangingPantone: true } : null)}
                    style={{ background: 'none', border: 'none', color: '#0090D3', cursor: 'pointer', fontSize: 11, textDecoration: 'underline', fontWeight: 500 }}
                  >
                    Alterar Pantone
                  </button>
                </div>
              )}
              <ModalInputDiv>
                <ModalLabel>
                  Código <span style={{ color: 'red', marginLeft: 2 }}>*</span>
                </ModalLabel>
                <ModalInput
                  type='text'
                  value={createColorModalState.code}
                  onChange={(e) => {
                    const val = e.target.value
                    const isDuplicated = createColorModalState.existingCodes.some(
                      ec => ec.trim().toUpperCase() === val.trim().toUpperCase()
                    )
                    setCreateColorModalState(prev => prev ? {
                      ...prev,
                      code: val,
                      errorMessage: isDuplicated ? 'Este código já está cadastrado para este material.' : undefined
                    } : null)
                  }}
                  placeholder='Digite o código da matéria-prima'
                />
                {createColorModalState.existingCodes.length > 0 && (
                  <div style={{ marginTop: '8px', fontSize: '12px', color: '#6b7280' }}>
                    <span style={{ fontWeight: 500 }}>Códigos já cadastrados para este material:</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                      {createColorModalState.existingCodes.map((ec, idx) => (
                        <span
                          key={idx}
                          style={{
                            padding: '3px 8px',
                            borderRadius: '4px',
                            backgroundColor: '#f3f4f6',
                            border: '1px solid #e5e7eb',
                            color: '#374151',
                            fontSize: '12px',
                            fontFamily: 'monospace',
                          }}
                        >
                          {ec}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </ModalInputDiv>
            </div>
            <ModalButtonContainer style={{ marginTop: '24px' }}>
              <ModalButton
                type='button'
                className='cancel'
                onClick={handleCancelCreateColorModal}
                disabled={createColorModalState.isLoading}
              >
                Cancelar
              </ModalButton>
              <ModalButton
                type='button'
                onClick={handleConfirmCreateColorModal}
                disabled={createColorModalState.isLoading}
              >
                {createColorModalState.isLoading ? 'Salvando...' : 'Salvar e Vincular'}
              </ModalButton>
            </ModalButtonContainer>
          </ContainerOfModal>
        </ModalTest>
      )}
    </>
  )
}

export default RegisterComposition